!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.cognite = t() : e.cognite = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 124);
  }([function (e, t, n) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(13));
    t.THREE = i;
  }, function (e, t) {
    e.exports = require("@babel/runtime/regenerator");
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/asyncToGenerator");
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/classCallCheck");
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/createClass");
  }, function (e, t) {
    e.exports = require("@tweenjs/tween.js");
  }, function (e, t, n) {
    "use strict";

    var _r,
        i = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        o = n(11),
        s = function (e) {
      function t(t, n, r) {
        var i = e.call(this, t, n) || this;
        return i.cogniteType = "", i.isBillboard = !1, i.standardMaterial = n, i.hasBeenRendered = !1, i.sizes = r, i.sizesValid = o.isNonZeroAndSorted(r), i;
      }

      return i(t, e), t.prototype.dispose = function () {
        this.geometry.dispose();
      }, t.prototype.setBoundingBox = function (e) {
        this.boundingBox = e;
      }, t.prototype.getBoundingBox = function () {
        return this.boundingBox;
      }, t.prototype.setBiggestObjectSize = function (e) {
        this.biggestObjectSize = e;
      }, t.prototype.getBiggestObjectSize = function () {
        return this.biggestObjectSize;
      }, t;
    }(a.THREE.Mesh);

    t.CogniteBaseMesh = s;

    var c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i(t, e), t.prototype.getMaxInstancedCount = function (e) {
        return this.sizesValid ? o.binarySearchLessThan(this.sizes, e) : this.sizes.length;
      }, t;
    }(s);

    t.CognitePrimitiveMesh = c;

    var l = function (e) {
      function t(t, n, r, i) {
        var a = e.call(this, t, n, i) || this;
        return a.triangleOffsets = r, a;
      }

      return i(t, e), t.prototype.getDrawTriangleOffset = function (e) {
        if (!this.sizesValid) return 1 / 0;
        var t = o.binarySearchLessThan(this.sizes, e);
        return t < this.sizes.length ? 3 * this.triangleOffsets[t] : 1 / 0;
      }, t;
    }(s);

    t.CogniteMergedPolygonMesh = l;

    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.cogniteType = "", t;
      }

      return i(t, e), t;
    }(a.THREE.LOD);

    t.CogniteLOD = d;

    var u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i(t, e), t.prototype.getMaxInstancedCount = function (e) {
        return this.sizesValid ? o.binarySearchLessThan(this.sizes, e) : this.sizes.length;
      }, t;
    }(s);

    t.CogniteInstancedPolygonMesh = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return new Promise(function (t) {
        return setTimeout(t, e);
      });
    };
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/toConsumableArray");
  }, function (e, t) {
    e.exports = require("right-now");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        i = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = i(n(71)),
        o = !0,
        s = {},
        c = function () {
      function e(e, t) {
        if (void 0 === t && (t = {}), this.timerEvent = e, this.startProps = t, o) try {
          a.default.reveal.time_event(e);
        } catch (e) {
          console.warn("Unable to track " + this.timerEvent);
        }
      }

      return e.prototype.stop = function (e) {
        if (void 0 === e && (e = {}), o) try {
          var t = r({}, s, this.startProps, e);
          a.default.reveal.track(this.timerEvent, t);
        } catch (e) {
          console.warn("Unable to track " + this.timerEvent);
        }
      }, e;
    }();

    t.isEnabled = function () {
      return o;
    }, t.init = function (e, t) {
      (o = e) && (a.default.init("7806e37ad90238622aed605ba75d7b95", {}, "reveal"), s = {
        VERSION: "6.0.3",
        project: t || "reveal"
      });
    }, t.track = function (e, t, n) {
      if (o) {
        var i = r({}, s, n);
        a.default.reveal.track(e + "." + t, i);
      }
    }, t.start = function (e, t, n) {
      return new c(e + "." + t, n);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(14),
        i = n(0),
        a = new i.THREE.Vector3();
    t.normalizeRadians = function (e, t, n) {
      for (void 0 === t && (t = -Math.PI), void 0 === n && (n = Math.PI); e < t;) {
        e += r.twoPI;
      }

      for (; e > n;) {
        e -= r.twoPI;
      }

      return e;
    }, t.angleBetweenVector3s = function (e, t, n) {
      var i = e.angleTo(t);
      return a.copy(e).cross(n).dot(t) < 0 ? r.twoPI - i : i;
    };
    var o = new i.THREE.Vector3(0, 0, -1),
        s = new i.THREE.Vector3(),
        c = new i.THREE.Vector3(),
        l = new i.THREE.Vector3();
    t.calculateNearAndFarDistanceForBoundingBox = function (e, t) {
      var n = .1,
          r = 100;
      if (t.isEmpty()) return {
        near: n,
        far: r
      };
      if (e instanceof i.THREE.PerspectiveCamera) r = t.distanceToPoint(e.position) + t.max.distanceTo(t.min), n = t.distanceToPoint(e.position) / Math.sqrt(1 + Math.pow(Math.tan(e.fov / 180 * Math.PI / 2), 2) * (Math.pow(e.aspect, 2) + 1));else {
        t.getCenter(s), t.getSize(c);
        var a = [-.5, .5];
        a.forEach(function (t) {
          a.forEach(function (i) {
            a.forEach(function (a) {
              l.set(t, i, a).multiply(c).add(s).applyMatrix4(e.matrixWorldInverse);
              var d = l.projectOnVector(o).length();
              n = Math.min(n, d), r = Math.max(r, d);
            });
          });
        });
      }
      return {
        near: n,
        far: r
      };
    }, t.clamp = function (e, t, n) {
      return Math.max(t, Math.min(e, n));
    }, t.binarySearchLessThan = function (e, t) {
      if (0 !== e.length) {
        for (var n = 0, r = e.length; r - n > 1;) {
          var i = Math.floor((r + n) / 2);
          e[i] >= t ? n = i : r = i;
        }

        return r;
      }
    }, t.isNonZeroAndSorted = function (e) {
      var t = !e.some(function (e) {
        return 0 === e;
      }),
          n = !e.some(function (t, n) {
        return 0 !== n && t > e[n - 1];
      });
      return t && n;
    };
  }, function (e, t) {
    e.exports = require("is-function");
  }, function (e, t) {
    e.exports = require("three");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        i = new r.THREE.Vector3(1, 0, 0);
    t.xAxis = i;
    var a = new r.THREE.Vector3(0, 1, 0);
    t.yAxis = a;
    var o = new r.THREE.Vector3(0, 0, 1);
    t.zAxis = o;
    var s = 2 * Math.PI;
    t.twoPI = s;
    var c = Math.PI / 180;
    t.degToRadFactor = c;
    var l = new r.THREE.Matrix4();
    t.identityMatrix4 = l;
    var d = new r.THREE.Vector3(0, 0, 0);
    t.identityPosition = d;
    var u = new r.THREE.Quaternion(1, 0, 0, 0);
    t.identityQuaternion = u;
    var f = new r.THREE.Vector3(1, 1, 1);
    t.identityScale = f;
  }, function (e, t) {
    e.exports = require("@cognite/3d-web-parser");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, a) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            a(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            a(e);
          }
        }

        function c(e) {
          e.done ? i(e.value) : new n(function (t) {
            t(e.value);
          }).then(o, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          a,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
        return this;
      }), a;

      function s(a) {
        return function (s) {
          return function (a) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;

                switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                  case 0:
                  case 1:
                    i = a;
                    break;

                  case 4:
                    return o.label++, {
                      value: a[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = a[1], a = [0];
                    continue;

                  case 7:
                    a = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === a[0] || 2 === a[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                      o.label = a[1];
                      break;
                    }

                    if (6 === a[0] && o.label < i[1]) {
                      o.label = i[1], i = a;
                      break;
                    }

                    if (i && o.label < i[2]) {
                      o.label = i[2], o.ops.push(a);
                      break;
                    }

                    i[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                a = t.call(e, o);
              } catch (e) {
                a = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & a[0]) throw a[1];
            return {
              value: a[0] ? a[1] : void 0,
              done: !0
            };
          }([a, s]);
        };
      }
    },
        s = this && this.__read || function (e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          i,
          a = n.call(e),
          o = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = a.next()).done;) {
          o.push(r.value);
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = a.return) && n.call(a);
        } finally {
          if (i) throw i.error;
        }
      }

      return o;
    },
        c = this && this.__spread || function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(s(arguments[t]));
      }

      return e;
    },
        l = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        d = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = n(0),
        f = l(n(10)),
        h = d(n(72)),
        p = d(n(114)),
        v = d(n(119)),
        g = d(n(115)),
        m = n(15),
        _ = new u.THREE.Matrix4().makeRotationFromEuler(new u.THREE.Euler(-Math.PI / 2, 0, 0));

    function x(e) {
      var t,
          n = new u.THREE.Matrix4();
      return null != e && n.makeRotationFromEuler(new ((t = u.THREE.Euler).bind.apply(t, c([void 0], e)))()), n.premultiply(_), n;
    }

    var y = {
      min: 1,
      max: 3
    };

    function b(e) {
      var t = y.min,
          n = y.max;
      return e.filter(function (e) {
        return t <= e.version && e.version <= n;
      }).filter(function (e) {
        return 4 !== e.version;
      }).reduce(function (e, t) {
        return t.version > e.version ? t : e;
      }, {
        fileId: -1,
        version: -1
      });
    }

    function w(e, t) {
      return a(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, fetch("" + e.localPath + t)];

            case 1:
              if (!(n = r.sent()).ok) throw new Error("Request failed");
              return [2, n.arrayBuffer()];
          }
        });
      });
    }

    function E(e) {
      return a(this, void 0, void 0, function () {
        var t, n;
        return o(this, function (i) {
          switch (i.label) {
            case 0:
              return t = null, t = y.max >= 4 ? g.default(C || (C = r(["/web_scene_", ".i3d"], ["/web_scene_", ".i3d"])), y.max) : g.default(R || (R = r(["/web_scene_", ".pb"], ["/web_scene_", ".pb"])), y.max), n = {
                fileVersion: y.max
              }, [4, w(e, t)];

            case 1:
              return [2, (n.sceneBuffer = i.sent(), n.rotationMatrix = _, n)];
          }
        });
      });
    }

    function M(e) {
      return a(this, void 0, void 0, function () {
        var t, n, r, i, a, s, c;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, (t = e.sdk).viewer3D.retrieveRevealRevision3D(e.modelId, e.revisionId)];

            case 1:
              if (n = o.sent(), r = null, i = null, !(n.sceneThreedFiles.length > 0)) throw new Error("Invalid Scene");
              if (a = b(n.sceneThreedFiles), r = a.fileId, i = a.version, null == r || r < 0) throw new Error("Non supported files found for this revision. Please upgrade the 3d-viewer.");
              return s = x(n.rotation), c = {
                fileVersion: i
              }, [4, t.files3D.retrieve(r)];

            case 2:
              return [2, (c.sceneBuffer = o.sent(), c.rotationMatrix = s, c)];
          }
        });
      });
    }

    function S(e, t, n, r) {
      return a(this, void 0, void 0, function () {
        var i, a, s, c, l, d, u, f, h, p, v, g, _, x, y;

        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return (a = t.addNewStep("Downloading 3D model...", 2)).setProgress(1), s = null != e.localPath ? e.localPath : e.modelId + "-" + e.revisionId, [4, r.get("i3df", s)];

            case 1:
              return (c = o.sent()) ? [3, 6] : null == e.localPath ? [3, 3] : [4, E(e)];

            case 2:
              return h = o.sent(), [3, 5];

            case 3:
              return [4, M(e)];

            case 4:
              h = o.sent(), o.label = 5;

            case 5:
              return u = (i = h).fileVersion, d = i.sceneBuffer, f = i.rotationMatrix, l = new Uint8Array(d), r.put("i3df", {
                cacheId: s,
                sceneArray: l,
                sceneBuffer: d,
                fileVersion: u,
                rotationMatrix: f
              }), [3, 7];

            case 6:
              l = c.sceneArray, d = c.sceneBuffer, u = c.fileVersion, f = c.rotationMatrix, o.label = 7;

            case 7:
              return a.setProgress(2), (p = t.addNewStep("Parsing 3D model...", 2)).setProgress(1), u >= 4 ? (y = m.parseFullCustomFile(d, n, e.geometryFilter), [3, 10]) : [3, 8];

            case 8:
              return [4, m.parseProtobuf(l, e.geometryFilter)];

            case 9:
              y = o.sent(), o.label = 10;

            case 10:
              return g = (v = y).rootSector, _ = v.sceneStats, x = v.maps, p.setProgress(2), [2, {
                rootSector: g,
                sceneStats: _,
                maps: x,
                rotationMatrix: f,
                fileVersion: u
              }];
          }
        });
      });
    }

    function T(e, t, n, r, i, s, c) {
      return a(this, void 0, void 0, function () {
        var a, l, d, u, f, h, p, v, g, _, y, w;

        return o(this, function (o) {
          switch (o.label) {
            case 0:
              if ((a = s.map(function (e) {
                return e.threedFiles ? b(e.threedFiles) : {
                  fileId: -1,
                  version: 1
                };
              })).some(function (e) {
                return e.fileId < 0;
              })) throw new Error("Non supported files found for this revision. Please upgrade the 3d viewer");
              return l = a[0].version, d = a.map(function (t) {
                return e.files3D.retrieve(t.fileId);
              }), [4, e.viewer3D.retrieveRevealRevision3D(t, n)];

            case 1:
              return u = o.sent(), [4, Promise.all(d)];

            case 2:
              return f = o.sent(), h = f.map(function (e) {
                return new Uint8Array(e);
              }), i.setProgress(2), l >= 4 ? (y = m.parseMultipleCustomFiles(f, c, {
                boundingBoxFilter: r
              }), [3, 5]) : [3, 3];

            case 3:
              return [4, m.parseProtobuf(h, {
                boundingBoxFilter: r
              })];

            case 4:
              y = o.sent(), o.label = 5;

            case 5:
              return v = (p = y).rootSector, g = p.sceneStats, _ = p.maps, i.setProgress(3), w = x(u.rotation), [2, {
                rootSector: v,
                sceneStats: g,
                maps: _,
                fileVersion: l,
                rotationMatrix: w
              }];
          }
        });
      });
    }

    var C,
        R,
        D = function () {
      function e() {}

      return e.load = function (e, t) {
        return a(this, void 0, void 0, function () {
          var n, r, a, s, c, l, d, u, g, m, _, x, y, b, w, E, M, C, R, D, I, P, B, z, N, O, A;

          return o(this, function (o) {
            switch (o.label) {
              case 0:
                if (a = e.modelId, s = e.revisionId, c = e.localPath, l = e.sdk, d = e.geometryFilter, u = void 0 === d ? {} : d, g = e.onProgress, m = void 0 === g ? function () {} : g, _ = e.onComplete, x = void 0 === _ ? function () {} : _, y = new p.default(4, m, x), b = new v.default(l, c, t), u.boundingBox && (w = u.boundingBox.clone()), !w || !w.isBox3 || w.isEmpty() || !l) return [3, 6];
                I = y.addNewStep("Downloading 3D model...", 2), P = void 0, B = [], I.setProgress(1), o.label = 1;

              case 1:
                return [4, l.viewer3D.listRevealSectors3D(a, s, {
                  boundingBox: {
                    max: [w.max.x, w.max.y, w.max.z],
                    min: [w.min.x, w.min.y, w.min.z]
                  },
                  cursor: P
                })];

              case 2:
                z = o.sent(), B = B.concat(z.items), P = z.nextCursor, o.label = 3;

              case 3:
                if (void 0 !== P) return [3, 1];
                o.label = 4;

              case 4:
                return O = f.start("Cognite3DModelLoader", "loadSectors", {
                  modelId: a,
                  revisionId: s,
                  localPath: void 0 === c ? null : c
                }), I.setProgress(2), N = y.addNewStep("Parsing 3D model...", 3), [4, T(l, a, s, w, N, B, b)];

              case 5:
                return n = o.sent(), M = n.rootSector, C = n.sceneStats, R = n.maps, D = n.rotationMatrix, E = n.fileVersion, O.stop(i({}, C, {
                  fileVersion: E
                })), [3, 8];

              case 6:
                return O = f.start("Cognite3DModelLoader", "loadScene", {
                  modelId: a,
                  revisionId: s,
                  localPath: void 0 === c ? null : c
                }), [4, S(e, y, b, t)];

              case 7:
                r = o.sent(), M = r.rootSector, C = r.sceneStats, R = r.maps, D = r.rotationMatrix, E = r.fileVersion, O.stop(i({}, C, {
                  fileVersion: E
                })), o.label = 8;

              case 8:
                return y.addNewStep("Building 3D model...", 2).setProgress(1), (A = new h.default(a, s, M, C, R, y, b, {
                  orthographicCamera: e.orthographicCamera,
                  geometryFilter: u,
                  sdk: l
                })).applyMatrix(D), A.updateMatrixWorld(!1), [2, A];
            }
          });
        });
      }, e;
    }();

    t.default = D;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.GeometryTypes = ["Box", "Circle", "Cone", "Cylinder", "EccentricCone", "EllipsoidSegment", "ExtrudedRing", "GeneralCylinder", "GeneralRing", "Nut", "Quad", "SphericalSegment", "TorusSegment", "Trapezium", "InstancedMesh", "MergedMesh"];
    t.PrimitiveTypes = ["Box", "Circle", "Cone", "Cylinder", "EccentricCone", "EllipsoidSegment", "ExtrudedRing", "GeneralCylinder", "GeneralRing", "Nut", "Quad", "SphericalSegment", "TorusSegment", "Trapezium"];
    t.MeshTypes = ["InstancedMesh", "MergedMesh"];
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return W;
    });

    var r = n(33),
        i = n.n(r),
        a = n(1),
        o = n.n(a),
        s = n(2),
        c = n.n(s),
        l = n(4),
        d = n.n(l),
        u = n(3),
        f = n.n(u),
        h = n(12),
        p = n.n(h),
        v = n(5),
        g = n.n(v),
        m = n(54),
        _ = n.n(m),
        x = n(34),
        y = n.n(x),
        b = n(55),
        w = n.n(b),
        E = n(0),
        M = n(16),
        S = n.n(M),
        T = n(57),
        C = n.n(T),
        R = n(32),
        D = n(59),
        I = n.n(D),
        P = n(31),
        B = n(11),
        z = n(10),
        N = n(60),
        O = n.n(N),
        A = n(61),
        k = "reveal",
        j = 1,
        L = new E.THREE.Box3(),
        G = new E.THREE.Box3(),
        F = function F(e, t, n) {
      e instanceof E.THREE.PerspectiveCamera ? e.aspect = t / n : (e.left = -t, e.right = t, e.top = n, e.bottom = -n), e.updateProjectionMatrix();
    },
        H = function H() {
      var e = document.createElementNS("http://www.w3.org/1999/xhtml", "div");
      return e.style.width = "100%", e.style.height = "100%", e;
    },
        U = function e() {
      f()(this, e), this.get = function (e, t) {
        return null;
      }, this.put = function (e, t, n) {};
    },
        W = function () {
      function e() {
        var t = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        f()(this, e), V.call(this), this._isDisposed = !1;
        var r = n.domElement,
            i = void 0 === r ? H() : r,
            a = n.brightness,
            o = void 0 === a ? 1 : a,
            s = n.noBackground,
            c = void 0 !== s && s,
            l = n.highlightColor,
            d = void 0 === l ? new E.THREE.Color(0, 0, 1) : l,
            u = n.viewCube,
            h = n.orthographicCamera,
            p = void 0 !== h && h,
            v = n.logMetrics,
            g = void 0 === v || v,
            m = n.enableCache,
            x = void 0 !== m && m,
            y = n.sdk;
        z.init(g, y && y.project), z.track("Cognite3DViewer", "constructor", {
          brightness: n.brightness,
          alpha: n.alpha,
          viewCube: n.viewCube,
          highlightColor: null != n.highlightColor ? [n.highlightColor.r, n.highlightColor.g, n.highlightColor.b] : void 0
        }), this._stats = new O.a(), this._sdk = y, this._models = [], this._brightness = o, this._setupRenderer({
          alpha: c,
          highlightColor: d
        }), this._domElement = i, this._domElement.appendChild(this._canvas), this._latestRequestId = void 0, this._scene = new E.THREE.Scene(), this._camera = p ? new E.THREE.OrthographicCamera(null, null, null, null, .1, 1e4) : new E.THREE.PerspectiveCamera(60, null, .1, 1e4), this._camera.position.x = 30, this._camera.position.y = 10, this._camera.position.z = 50, this._camera.lookAt(new E.THREE.Vector3()), this._ambientLight = new E.THREE.AmbientLight(16777215), this._directionalLight = new E.THREE.DirectionalLight(16777215), this._ambientLight.intensity = .7, this._directionalLight.intensity = .7, this._scene.add(this._directionalLight), this._scene.add(this._ambientLight), this._controls = new _.a(this._camera, this._canvas), this._controls.dollyFactor = .992, this._disableCameraController(), this._renderController = new C.a(this._camera), this._eventListeners = {
          click: [],
          cameraChange: []
        }, this._controls.addEventListener("cameraChange", function (e) {
          var n = e.camera,
              r = n.position,
              i = n.target,
              a = n.zoom;

          t._eventListeners.cameraChange.forEach(function (e) {
            e(r.clone(), i.clone(), a);
          });
        }), this._forceRendering = !1, this._enableProfiler = !1, this._performanceMonitor = new R.a(), this._additionalObjects = [], ["topleft", "topright", "bottomleft", "bottomright"].includes(u) && this._renderer.addGUIComponent(new I.a(u)), this._cacheDb = x ? Object(A.openDB)(k, j, {
          upgrade: function upgrade(e) {
            e.createObjectStore("ctm", {
              keyPath: "fileId"
            }), e.createObjectStore("i3df", {
              keyPath: "cacheId"
            });
          }
        }) : new U(), this._enableCameraController(), this._startPointerEventListeners(), this._clock = new E.THREE.Clock(), this._animate();
      }

      return d()(e, [{
        key: "domElement",
        get: function get() {
          return this._domElement;
        }
      }]), e;
    }();

    W.isBrowserSupported = function () {
      try {
        var e = document.createElement("canvas");
        return !(!window.WebGLRenderingContext || !e.getContext("webgl") && !e.getContext("experimental-webgl"));
      } catch (e) {
        return !1;
      }
    };

    var V = function V() {
      var e = this;
      this.dispose = function () {
        e._isDisposed = !0, e._forceRendering = !1, void 0 !== e._latestRequestId && cancelAnimationFrame(e._latestRequestId), e._domElement.removeChild(e._canvas), e._renderer.dispose();
        var t = !0,
            n = !1,
            r = void 0;

        try {
          for (var i, a = e._models[Symbol.iterator](); !(t = (i = a.next()).done); t = !0) {
            i.value._dispose();
          }
        } catch (e) {
          n = !0, r = e;
        } finally {
          try {
            t || null == a.return || a.return();
          } finally {
            if (n) throw r;
          }
        }

        e._models = [], Object(P.disposeGeometries)();
      }, this._autoAdjustBrightness = function (t) {
        if (!e._isDisposed && 0 !== e._models.length) {
          t /= 4;

          var n = e._models.reduce(function (e, t) {
            return e + t._meanIntensity;
          }, 0) / e._models.length;

          e._ambientLight.intensity = t / n;
        }
      }, this._setupRenderer = function (t) {
        if (!e._isDisposed) {
          e._renderer = new w.a(t), e._canvas = e._renderer.getRawRenderer().domElement, e._canvas.style.width = "640px", e._canvas.style.height = "480px", e._canvas.style.minWidth = "100%", e._canvas.style.minHeight = "100%", e._canvas.style.maxWidth = "100%", e._canvas.style.maxHeight = "100%";
          var n = e._models;
          e._renderer.onBeforeModelRender = function () {
            n.forEach(function (e) {
              e._onlyShowSelectedNodes(!1);
            });

            var t = e._renderer.getSize(),
                r = t.width,
                i = t.height;

            n.forEach(function (t) {
              t._update(e._camera, r, i);
            }), e._additionalObjects.forEach(function (e) {
              e.visible = !0;
            });
          }, e._renderer.onBeforeSelectRender = function () {
            n.forEach(function (e) {
              e._onlyShowSelectedNodes(!0);
            }), e._additionalObjects.forEach(function (e) {
              e.visible = !1;
            });
          }, e._renderer.onAfterRender = e._renderer.onBeforeModelRender;
        }
      }, this._startPointerEventListeners = function () {
        if (!e._isDisposed) {
          var t,
              n = e._canvas,
              r = !1,
              i = !1,
              a = function a(e) {
            var t = [];
            return window.TouchEvent && e instanceof TouchEvent ? y()(e.changedTouches[0], n, t) : y()(e, n, t), {
              offsetX: t[0],
              offsetY: t[1]
            };
          },
              o = function o(n) {
            if (!e._isDisposed) {
              var o = a(n),
                  s = o.offsetX,
                  c = o.offsetY,
                  l = a(t),
                  d = l.offsetX,
                  u = l.offsetY;
              r && i && Math.abs(s - d) + Math.abs(c - u) > 4 && (i = !1);
            }
          },
              s = function s() {
            e._isDisposed || (r && i && e._eventListeners.click.forEach(function (e) {
              e(a(t));
            }), r = !1, i = !1, n.removeEventListener("mousemove", o), n.removeEventListener("touchmove", o), n.removeEventListener("mouseup", s), n.removeEventListener("touchend", s));
          },
              c = function c(a) {
            e._isDisposed || (t = a, r = !0, i = !0, n.addEventListener("mousemove", o), n.addEventListener("touchmove", o), n.addEventListener("mouseup", s), n.addEventListener("touchend", s));
          };

          n.addEventListener("mousedown", c), n.addEventListener("touchstart", c);
        }
      }, this._enableCameraController = function () {
        e._isDisposed || (e._controls.enabled = !0);
      }, this._disableCameraController = function () {
        e._isDisposed || (e._controls.enabled = !1);
      }, this.on = function (t, n) {
        if (!e._isDisposed) {
          var r = e._eventListeners;
          if (!p()(n)) throw new Error("func parameter is not a function");
          if (null == r[t]) throw new Error("Invalid type parameter: ".concat(t));
          r[t].push(n);
        }
      }, this.off = function (t, n) {
        if (!e._isDisposed) {
          var r = e._eventListeners;
          if (!p()(n)) throw new Error("func parameter is not a function");
          if (null == r[t]) throw new Error("Invalid type parameter: ".concat(t));
          var i = r[t].indexOf(n);
          -1 !== i && r[t].splice(i, 1);
        }
      }, this.addModel = c()(o.a.mark(function t() {
        var n,
            r,
            i,
            a,
            s,
            c,
            l,
            d,
            u,
            f,
            h = arguments;
        return o.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (n = h.length > 0 && void 0 !== h[0] ? h[0] : {}, !e._isDisposed) {
                  t.next = 3;
                  break;
                }

                return t.abrupt("return", null);

              case 3:
                if (r = n.modelId, i = n.revisionId, a = n.onProgress, s = n.onComplete, c = n.geometryFilter, l = n.localPath, d = n.apiKey, e._sdk || l) {
                  t.next = 6;
                  break;
                }

                throw new Error("A sdk:<CogniteClient> must be passed to the Cognite3DViewer before adding a Cognite3DModel with modelId and revisionId.");

              case 6:
                return u = {
                  modelId: r,
                  revisionId: i,
                  geometryFilter: c,
                  onProgress: function onProgress() {
                    e._isDisposed || (e._renderController.redraw(), p()(a) && a.apply(void 0, arguments));
                  },
                  onComplete: function onComplete() {
                    e._isDisposed || p()(s) && s.apply(void 0, arguments);
                  },
                  localPath: l,
                  apiKey: d,
                  sdk: e._sdk,
                  orthographicCamera: e._camera instanceof E.THREE.OrthographicCamera
                }, t.t0 = S.a, t.t1 = u, t.next = 13, e._cacheDb;

              case 13:
                return t.t2 = t.sent, t.next = 16, t.t0.load.call(t.t0, t.t1, t.t2);

              case 16:
                return f = t.sent, e._scene.add(f), f.traverse(function (e) {
                  e.matrixAutoUpdate = !1;
                }), f._onChange = function () {
                  e._renderController.redraw();
                }, e._models.push(f), t.abrupt("return", f);

              case 22:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), this.addObject3D = function (t) {
        e._isDisposed || (e._scene.add(t), e._additionalObjects.push(t), e._renderController.redraw());
      }, this.removeObject3D = function (t) {
        if (!e._isDisposed) {
          e._scene.remove(t);

          var n = e._additionalObjects.indexOf(t);

          n > -1 && e._additionalObjects.splice(n, 1), e._renderController.redraw();
        }
      }, this.setSlicePoint = function () {
        e._isDisposed || console.error("setSlicePoint is no longer supported, please use setSlicingPlanes instead.");
      }, this.setSlicePlanes = function () {
        e._isDisposed || console.error("setSlicePlanes is no longer supported, please use setSlicingPlanes instead.");
      }, this.setSlicingPlanes = function (t) {
        e._isDisposed || (e._renderer.getRawRenderer().clippingPlanes = t.map(function (e) {
          return e.clone().normalize();
        }), e._models.forEach(function (e) {
          e._updateSlicing(t.length > 0);
        }), e._renderController.redraw());
      }, this.getCameraPosition = function () {
        return e._isDisposed ? null : e._controls.getState().position;
      }, this.getCameraTarget = function () {
        return e._isDisposed ? null : e._controls.getState().target;
      }, this.setCameraPosition = function (t) {
        e._isDisposed || e._controls.setState(t, e.getCameraTarget());
      }, this.setCameraTarget = function (t) {
        e._isDisposed || e._controls.setState(e.getCameraPosition(), t);
      }, this._moveCameraTo = function (t, n, r) {
        if (!e._isDisposed) {
          var i = e._camera;
          if (null == r) r = 125 * t.distanceTo(i.position), r = Object(B.clamp)(r, 600, 2500);
          var a = new E.THREE.Raycaster();
          a.setFromCamera(new E.THREE.Vector2(0, 0), i);

          var o = n.distanceTo(i.position),
              s = a.ray.direction.clone().multiplyScalar(o),
              c = a.ray.origin.clone().add(s),
              l = {
            x: i.position.x,
            y: i.position.y,
            z: i.position.z,
            targetX: c.x,
            targetY: c.y,
            targetZ: c.z
          },
              d = {
            x: t.x,
            y: t.y,
            z: t.z,
            targetX: n.x,
            targetY: n.y,
            targetZ: n.z
          },
              u = new g.a.Tween(l),
              f = function t(n) {
            if (e._isDisposed) return document.removeEventListener("keydown", t), void u.stop();
            ("keydown" !== n.type || e._controls.enableKeyboardNavigation) && (u.stop(), e._canvas.removeEventListener("pointerdown", t), e._canvas.removeEventListener("wheel", t), document.removeEventListener("keydown", t));
          };

          e._canvas.addEventListener("pointerdown", f), e._canvas.addEventListener("wheel", f), document.addEventListener("keydown", f);
          var h = new E.THREE.Vector3(),
              p = new E.THREE.Vector3();
          u.to(d, r).easing(g.a.Easing.Circular.Out).onUpdate(function () {
            e._isDisposed || (p.set(l.x, l.y, l.z), h.set(l.targetX, l.targetY, l.targetZ), void 0 !== e._camera && (e.setCameraPosition(p), e.setCameraTarget(h)));
          }).onComplete(function () {
            e._isDisposed || e._canvas.removeEventListener("pointerdown", f);
          }).start();
        }
      }, this.fitCameraToBoundingBox = function (t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4;

        if (!e._isDisposed) {
          var i = new E.THREE.Sphere();
          t.getBoundingSphere(i);
          var a = i.center,
              o = Math.max(2 * e._getSmallestMeanObjectSize(), i.radius * r),
              s = new E.THREE.Vector3(0, 0, -1);
          s.applyQuaternion(e._camera.quaternion);
          var c = new E.THREE.Vector3();
          c.copy(s).multiplyScalar(-o).add(a), e._moveCameraTo(c, a, n);
        }
      }, this.disableKeyboardNavigation = function () {
        e._isDisposed || (e._controls.enableKeyboardNavigation = !1);
      }, this.enableKeyboardNavigation = function () {
        e._isDisposed || (e._controls.enableKeyboardNavigation = !0);
      }, this.fitCameraToModel = function (t, n) {
        if (!e._isDisposed) {
          var r = t.getBoundingBox(null);
          e.fitCameraToBoundingBox(r, n, 2);
        }
      }, this.worldToScreen = function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (e._isDisposed) return null;
        var r = t.clone().project(e._camera);
        return r.y = -r.y, r.addScalar(1).multiplyScalar(.5), r.x < 0 || r.x > 1 || r.y < 0 || r.y > 1 || r.z < 0 || r.z > 1 ? null : (n || (r.x *= e._canvas.clientWidth, r.y *= e._canvas.clientHeight), new E.THREE.Vector2(r.x, r.y));
      }, this.getIntersectionFromPixel = function (t, n, r) {
        if (e._isDisposed) return null;

        var a = e._renderer.getSize(),
            o = a.width,
            s = a.height;

        if (t = t * o / e._canvas.clientWidth, n = n * s / e._canvas.clientHeight, r) {
          var c = r._getIntersectionFromPixel(e._camera, e._renderer, t, n);

          return c ? i()({
            model: r
          }, c) : null;
        }

        var l = [];
        if (e._models.forEach(function (r) {
          var a = r._getIntersectionFromPixel(e._camera, e._renderer, t, n);

          a && l.push(i()({
            model: r
          }, a));
        }), 0 === l.length) return null;
        var d = 1 / 0,
            u = null,
            f = e._camera.position;
        return l.forEach(function (e) {
          var t = f.distanceToSquared(e.point);
          t < d && (d = t, u = e);
        }), u;
      }, this._getSmallestMeanObjectSize = function () {
        return e._isDisposed ? 0 : 0 === e._models.length ? 0 : e._models.reduce(function (e, t) {
          return Math.min(e, t._getMeanObjectSize());
        }, 1 / 0);
      }, this._getCanvasSize = function () {
        return e._isDisposed ? {
          width: 0,
          height: 0
        } : {
          width: e._canvas.clientWidth,
          height: e._canvas.clientHeight
        };
      }, this.getScreenshot = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e._canvas.width,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e._canvas.height;
        if (e._isDisposed) return "";

        var r = e._camera.clone();

        return F(r, t, n), e._renderer.getScreenshot(e._scene, r, t, n);
      }, this._resizeIfNeeded = function () {
        if (e._isDisposed) return !1;

        var t = e._renderer.getSize(),
            n = t.width,
            r = t.height,
            i = 0 !== e._domElement.clientWidth ? e._domElement.clientWidth : e._canvas.clientWidth,
            a = 0 !== e._domElement.clientHeight ? e._domElement.clientHeight : e._canvas.clientHeight,
            o = window.devicePixelRatio * i,
            s = window.devicePixelRatio * a,
            c = o * s,
            l = c > 14e5 ? Math.sqrt(14e5 / c) : 1,
            d = o * l,
            u = s * l;

        return !(Math.abs(n - d) < .1 && Math.abs(r - u) < .1) && (e._renderer.setSize(d, u), F(e._camera, d, u), e._camera instanceof E.THREE.OrthographicCamera && (e._controls.orthographicCameraDollyFactor = 20 / d, e._controls.keyboardDollySpeed = 2 / d), !0);
      }, this._startProfiler = function () {
        e._isDisposed || (e._performanceMonitor.reset(), e._enableProfiler = !0);
      }, this._stopProfiler = function () {
        return e._isDisposed ? [] : (e._enableProfiler = !1, e._performanceMonitor.datapoints);
      }, this._updateNearAndFarPlane = function (t) {
        if (!e._isDisposed && 0 !== e._models.length) {
          var n = L;
          n.makeEmpty();

          var r = e._getSmallestMeanObjectSize();

          e._models.forEach(function (e) {
            n.union(e.getBoundingBox(null, G));
          }), e._additionalObjects.forEach(function (e) {
            G.makeEmpty(), G.setFromObject(e), n.union(G);
          });
          var i = Object(B.calculateNearAndFarDistanceForBoundingBox)(t, n),
              a = i.near,
              o = i.far;

          if (!n.isEmpty()) {
            var s = a,
                c = o;
            t.near = Math.min(c / 1e3, Math.max(.1 * r, s)), t.far = c, t.updateProjectionMatrix();
            var l = n.max.distanceTo(n.min);
            e._controls.minDistance = Math.max(Math.min(2 * r, .02 * l), .1 * s);
          }
        }
      }, this._updateLights = function () {
        if (!e._isDisposed) {
          var t = e._controls.getState(),
              n = t.position,
              r = t.target;

          e._directionalLight.position.subVectors(n, r), e._autoAdjustBrightness(e._brightness);
        }
      }, this._animate = function (t) {
        if (!e._isDisposed) {
          e._onBeforeRender && e._onBeforeRender();
          var n = window.getComputedStyle(e._canvas),
              r = n.display;

          if ("visible" === n.visibility && "none" !== r) {
            var i = e._renderController,
                a = e._forceRendering;
            e._enableProfiler && e._performanceMonitor.begin(), g.a.update(t), e._resizeIfNeeded() && i.redraw(), e._controls.update(e._clock.getDelta()), i.update(), i.needsRedraw || a ? (e._stats.start(), e._updateLights(), e._updateNearAndFarPlane(e._camera), e._renderer.render(e._scene, e._camera), i.clearNeedsRedraw()) : e._stats.end(), e._enableProfiler && e._performanceMonitor.end(), e._onAfterRender && e._onAfterRender(), e._latestRequestId = requestAnimationFrame(e._animate.bind(e));
          } else e._latestRequestId = requestAnimationFrame(e._animate.bind(e));
        }
      }, this.clearCache = c()(o.a.mark(function t() {
        var n;
        return o.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, e._cacheDb;

              case 2:
                return n = t.sent, t.next = 5, n.clear("ctm");

              case 5:
                return t.next = 7, n.clear("i3df");

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
    };
  }, function (e, t) {
    e.exports = "varying vec2 xy;";
  }, function (e, t) {
    e.exports = "varying vec2 xy;";
  }, function (e, t) {
    e.exports = "uniform mat4 projectionMatrix;\nvarying vec4 U;\nvarying vec4 V;\nvarying vec4 axis;\n\nvarying vec4 v_centerA;\nvarying vec4 v_centerB;\nvarying float height;\n";
  }, function (e, t) {
    e.exports = "attribute vec3 a_centerA;\nattribute vec3 a_centerB;\nattribute float a_radiusA;\nattribute float a_radiusB;\nattribute vec3 a_normal;\n\n// We pack the radii into w-components\nvarying vec4 v_centerA;\nvarying vec4 v_centerB;\n\n// U, V, axis represent the 3x3 cone basis.\n// They are vec4 to pack extra data into the w-component\n// since Safari on iOS only supports 8 varying vec4 registers.\nvarying vec4 U;\nvarying vec4 V;\nvarying vec4 axis;\nvarying float height;\n";
  }, function (e, t) {
    e.exports = "uniform mat4 projectionMatrix;\nvarying vec4 center;\nvarying float hRadius;\nvarying float height;\n\nvarying vec4 U;\nvarying vec4 V;\nvarying vec4 sphereNormal;\n";
  }, function (e, t) {
    e.exports = "attribute vec3 a_center;\nattribute vec3 a_normal;\nattribute float a_hRadius;\nattribute float a_vRadius;\nattribute float a_height;\n\n// We pack vRadius as w-component of center\nvarying vec4 center;\nvarying float hRadius;\nvarying float height;\n\n// U, V, axis represent the 3x3 sphere basis.\n// They are vec4 to pack extra data into the w-component\n// since Safari on iOS only supports 8 varying vec4 registers.\nvarying vec4 U;\nvarying vec4 V;\nvarying vec4 sphereNormal;\n";
  }, function (e, t) {
    e.exports = "uniform float dataTextureWidth;\nuniform float dataTextureHeight;\nuniform mat4 projectionMatrix;\n\nvarying vec4 v_centerB;\n\nvarying vec4 v_W;\nvarying vec4 v_U;\n\nvarying float v_angle;\nvarying float v_arcAngle;\n\n#if defined(COGNITE_CONE)\n  varying vec4 v_centerA;\n  varying vec4 v_V;\n#endif\n\n#if defined(COGNITE_GENERAL_CYLINDER)\n  varying float v_surfacePointY;\n\n  varying vec4 v_planeA;\n  varying vec4 v_planeB;\n#endif\n";
  }, function (e, t) {
    e.exports = "attribute vec3 a_centerA;\nattribute vec3 a_centerB;\nattribute float a_radiusA;\nattribute float a_radiusB;\n\n// We pack the radii into w-components\nvarying vec4 v_centerB;\n\n// U, V, axis represent the 3x3 cone basis.\n// They are vec4 to pack extra data into the w-component\n// since Safari on iOS only supports 8 varying vec4 registers.\nvarying vec4 v_U;\nvarying vec4 v_W;\n\n#if defined(COGNITE_CONE)\n  varying vec4 v_centerA;\n  varying vec4 v_V;\n#endif\n\n#if defined(COGNITE_GENERAL_CYLINDER)\n  // slicing plane attributes\n  attribute vec4 a_planeA;\n  attribute vec4 a_planeB;\n  varying vec4 v_planeA;\n  varying vec4 v_planeB;\n\n  // additional attributes\n  varying float v_surfacePointY;\n#endif\n\n// segment attributes\nattribute vec3 a_localXAxis;\nattribute float a_angle;\nattribute float a_arcAngle;\n\nvarying float v_angle;\nvarying float v_arcAngle;\n";
  }, function (e, t) {
    e.exports = "varying float v_oneMinusThicknessSqr;\nvarying vec2 v_xy;\nvarying float v_angle;\nvarying float v_arcAngle;\n";
  }, function (e, t) {
    e.exports = "attribute float a_angle;\nattribute float a_arcAngle;\nattribute float a_thickness;\n\nvarying float v_oneMinusThicknessSqr;\nvarying vec2 v_xy;\nvarying float v_angle;\nvarying float v_arcAngle;\n";
  }, function (e, t) {
    e.exports = "attribute float a_arcAngle;\nattribute float a_radius;\nattribute float a_tubeRadius;";
  }, function (e, t) {
    e.exports = "attribute vec3 a_vertex1;\nattribute vec3 a_vertex2;\nattribute vec3 a_vertex3;\nattribute vec3 a_vertex4;\n";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__read || function (e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          i,
          a = n.call(e),
          o = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = a.next()).done;) {
          o.push(r.value);
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = a.return) && n.call(a);
        } finally {
          if (i) throw i.error;
        }
      }

      return o;
    },
        i = this && this.__values || function (e) {
      var t = "function" == typeof Symbol && e[Symbol.iterator],
          n = 0;
      return t ? t.call(e) : {
        next: function next() {
          return e && n >= e.length && (e = void 0), {
            value: e && e[n++],
            done: !e
          };
        }
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(0),
        o = n(14),
        s = {},
        c = [];

    function l() {
      var e = new a.THREE.PlaneBufferGeometry(1, 1, 1, 1);
      return c.push(e), [{
        index: e.getIndex(),
        position: e.getAttribute("position"),
        normal: e.getAttribute("normal")
      }];
    }

    function d() {
      var e = [];
      e.push(-1, 1, -1), e.push(-1, -1, -1), e.push(1, 1, -1), e.push(1, -1, -1), e.push(1, 1, 1), e.push(1, -1, 1);
      var t = new Uint16Array([1, 2, 0, 1, 3, 2, 3, 4, 2, 3, 5, 4]);
      return [{
        index: new a.THREE.BufferAttribute(t, 1),
        position: new a.THREE.BufferAttribute(new Float32Array(e), 3)
      }];
    }

    var u = {
      Box: function Box() {
        var e = new a.THREE.BoxBufferGeometry(1, 1, 1, 1, 1, 1);
        return c.push(e), [{
          index: e.getIndex(),
          position: e.getAttribute("position"),
          normal: e.getAttribute("normal")
        }];
      },
      Circle: l,
      Cone: d,
      EllipsoidSegment: d,
      EccentricCone: d,
      GeneralRing: l,
      GeneralCylinder: d,
      Nut: function Nut() {
        var e = new a.THREE.CylinderBufferGeometry(.5, .5, 1, 6);
        return c.push(e), e.applyMatrix(new a.THREE.Matrix4().makeRotationX(-Math.PI / 2)), [{
          index: e.getIndex(),
          position: e.getAttribute("position"),
          normal: e.getAttribute("normal")
        }];
      },
      Quad: l,
      SphericalSegment: d,
      TorusSegment: function TorusSegment() {
        var e = function e(_e, t) {
          return [_e, t * o.twoPI];
        };

        return [[6, 4], [9, 4], [11, 6], [16, 12], [24, 16]].map(function (t) {
          var n = r(t, 2);
          return function (e, t, n) {
            void 0 === n && (n = function n(e, t) {
              return [e, t, 0];
            });

            for (var i = [], o = [], s = 1 / e, c = 1 / t, l = 0; l <= t; l++) {
              for (var d = 0; d <= e; d++) {
                var u = r(n(d * s, l * c), 3),
                    f = u[0],
                    h = u[1],
                    p = u[2];
                i.push(f || 0, h || 0, p || 0);
              }
            }

            for (l = 1; l <= t; l++) {
              for (d = 1; d <= e; d++) {
                var v = (e + 1) * l + d - 1,
                    g = (e + 1) * (l - 1) + d - 1,
                    m = (e + 1) * (l - 1) + d,
                    _ = (e + 1) * l + d;

                o.push(v, g, _), o.push(g, m, _);
              }
            }

            return {
              index: new a.THREE.Uint16BufferAttribute(o, 1),
              position: new a.THREE.Float32BufferAttribute(i, 3)
            };
          }(n[0], n[1], e);
        });
      },
      Trapezium: function Trapezium() {
        return [{
          index: new a.THREE.BufferAttribute(new Uint16Array([0, 1, 3, 0, 3, 2]), 1),
          position: new a.THREE.BufferAttribute(new Float32Array([0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3]), 3)
        }];
      }
    };
    t.getGeometryLODs = function (e) {
      if (null == u[e]) throw new Error("Geometry (" + e + ") not found");
      return null == s[e] && (s[e] = u[e]()), s[e];
    }, t.disposeGeometries = function () {
      var e, t;

      try {
        for (var n = i(c), r = n.next(); !r.done; r = n.next()) {
          r.value.dispose();
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (t = n.return) && t.call(n);
        } finally {
          if (e) throw e.error;
        }
      }
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return S;
    }), n.d(t, "b", function () {
      return R;
    });

    var r = n(1),
        i = n.n(r),
        a = n(2),
        o = n.n(a),
        s = n(8),
        c = n.n(s),
        l = n(58),
        d = n.n(l),
        u = n(3),
        f = n.n(u),
        h = n(4),
        p = n.n(h),
        v = n(9),
        g = n.n(v),
        m = n(5),
        _ = n.n(m),
        x = n(0),
        y = n(35),
        b = n(6),
        w = n(7),
        E = n.n(w),
        M = function () {
      function e() {
        return f()(this, e), this;
      }

      return p()(e, [{
        key: "start",
        value: function value() {
          return this.startTime = g()(), this;
        }
      }, {
        key: "stop",
        value: function value() {
          return g()() - this.startTime;
        }
      }]), e;
    }(),
        S = function () {
      function e() {
        f()(this, e), this.reset();
      }

      return p()(e, [{
        key: "begin",
        value: function value() {
          return this.beginTime = g()(), this.beginTime;
        }
      }, {
        key: "end",
        value: function value(e) {
          var t = g()();
          return this.datapoints.push({
            timestamp: t,
            frames: this.frames++,
            duration: t - this.beginTime,
            userData: e
          }), t;
        }
      }, {
        key: "reset",
        value: function value() {
          this.beginTime = g()(), this.frames = 0, this.datapoints = [];
        }
      }]), e;
    }();

    function T(e) {
      if (e.length < 2) return console.error("calculateFrameRate requires >= 2 datapoints"), NaN;
      var t = e[0],
          n = e[e.length - 1],
          r = n.timestamp - t.timestamp;
      return 1e3 * (n.frames - t.frames) / r;
    }

    var C = function () {
      function e() {
        f()(this, e), this.loadingStats = [], this.renderingStats = [];
      }

      return p()(e, [{
        key: "addLoadingStats",
        value: function value(e, t) {
          this.loadingStats.push({
            title: e,
            duration: t
          }), console.log("".concat(e, ": ").concat(t, " ms"));
        }
      }, {
        key: "addRenderingStats",
        value: function value(e, t) {
          this.renderingStats.push({
            title: e,
            data: t
          }), console.log("".concat(e, ": "), t);
        }
      }, {
        key: "makeReport",
        value: function value() {
          var e = "font-weight: bold;",
              t = "".concat("color:blue", " ").concat(e, " font-size: 17px;"),
              n = "".concat(e, " font-size: 15px;"),
              r = "font-size: 13px;",
              i = "font-size: 12px;",
              a = "",
              o = [],
              s = function e(t, n) {
            null == n ? e(t, "color:black") : (a += "%c".concat(t), o.push(n));
          },
              l = function l(e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            n.forEach(function (e) {
              "object" === d()(e) ? s(e[0], e[1]) : s(e);
            }), e.apply(void 0, [a].concat(c()(o))), a = "", o = [];
          },
              u = function u() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            l.apply(void 0, [console.log].concat(t));
          },
              f = function f() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            l.apply(void 0, [console.group].concat(t));
          },
              h = function h() {
            console.groupEnd();
          };

          f(["Report", t]), f(["Loading stats", n]), this.loadingStats.forEach(function (e) {
            u([e.title, r], ": ", e.duration.toFixed(0), " ms");
          }), h(), f(["Rendering stats", n]);

          var p = function p(e) {
            [{
              name: "Static",
              data: e.static
            }, {
              name: "Spinning",
              data: e.spinning
            }, {
              name: "Inside",
              data: e.inside
            }].forEach(function (e) {
              var t = e.name,
                  n = e.data.fps,
                  r = "color:green";
              n < 40 && (r = "color:red"), n < 25 && (r = "color:red"), u(t, " -> ", [n.toFixed(0), r], " fps");
            });
          };

          this.renderingStats.forEach(function (e) {
            f(["".concat(e.title, " (").concat(e.data.numDrawCalls, " draw calls, ").concat(e.data.numNodes, " nodes)"), r]), f(["Big canvas", i]), p(e.data.big), h(), f(["Small canvas", i]), p(e.data.small), h(), h();
          }), h(), h();
        }
      }]), e;
    }(),
        R = function () {
      function e(t, n) {
        f()(this, e), this.viewer = t, this.viewerOptions = n, this.types = ["Box", "Circle", "Cone", "EccentricCone", "ExtrudedRing", "InstancedMesh", "MergedMesh", "Nut", "SphericalSegment", "EllipsoidSegment", "TorusSegment"];
      }

      return p()(e, [{
        key: "run",
        value: function value() {
          var e = this,
              t = this.viewer,
              n = this.viewerOptions,
              r = new C();
          this.loadModelWatch = new M().start();
          var a = [];
          n.onComplete = o()(i.a.mark(function n() {
            var o, s, c, l, d;
            return i.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return o = a[a.length - 1], s = o.title, c = o.watch, l = c.stop(), r.addLoadingStats(s, l), d = e.loadModelWatch.stop(), r.addLoadingStats("Load model", d), t._disableCameraController(), t._forceRendering = !0, n.next = 9, E()(1e3);

                  case 9:
                    return n.next = 11, e.start(r);

                  case 11:
                    t._forceRendering = !1, t._enableCameraController(), r.makeReport();

                  case 14:
                  case "end":
                    return n.stop();
                }
              }
            }, n);
          })), n.onProgress = function (e) {
            if (a.length > 0) {
              var t = a[a.length - 1],
                  n = t.step,
                  i = t.title,
                  o = t.watch;

              if (n !== e.step) {
                var s = o.stop();
                r.addLoadingStats(i, s), a.push({
                  step: e.step,
                  title: e.title,
                  watch: new M().start()
                });
              }
            } else a.push({
              step: e.step,
              title: e.title,
              watch: new M().start()
            });
          }, t.addModel(n).then(function (n) {
            e.model = n, t.fitCameraToModel(n, 0);
          });
        }
      }, {
        key: "start",
        value: function () {
          var e = o()(i.a.mark(function e(t) {
            var n, r, a, o, s, c, l, d;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    n = this.viewer, r = this.model, a = this.types, o = 0;

                  case 2:
                    if (!(o < a.length)) {
                      e.next = 11;
                      break;
                    }

                    return s = a[o], e.next = 6, this.testGeometryTypes(s);

                  case 6:
                    (c = e.sent) && t.addRenderingStats(s, c);

                  case 8:
                    o++, e.next = 2;
                    break;

                  case 11:
                    return e.next = 13, this.testGeometryTypes("MergedMesh", "InstancedMesh");

                  case 13:
                    return l = e.sent, t.addRenderingStats("All meshes", l), e.next = 17, this.testCurrentState();

                  case 17:
                    d = e.sent, t.addRenderingStats("Full model", d), n.fitCameraToModel(r, 0);

                  case 20:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "testGeometryTypes",
        value: function () {
          var e = o()(i.a.mark(function e() {
            var t,
                n,
                r,
                a,
                o,
                s,
                c,
                l,
                d = arguments;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    for (t = d.length, n = new Array(t), r = 0; r < t; r++) {
                      n[r] = d[r];
                    }

                    if (a = this.onlyShowGeometryTypes.apply(this, n), o = a.count, s = a.removedObjects, c = function c() {
                      s.forEach(function (e) {
                        var t = e.parent,
                            n = e.obj;
                        t.add(n);
                      });
                    }, 0 !== o) {
                      e.next = 7;
                      break;
                    }

                    return console.warn("No ".concat(n.join(", "), " found. Continuing test")), c(), e.abrupt("return", null);

                  case 7:
                    return e.next = 9, this.testCurrentState();

                  case 9:
                    return l = e.sent, c(), e.abrupt("return", l);

                  case 12:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "onlyShowGeometryTypes",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          var r = this.model._rootSector.object3d,
              i = [],
              a = 0;
          return r.traverse(function (e) {
            var n = e.cogniteType;
            if (n) if (-1 === t.indexOf(n)) {
              var r = e.parent;
              i.push({
                parent: r,
                obj: e
              });
            } else a++;
          }), i.forEach(function (e) {
            var t = e.parent,
                n = e.obj;
            t.remove(n);
          }), {
            count: a,
            removedObjects: i
          };
        }
      }, {
        key: "testCurrentState",
        value: function () {
          var e = o()(i.a.mark(function e() {
            var t, n, r, a, o;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = this.viewer, n = this.model, r = t.domElement, a = {
                      numDrawCalls: 0
                    }, o = 0, n._rootSector.object3d.traverseVisible(function (e) {
                      e instanceof b.CogniteBaseMesh && (o += n._getTreeIndicesFromMesh(e).length, a.numDrawCalls++);
                    }), a.numNodes = o, r.style.width = "200px", r.style.height = "200px", e.next = 10, this.profileRendering();

                  case 10:
                    return a.small = e.sent, r.style.width = "1500px", r.style.height = "1500px", e.next = 15, this.profileRendering();

                  case 15:
                    return a.big = e.sent, r.removeAttribute("style"), e.abrupt("return", a);

                  case 18:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "profileRendering",
        value: function () {
          var e = o()(i.a.mark(function e() {
            var t, n, r, a, o, s, c, l, d, u, f, h, p, v, g, m, b, w, M, S, C, R, D, I, P, B;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = this.viewer, n = this.model, r = {}, a = function a(e) {
                      return {
                        fps: T(e)
                      };
                    }, o = 3e3, t.fitCameraToModel(n, 0), e.next = 7, E()(300);

                  case 7:
                    return t._startProfiler(), e.next = 10, E()(o);

                  case 10:
                    return s = t._stopProfiler(), r.static = a(s), c = n.getBoundingBox(), l = new x.THREE.Sphere(), c.getBoundingSphere(l), d = l.center, u = 1.5 * l.radius, f = new x.THREE.Vector3(), h = {
                      angle: 0
                    }, p = {
                      angle: 2 * Math.PI
                    }, e.next = 22, E()(300);

                  case 22:
                    return t._startProfiler(), v = function v() {
                      f.x = Math.cos(h.angle) * u, f.z = Math.sin(h.angle) * u, f.y = 0, f.add(d), t.setCameraPosition(f, d);
                    }, g = Object(y.tweenPromiseWrapper)(h, p, o, _.a.Easing.Linear.None, v), m = g.tweenPromise, e.next = 27, m;

                  case 27:
                    return b = t._stopProfiler(), r.spinning = a(b), w = l.center, M = 1.5 * l.radius, S = new x.THREE.Vector3(), C = {
                      x: w.x - .5 * M,
                      y: w.y,
                      z: w.z
                    }, R = {
                      x: w.x,
                      y: w.y,
                      z: w.z
                    }, e.next = 36, E()(300);

                  case 36:
                    return t._startProfiler(), D = function D() {
                      S.set(C.x, C.y, C.z), w.copy(S), w.x += 100, t.setCameraPosition(S, w);
                    }, I = Object(y.tweenPromiseWrapper)(C, R, o, _.a.Easing.Linear.None, D), P = I.tweenPromise, e.next = 41, P;

                  case 41:
                    return B = t._stopProfiler(), r.inside = a(B), e.abrupt("return", r);

                  case 44:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }]), e;
    }();
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/objectSpread");
  }, function (e, t) {
    e.exports = require("mouse-event-offset");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(5));

    t.tweenPromiseWrapper = function (e, t, n, r, a) {
      var o = new i.default.Tween(e),
          s = new Promise(function (e) {
        o.to(t, n).easing(r).onUpdate(a).onComplete(e).start();
      });
      return {
        tween: o,
        tweenPromise: s
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        i,
        a = n(0),
        o = n(17),
        s = n(37),
        c = n(74),
        l = {},
        d = {};

    function u(e, t) {
      var n = t.replace(/^[ \t]*#import +<([\w\d.\/]+)>/gm, function (e, t) {
        if (void 0 === d[t]) throw new Error("Can not resolve #import <" + t + ">");
        return d[t];
      });
      a.THREE.ShaderChunk[e] = n;
    }

    function f(e, t) {
      if (function (e) {
        if (e in l) return l[e];
        var t = new a.THREE.WebGLRenderer(),
            n = t.domElement.getContext("webgl");
        return l[e] = !!n && null != n.getExtension(e), t.dispose(), l[e];
      }(e)) {
        if ("EXT_frag_depth" === e) return t.extensions.fragDepth = !0, !0;
        throw Error("Error in MaterialManager.js: tried to add unsupported extension " + e);
      }

      return !1;
    }

    r = "cognite_write_to_depth", i = n(38), d[r] = i;
    var h = {
      vertex: ".vert",
      pars_vertex: "_pars.vert",
      fragment: ".frag",
      pars_fragment: "_pars.frag",
      glsl: ".glsl",
      pars_glsl: "_pars.glsl"
    };

    function p(e, t, n) {
      return e.replace(t, n);
    }

    function v(e, t) {
      var n = t.vertex,
          r = void 0 === n ? {} : n,
          i = t.fragment,
          a = void 0 === i ? {} : i;
      [!0, !1].forEach(function (t) {
        var n = t ? r : a,
            i = e[t ? "vertexShader" : "fragmentShader"];
        Object.keys(n).forEach(function (e) {
          var t, r;
          null != n[e].after ? (t = i, r = "#include <" + n[e].after + ">", i = p(t, r, r + "\n" + ("// BEGIN " + e + "\n#include <" + e + ">\n// END " + e + "\n"))) : null != n[e].before ? i = function (e, t, n) {
            return p(e, t, n + "\n" + t);
          }(i, "#include <" + n[e].before + ">", "// BEGIN " + e + "\n#include <" + e + ">\n// END " + e + "\n") : !0 === n[e].remove && (i = function (e, t) {
            return p(e, t, "");
          }(i, "#include <" + e + ">"));
        }), e[t ? "vertexShader" : "fragmentShader"] = i;
      });
    }

    function g(e, t, n, r) {
      !function (e) {
        v(e, {
          vertex: {
            cognite_treeIndex_pars_vertex: {
              after: "common"
            }
          }
        });
      }(t), function (e, t) {
        var n = "";
        Object.keys(t).forEach(function (r) {
          var i = t[r],
              a = i.getTexture();
          e.uniforms.dataTextureWidth = {
            value: i.width
          }, e.uniforms.dataTextureHeight = {
            value: i.height
          }, e.uniforms[i.name] = {
            value: a
          }, n += "uniform sampler2D " + i.name + ";\n";
        }), u("cognite_data_textures", n), v(e, {
          vertex: {
            cognite_data_pars_vertex: {
              after: "common"
            },
            cognite_inverseMatrices_pars_vertex: {
              after: "cognite_data_pars_vertex"
            },
            cognite_data_textures: {
              after: "cognite_inverseMatrices_pars_vertex"
            },
            cognite_data_unpack_glsl: {
              after: "cognite_data_textures"
            },
            cognite_data_pack_glsl: {
              after: "cognite_data_unpack_glsl"
            },
            cognite_data_vertex: {
              before: "uv_vertex"
            },
            cognite_color_vertex: {
              after: "cognite_data_vertex"
            }
          },
          fragment: {
            cognite_data_pars_fragment: {
              after: "common"
            },
            cognite_data_textures: {
              after: "cognite_data_pars_fragment"
            },
            cognite_data_unpack_glsl: {
              after: "cognite_data_textures"
            },
            cognite_data_pack_glsl: {
              after: "cognite_data_unpack_glsl"
            },
            cognite_color_fragment: {
              after: "map_fragment"
            }
          }
        });
      }(t, n), v(t, {
        vertex: {
          cognite_clamp_glsl: {
            before: "common"
          },
          cognite_displaceVertex_pars_vertex: {
            after: "cognite_treeIndex_pars_vertex"
          },
          cognite_hideNode_pars_vertex: {
            after: "cognite_clamp_glsl"
          },
          cognite_hideNode_vertex: {
            after: "cognite_color_vertex"
          },
          cognite_displaceVertex_vertex: {
            before: "project_vertex"
          }
        }
      }), function (e) {
        v(e, {
          vertex: {
            cognite_selectNode_pars_vertex: {
              after: "common"
            },
            cognite_selectNode_vertex: {
              before: "project_vertex"
            }
          }
        }), e.uniforms.renderSelectedNodes = {
          value: !0
        }, e.uniforms.renderOnlySelectedNodes = {
          value: !1
        };
      }(t), function (e) {
        v(e, {
          vertex: {
            cognite_nodePick_vertex: {
              after: "fog_vertex"
            }
          },
          fragment: {
            cognite_nodePick_fragment: {
              after: "fog_fragment"
            }
          }
        });
      }(t), function (e, t) {
        t || v(e, {
          vertex: {
            cognite_slicingPlanes_pars_vertex: {
              after: "clipping_planes_pars_vertex"
            },
            cognite_slicingPlanes_vertex: {
              after: "clipping_planes_vertex"
            }
          },
          fragment: {
            cognite_slicingPlanes_pars_fragment: {
              after: "clipping_planes_pars_fragment"
            },
            cognite_slicingPlanes_fragment: {
              after: "clipping_planes_fragment"
            }
          }
        });
        v(e, {
          vertex: {
            clipping_planes_pars_vertex: {
              remove: !0
            },
            clipping_planes_vertex: {
              remove: !0
            }
          },
          fragment: {
            cognite_isSliced_fragment: {
              after: "clipping_planes_pars_fragment"
            },
            clipping_planes_fragment: {
              remove: !0
            }
          }
        });
      }(t, r), Object.assign(t.uniforms, e.uniforms), e.uniforms = t.uniforms;
    }

    [{
      name: "displaceVertex",
      options: ["vertex", "pars_vertex"],
      path: "base"
    }, {
      name: "clamp",
      options: ["glsl"],
      path: "optional"
    }, {
      name: "color",
      options: ["vertex", "fragment"],
      path: "base"
    }, {
      name: "data",
      options: ["vertex", "pars_vertex", "pars_fragment"],
      path: "base"
    }, {
      name: "data_pack",
      options: ["glsl"],
      path: "optional"
    }, {
      name: "data_unpack",
      options: ["glsl"],
      path: "optional"
    }, {
      name: "debug",
      options: ["pars_glsl"],
      path: "geometries/debug"
    }, {
      name: "hideNode",
      options: ["vertex", "pars_vertex"],
      path: "base"
    }, {
      name: "isSliced",
      options: ["fragment"],
      path: "base"
    }, {
      name: "makePerpendicular",
      options: ["glsl"],
      path: "optional"
    }, {
      name: "mul3",
      options: ["glsl"],
      path: "optional"
    }, {
      name: "nodePick",
      options: ["vertex", "fragment"],
      path: "base"
    }, {
      name: "selectNode",
      options: ["vertex", "pars_vertex"],
      path: "base"
    }, {
      name: "slicingPlanes",
      options: ["vertex", "pars_vertex", "fragment", "pars_fragment"],
      path: "optional"
    }, {
      name: "transformMatrix",
      options: ["vertex", "pars_vertex"],
      path: "base"
    }, {
      name: "transformNormal",
      options: ["vertex"],
      path: "base"
    }, {
      name: "treeIndex",
      options: ["pars_vertex"],
      path: "base"
    }, {
      name: "inverseMatrices",
      options: ["pars_vertex"],
      path: "optional"
    }].forEach(function (e) {
      var t = e.name,
          r = e.path;
      e.options.forEach(function (e) {
        u("cognite_" + t + "_" + e, n(75)("./" + r + "/" + t + h[e]));
      });
    }), [{
      name: "circle",
      hasFrag: !0
    }, {
      name: "eccentricCone",
      hasFrag: !0
    }, {
      name: "ellipsoid",
      hasFrag: !0
    }, {
      name: "generalCylinder",
      hasFrag: !0
    }, {
      name: "generalRing",
      hasFrag: !0
    }, {
      name: "torus"
    }, {
      name: "trapezium"
    }].forEach(function (e) {
      var t = e.name,
          r = e.hasFrag;
      u("cognite_" + t + "_vertex", n(105)("./" + t + "/" + t + ".vert")), u("cognite_" + t + "_pars_vertex", n(106)("./" + t + "/" + t + "_pars.vert")), r && (u("cognite_" + t + "_fragment", n(107)("./" + t + "/" + t + ".frag")), u("cognite_" + t + "_pars_fragment", n(108)("./" + t + "/" + t + "_pars.frag")));
    });
    var m = {
      Instance: {
        side: c.Side.DoubleIfSlicingEnabled,
        flatShading: !0,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_transformMatrix_pars_vertex: {
              after: "common"
            },
            cognite_transformMatrix_vertex: {
              after: "begin_vertex"
            },
            cognite_transformNormal_vertex: {
              after: "defaultnormal_vertex"
            }
          }
        }
      },
      Circle: {
        side: c.Side.Double,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_transformMatrix_pars_vertex: {
              after: "common"
            },
            cognite_transformMatrix_vertex: {
              after: "begin_vertex"
            },
            cognite_transformNormal_vertex: {
              after: "defaultnormal_vertex"
            },
            cognite_circle_pars_vertex: {
              after: "common"
            },
            cognite_circle_vertex: {
              before: "defaultnormal_vertex"
            }
          },
          fragment: {
            cognite_circle_pars_fragment: {
              after: "common"
            },
            cognite_circle_fragment: {
              after: "fog_fragment"
            }
          }
        }
      },
      Cone: {
        side: c.Side.Single,
        extensions: ["EXT_frag_depth"],
        isBillboarded: !0,
        shader: {
          vertex: {
            cognite_generalCylinder_pars_vertex: {
              after: "common"
            },
            cognite_mul3_glsl: {
              after: "cognite_generalCylinder_pars_vertex"
            },
            cognite_generalCylinder_vertex: {
              before: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          },
          fragment: {
            cognite_generalCylinder_pars_fragment: {
              after: "common"
            },
            cognite_generalCylinder_fragment: {
              after: "normal_fragment_maps"
            }
          }
        },
        defines: ["COGNITE_CONE"]
      },
      GeneralCylinder: {
        side: c.Side.Single,
        extensions: ["EXT_frag_depth"],
        isBillboarded: !0,
        shader: {
          vertex: {
            cognite_generalCylinder_pars_vertex: {
              after: "common"
            },
            cognite_mul3_glsl: {
              after: "cognite_generalCylinder_pars_vertex"
            },
            cognite_generalCylinder_vertex: {
              before: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          },
          fragment: {
            cognite_generalCylinder_pars_fragment: {
              after: "common"
            },
            cognite_generalCylinder_fragment: {
              after: "normal_fragment_maps"
            }
          }
        },
        defines: ["COGNITE_GENERAL_CYLINDER"]
      },
      EccentricCone: {
        side: c.Side.Single,
        extensions: ["EXT_frag_depth"],
        isBillboarded: !0,
        shader: {
          vertex: {
            cognite_eccentricCone_pars_vertex: {
              after: "common"
            },
            cognite_mul3_glsl: {
              after: "cognite_eccentricCone_pars_vertex"
            },
            cognite_eccentricCone_vertex: {
              before: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          },
          fragment: {
            cognite_eccentricCone_pars_fragment: {
              after: "common"
            },
            cognite_eccentricCone_fragment: {
              after: "normal_fragment_maps"
            }
          }
        }
      },
      GeneralRing: {
        side: c.Side.Double,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_transformMatrix_pars_vertex: {
              after: "common"
            },
            cognite_transformMatrix_vertex: {
              after: "begin_vertex"
            },
            cognite_transformNormal_vertex: {
              after: "defaultnormal_vertex"
            },
            cognite_generalRing_pars_vertex: {
              after: "common"
            },
            cognite_generalRing_vertex: {
              before: "defaultnormal_vertex"
            }
          },
          fragment: {
            cognite_generalRing_pars_fragment: {
              after: "common"
            },
            cognite_generalRing_fragment: {
              after: "fog_fragment"
            }
          }
        }
      },
      EllipsoidSegment: {
        side: c.Side.Single,
        extensions: ["EXT_frag_depth"],
        isBillboarded: !0,
        shader: {
          vertex: {
            cognite_ellipsoid_pars_vertex: {
              after: "common"
            },
            cognite_mul3_glsl: {
              after: "cognite_ellipsoid_pars_vertex"
            },
            cognite_makePerpendicular_glsl: {
              after: "common"
            },
            cognite_ellipsoid_vertex: {
              before: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          },
          fragment: {
            cognite_ellipsoid_pars_fragment: {
              after: "common"
            },
            cognite_ellipsoid_fragment: {
              after: "normal_fragment_maps"
            }
          }
        }
      },
      Trapezium: {
        side: c.Side.DoubleIfSlicingEnabled,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_trapezium_pars_vertex: {
              after: "common"
            },
            cognite_trapezium_vertex: {
              before: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          }
        }
      },
      TorusSegment: {
        side: c.Side.Double,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_transformMatrix_pars_vertex: {
              after: "common"
            },
            cognite_torus_pars_vertex: {
              after: "common"
            },
            cognite_torus_vertex: {
              before: "defaultnormal_vertex"
            },
            cognite_transformNormal_vertex: {
              after: "defaultnormal_vertex"
            },
            begin_vertex: {
              remove: !0
            }
          }
        }
      },
      Mesh: {
        side: c.Side.Double,
        flatShading: !0,
        isBillboarded: !1
      },
      InstancedMesh: {
        side: c.Side.Double,
        flatShading: !0,
        isBillboarded: !1,
        shader: {
          vertex: {
            cognite_transformMatrix_pars_vertex: {
              after: "common"
            },
            cognite_transformMatrix_vertex: {
              after: "begin_vertex"
            },
            cognite_transformNormal_vertex: {
              after: "defaultnormal_vertex"
            }
          }
        }
      }
    };
    t.generateMaterial = function (e, t) {
      var n = m[e];
      if (void 0 === n || -1 === o.GeometryTypes.concat("Mesh", "Instance").indexOf(e)) throw Error("Unrecognized material name " + e);
      var r = new c.CogniteMaterial({
        transparent: !1,
        flatShading: !0 === n.flatShading
      }, n.side);
      return function (e) {
        e.uniforms.debug = {
          value: 0
        }, e.uniforms.inverseModelMatrix = {
          value: new a.THREE.Matrix4()
        }, e.uniforms.inverseNormalMatrix = {
          value: new a.THREE.Matrix3()
        };
      }(r), void 0 !== n.extensions && n.extensions.forEach(function (e) {
        f(e, r);
      }), void 0 !== n.uniforms && Object.keys(n.uniforms).forEach(function (e) {
        r.uniforms[e] = n.uniforms[e];
      }), r.onBeforeCompile = function (r) {
        g(this, r, t, n.isBillboarded);
        var i = m[e].shader;
        void 0 !== i && v(r, i);
      }, r.onBeforeCompile.toString = function () {
        return e;
      }, void 0 !== n.defines && n.defines.forEach(function (e) {
        r.defines[e] = "";
      }), r;
    }, t.addDefinitionToMaterial = function (e, t) {
      e.defines[t] = "";
    }, t.removeDefinitionFromMaterial = function (e, t) {
      delete e.defines[t];
    }, t.updateSlicingForMaterial = function (e, t) {
      switch (e.cogniteSide) {
        case c.Side.Single:
        case c.Side.Double:
          break;

        case c.Side.DoubleIfSlicingEnabled:
          e.side = t ? a.THREE.DoubleSide : a.THREE.FrontSide;
          break;

        default:
          s.assertUnreachable(e.cogniteSide);
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.assertUnreachable = function (e) {
      throw new Error("Reached a supposedly unreachable point in code");
    };
  }, function (e, t) {
    e.exports = "#ifdef GL_EXT_frag_depth\n#define COGNITE_WRITE_TO_DEPTH\n// Anders Hafreager comments:\n// Depth value can be calculated by transforming the z-component of the intersection point to projection space.\n// The w-component is also needed to scale projection space into clip space.\n// However, the 4th column of the projection matrix is (0, 0, const, 0), so we can exploit this when computing w-value.\nfloat projected_intersection_z = projectionMatrix[0][2]*p.x + projectionMatrix[1][2]*p.y + projectionMatrix[2][2]*p.z + projectionMatrix[3][2];\n\n// If we want to use orthographic camera, the full w-component is found as\nfloat projected_intersection_w = projectionMatrix[0][3]*p.x + projectionMatrix[1][3]*p.y + projectionMatrix[2][3]*p.z + projectionMatrix[3][3];\n// float projected_intersection_w = projectionMatrix[2][3]*newPoint.z; // Optimized for perspective camera\ngl_FragDepthEXT = ((gl_DepthRange.diff * (projected_intersection_z / projected_intersection_w)) + gl_DepthRange.near + gl_DepthRange.far) * 0.5;\n#endif\n";
  }, function (e, t) {
    e.exports = "float dist = dot(xy, xy);\nif (dist > 0.25)\n  discard;";
  }, function (e, t) {
    e.exports = "xy = vec2(position.x, position.y);";
  }, function (e, t) {
    e.exports = "if (debug == 1.0) {\n  gl_FragColor = vec4(normal, 1.0);\n  return;\n}";
  }, function (e, t) {
    e.exports = "mat3 basis = mat3(U.xyz, V.xyz, axis.xyz);\nvec3 surfacePoint = vec3(U.w, V.w, axis.w);\nvec3 rayTarget = surfacePoint;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 rayDirection = vec3(0.0, 0.0, -1.0);\n#else\n  vec3 rayDirection = normalize(rayTarget); // rayOrigin is (0,0,0) in camera space\n#endif\n\nvec3 diff = rayTarget - v_centerA.xyz;\nvec3 E = diff * basis;\nfloat L = height;\nvec3 D = rayDirection * basis;\n\nfloat R1 = v_centerA.w;\nfloat R2 = v_centerB.w;\nfloat dR = R2 - R1;\n\nfloat a = dot(D.xy, D.xy);\nfloat b = dot(E.xy, D.xy);\nfloat c = dot(E.xy, E.xy)-R1*R1;\nfloat L2Inv = 1.0/(L*L);\n\nif (R1 != R2) {\n  // Additional terms if radii are different\n  float dRLInv = dR/L;\n  float dRdRL2Inv = dRLInv*dRLInv;\n  a -= D.z*D.z*dRdRL2Inv;\n  b -= dRLInv*(E.z*D.z*dRLInv + R1*D.z);\n  c -= dRLInv*(E.z*E.z*dRLInv + 2.0*R1*E.z);\n}\n\n// Additional terms when one of the center points is displaced orthogonal to normal vector\nvec2 displacement = ((v_centerB.xyz-v_centerA.xyz)*basis).xy; // In the basis where displacement is in XY only\nfloat displacementLengthSquared = dot(displacement, displacement);\na += D.z*(D.z*displacementLengthSquared - 2.0*L*dot(D.xy, displacement))*L2Inv;\nb += (D.z*E.z*displacementLengthSquared - L*(D.x*E.z*displacement.x + D.y*E.z*displacement.y + D.z*E.x*displacement.x + D.z*E.y*displacement.y))*L2Inv;\nc += E.z*(E.z*displacementLengthSquared - 2.*L*dot(E.xy, displacement))*L2Inv;\n\n// Calculate a dicriminant of the above quadratic equation (factor 2 removed from all b-terms above)\nfloat d = b*b - a*c;\n\n// d < 0.0 means the ray hits outside an infinitely long eccentric cone\nif (d < 0.0) {\n  discard;\n}\nfloat sqrtd = sqrt(d);\nfloat dist1 = (-b - sqrtd)/a;\nfloat dist2 = (-b + sqrtd)/a;\n\n// Make sure dist1 is the smaller one\nif (dist2 < dist1) {\n  float tmp = dist1;\n  dist1 = dist2;\n  dist2 = tmp;\n}\n\n// Check the smallest root, it is closest camera. Only test if the z-component is outside the truncated eccentric cone\nfloat dist = dist1;\nfloat intersectionPointZ = E.z + dist*D.z;\n// Intersection point in camera space\nvec3 p = rayTarget + dist*rayDirection;\n\nif (\n  intersectionPointZ <= 0.0 ||\n  intersectionPointZ >= L\n#if NUM_CLIPPING_PLANES > 0\n  || isSliced(p)\n#endif\n  ) {\n  // Either intersection point is behind starting point (happens inside the cone),\n  // or the intersection point is outside the end caps. This is not a valid solution.\n  dist = dist2;\n  intersectionPointZ = E.z + dist*D.z;\n  p = rayTarget + dist*rayDirection;\n\n  if (\n    intersectionPointZ <= 0.0 ||\n    intersectionPointZ >= L\n#if NUM_CLIPPING_PLANES > 0\n    || isSliced(p)\n#endif\n  ) {\n    // Missed the other point too\n    discard;\n  }\n}\n\n#import <cognite_write_to_depth>\n\n#if !defined(COGNITE_RENDER_COLOR_ID) && !defined(COGNITE_RENDER_DEPTH)\n// Find normal vector\nvec3 n = normalize(-axis.xyz);\nvec3 v_centerA = v_centerA.xyz;\nvec3 v_centerB = v_centerB.xyz;\nvec3 A = cross(v_centerA - p, v_centerB - p);\n\nvec3 t = normalize(cross(n, A));\nvec3 o1 = v_centerA + R1 * t;\nvec3 o2 = v_centerB + R2 * t;\nvec3 B = o2-o1;\nnormal = normalize(cross(A, B));\n#endif\n";
  }, function (e, t) {
    e.exports = "vec3 lDir;\nheight = dot(a_centerA - a_centerB, a_normal);\nvec3 center = 0.5 * (a_centerA + a_centerB);\nvec3 newPosition = position;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 objectToCameraModelSpace = inverseNormalMatrix*vec3(0.0, 0.0, 1.0);\n#else\n  vec3 rayOrigin = (inverseModelMatrix * vec4(cameraPosition, 1.0)).xyz;\n  vec3 objectToCameraModelSpace = rayOrigin - center;\n#endif\n\n\n// Find the coordinates of centerA and centerB projected down to the end cap plane\nvec3 maxCenterProjected = a_centerA - dot(a_centerA, a_normal)*a_normal;\nvec3 minCenterProjected = a_centerB - dot(a_centerB, a_normal)*a_normal;\nfloat distanceBetweenProjectedCenters = length(maxCenterProjected - minCenterProjected);\n\nlDir = a_normal;\nfloat dirSign = 1.0;\nif (dot(objectToCameraModelSpace, lDir) < 0.0) { // direction vector looks away, flip it\n  dirSign = -1.0;\n  lDir *= -1.;  \n}\n\nvec3 left = normalize(cross(objectToCameraModelSpace, lDir));\nvec3 up = normalize(cross(left, lDir));\n\n// compute basis for cone\naxis.xyz = -a_normal;\nU.xyz = cross(objectToCameraModelSpace, axis.xyz);\nV.xyz = cross(U.xyz, axis.xyz);\n// Transform to camera space\naxis.xyz = normalize(normalMatrix * axis.xyz);\nU.xyz = normalize(normalMatrix * U.xyz);\nV.xyz = normalize(normalMatrix * V.xyz);\n\n#ifndef GL_EXT_frag_depth\n// make sure the billboard will not overlap with cap geometry (flickering effect), not important if we write to depth buffer\nnewPosition.x *= 1.0 - (a_radiusA * (position.x + 1.0) * 0.0025 / height);\n#endif\n\nv_centerA.xyz = mul3(modelViewMatrix, a_centerA);\nv_centerB.xyz = mul3(modelViewMatrix, a_centerB);\n// Pack radii as w components of v_centerA and v_centerB\nv_centerA.w = displaceScalar(a_centerA, a_radiusA);\nv_centerB.w = displaceScalar(a_centerB, a_radiusB);\n\nfloat radiusIncludedDisplacement = 0.5*(2.0*max(a_radiusA, a_radiusB) + distanceBetweenProjectedCenters);\nvec3 surfacePoint = center + mat3(0.5*height*lDir, radiusIncludedDisplacement*left, radiusIncludedDisplacement*up) * newPosition;\nvec3 transformed = surfacePoint;\n\n// We pack radii as w-components of coneTop and coneBase\nsurfacePoint = mul3(modelViewMatrix, surfacePoint);\n \n // We pack surfacePoint as w-components of U, V and axis\nU.w = surfacePoint.x;\nV.w = surfacePoint.y;\naxis.w = surfacePoint.z;";
  }, function (e, t) {
    e.exports = "float vRadius = center.w;\nfloat ratio = vRadius / hRadius;\nmat3 basis = mat3(U.xyz, V.xyz, sphereNormal.xyz);\nmat3 scaledBasis = mat3(ratio * U.xyz, ratio * V.xyz, sphereNormal.xyz);\nvec3 surfacePoint = vec3(U.w, V.w, sphereNormal.w);\nvec3 rayTarget = surfacePoint;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 rayDirection = vec3(0.0, 0.0, -1.0);\n#else\n  vec3 rayDirection = normalize(rayTarget); // rayOrigin is (0,0,0) in camera space\n#endif\n\nvec3 diff = rayTarget - center.xyz;\nvec3 E = diff * scaledBasis;\nvec3 D = rayDirection * scaledBasis;\n\nfloat a = dot(D, D);\nfloat b = dot(E, D);\nfloat c = dot(E, E) - vRadius*vRadius;\n\n// discriminant of sphere equation (factor 2 removed from b above)\nfloat d = b*b - a*c;\nif(d < 0.0)\n  discard;\n\nfloat sqrtd = sqrt(d);\nfloat dist1 = (-b - sqrtd)/a;\nfloat dist2 = (-b + sqrtd)/a;\n\n// Make sure dist1 is the smaller one\nif (dist2 < dist1) {\n  float tmp = dist1;\n  dist1 = dist2;\n  dist2 = tmp;\n}\n\nfloat dist = dist1;\nfloat intersectionPointZ = E.z + dist*D.z;\n// Intersection point in camera space\nvec3 p = rayTarget + dist*rayDirection;\n\nif (\n  intersectionPointZ <= vRadius - height ||\n  intersectionPointZ > vRadius\n#if NUM_CLIPPING_PLANES > 0\n  || isSliced(p)\n#endif\n  ) {\n  // Missed the first point, check the other point\n  \n  dist = dist2;\n  intersectionPointZ = E.z + dist*D.z;\n  p = rayTarget + dist*rayDirection;\n  if (\n    intersectionPointZ <= vRadius - height ||\n    intersectionPointZ > vRadius\n#if NUM_CLIPPING_PLANES > 0\n    || isSliced(p)\n#endif\n  ) {\n    // Missed the other point too\n    discard;\n  }\n}\n\n#import <cognite_write_to_depth>\n\n#if !defined(COGNITE_RENDER_COLOR_ID) && !defined(COGNITE_RENDER_DEPTH)\n// Find normal vector in local space\nnormal = vec3(p - center.xyz) * basis;\nnormal.z = normal.z * (hRadius / vRadius) * (hRadius / vRadius);\n// Transform into camera space\nnormal = normalize(basis * normal);\nif (dot(normal, rayDirection) >  0.) {\n  normal = -normal;\n}\n#endif\n";
  }, function (e, t) {
    e.exports = "vec3 lDir;\nfloat distanceToCenterOfSegment = a_vRadius - a_height*0.5;\nvec3 centerOfSegment = a_center + a_normal*distanceToCenterOfSegment;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 objectToCameraModelSpace = inverseNormalMatrix*vec3(0.0, 0.0, 1.0);\n#else\n  vec3 rayOrigin = (inverseModelMatrix * vec4(cameraPosition, 1.0)).xyz;\n  vec3 objectToCameraModelSpace = rayOrigin - centerOfSegment;\n#endif\n\nvec3 newPosition = position;\n\nfloat bb = dot(objectToCameraModelSpace, a_normal);\nif (bb < 0.0) { // direction vector looks away, flip it\n  lDir = -a_normal;\n} else { // direction vector already looks in my direction\n  lDir = a_normal;\n}\n\nvec3 left = normalize(cross(objectToCameraModelSpace, lDir));\nvec3 up = normalize(cross(left, lDir));\n\n#ifndef GL_EXT_frag_depth\n// make sure the billboard will not overlap with cap geometry (flickering effect), not important if we write to depth buffer\nnewPosition.x *= 1.0 - (a_vRadius * (position.x + 1.0) * 0.0025 / a_height);\n#endif\n\n// Negative angle means height larger than radius,\n// so we should have full size so we can render the largest part of the ellipsoid segment\nfloat ratio = max(0.0, 1.0 - a_height / a_vRadius);\n// maxRadiusOfSegment is the radius of the circle (projected ellipsoid) when ellipsoid segment is seen from above\nfloat maxRadiusOfSegment = a_hRadius * sqrt(1.0 - ratio * ratio);\n\nvec3 displacement = vec3(newPosition.x*a_height*0.5, maxRadiusOfSegment*newPosition.y, maxRadiusOfSegment*newPosition.z);\nvec3 surfacePoint = centerOfSegment + mat3(lDir, left, up) * displacement;\nvec3 transformed = surfacePoint;\n\nsurfacePoint = mul3(modelViewMatrix, surfacePoint);\ncenter.xyz = mul3(modelViewMatrix, a_center);\ncenter.w = a_vRadius; // Pack radius into w-component\nhRadius = a_hRadius;\nheight = a_height;\n\n// compute basis\nsphereNormal.xyz = normalMatrix * a_normal;\nU.xyz = normalMatrix * up;\nV.xyz = normalMatrix * left;\n\n// We pack surfacePoint as w-components of U, V and axis\nU.w = surfacePoint.x;\nV.w = surfacePoint.y;\nsphereNormal.w = surfacePoint.z;\n";
  }, function (e, t) {
    e.exports = "float R1 = v_centerB.w;\nvec4 U = v_U;\nvec4 W = v_W;\n#if defined (COGNITE_GENERAL_CYLINDER)\n  vec4 V = vec4(normalize(cross(W.xyz, U.xyz)), v_surfacePointY);\n#endif\n\n#if defined (COGNITE_CONE)\n  vec4 V = v_V;\n  float height = length(v_centerA.xyz - v_centerB.xyz);\n  float R2 = v_centerA.w;\n  float dR = R2 - R1;\n#endif\n\nmat3 basis = mat3(U.xyz, V.xyz, W.xyz);\nvec3 surfacePoint = vec3(U.w, V.w, W.w);\nvec3 rayTarget = surfacePoint;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 rayDirection = vec3(0.0, 0.0, -1.0);\n#else\n  vec3 rayDirection = normalize(rayTarget); // rayOrigin is (0,0,0) in camera space\n#endif\n\nvec3 diff = rayTarget - v_centerB.xyz;\nvec3 E = diff * basis;\nvec3 D = rayDirection * basis;\n\nfloat a = dot(D.xy, D.xy);\nfloat b = dot(E.xy, D.xy);\nfloat c = dot(E.xy, E.xy) - R1*R1;\n\n#if defined (COGNITE_CONE)\n  if (R1 != R2) {\n    // Additional terms if radii are different\n    float dRLInv = dR / height;\n    float dRdRL2Inv = dRLInv * dRLInv;\n    a -= D.z * D.z * dRdRL2Inv;\n    b -= dRLInv * (E.z * D.z * dRLInv + R1 * D.z);\n    c -= dRLInv * (E.z * E.z * dRLInv + 2.0 * R1 * E.z);\n  }\n#endif\n\n// Calculate a dicriminant of the above quadratic equation\nfloat d = b*b - a*c;\n\n// d < 0.0 means the ray hits outside an infinitely long cone\nif (d < 0.0)\n  discard;\n\nfloat sqrtd = sqrt(d);\nfloat dist1 = (-b - sqrtd)/a;\nfloat dist2 = (-b + sqrtd)/a;\n\n// Make sure dist1 is the smaller one\nif (dist2 < dist1) {\n  float tmp = dist1;\n  dist1 = dist2;\n  dist2 = tmp;\n}\n\nfloat dist = dist1;\nvec3 intersectionPoint = E + dist * D;\nfloat theta = atan(intersectionPoint.y, intersectionPoint.x);\nif (theta < v_angle) theta += 2.0 * PI;\n\n// Intersection point in camera space\nvec3 p = rayTarget + dist*rayDirection;\n\n#if defined (COGNITE_CONE)\n  if (\n    intersectionPoint.z <= 0.0 ||\n    intersectionPoint.z > height ||\n    theta > v_angle + v_arcAngle\n#if NUM_CLIPPING_PLANES > 0\n    || isSliced(p)\n#endif\n  ) {\n    // Missed the first point, check the other point\n    \n    dist = dist2;\n    intersectionPoint = E + dist * D;\n    theta = atan(intersectionPoint.y, intersectionPoint.x);\n    p = rayTarget + dist*rayDirection;\n    if (theta < v_angle) theta += 2.0 * PI;\n    if (\n      intersectionPoint.z <= 0.0 ||\n      intersectionPoint.z > height ||\n      theta > v_angle + v_arcAngle\n#if NUM_CLIPPING_PLANES > 0\n      || isSliced(p)\n#endif\n    ) {\n      // Missed the other point too\n      discard;\n    }\n  }\n#endif\n\n#if defined (COGNITE_GENERAL_CYLINDER)\n  vec3 planeACenter = vec3(0.0, 0.0, v_planeA.w);\n  vec3 planeANormal = v_planeA.xyz;\n  vec3 planeBCenter = vec3(0.0, 0.0, v_planeB.w);\n  vec3 planeBNormal = v_planeB.xyz;\n\n  if (\n    dot(intersectionPoint - planeACenter, planeANormal) > 0.0 ||\n    dot(intersectionPoint - planeBCenter, planeBNormal) > 0.0 ||\n    theta > v_arcAngle + v_angle\n#if NUM_CLIPPING_PLANES > 0\n    || isSliced(p)\n#endif\n  ) {\n    // Missed the first point, check the other point\n    dist = dist2;\n    intersectionPoint = E + dist * D;\n    theta = atan(intersectionPoint.y, intersectionPoint.x);\n    p = rayTarget + dist*rayDirection;\n    if (theta < v_angle) theta += 2.0 * PI;\n    if (\n      dot(intersectionPoint - planeACenter, planeANormal) > 0.0 ||\n      dot(intersectionPoint - planeBCenter, planeBNormal) > 0.0 ||\n      theta > v_arcAngle + v_angle\n#if NUM_CLIPPING_PLANES > 0\n      || isSliced(p)\n#endif\n    ) {\n      // Missed the other point too\n      discard;\n    }\n  }\n#endif\n\n#import <cognite_write_to_depth>\n\n#if !defined(COGNITE_RENDER_COLOR_ID) && !defined(COGNITE_RENDER_DEPTH)\n  #if defined (COGNITE_CONE)\n    if (R1 != R2)\n    {\n      // Find normal vector\n      vec3 n = -normalize(W.xyz);\n      vec3 P1 = v_centerB.xyz;\n      vec3 P2 = v_centerA.xyz;\n      vec3 A = cross(P1 - p, P2 - p);\n\n      vec3 t = normalize(cross(n, A));\n      vec3 o1 = P1 + R1 * t;\n      vec3 o2 = P2 + R2 * t;\n      vec3 B = o2-o1;\n      normal = normalize(cross(A, B));\n    }\n    else\n  #endif\n    {\n      // Regular cylinder has simpler normal vector in camera space\n      vec3 p_local = p - v_centerB.xyz;\n      normal = normalize(p_local - W.xyz * dot(p_local, W.xyz));\n    }\n#endif\n";
  }, function (e, t) {
    e.exports = "vec3 center = 0.5 * (a_centerA + a_centerB);\nfloat halfHeight = 0.5 * length(a_centerA - a_centerB);\nvec3 dir = normalize(a_centerA - a_centerB);\nvec3 newPosition = position;\n\n#if defined(COGNITE_ORTHOGRAPHIC_CAMERA)\n  vec3 objectToCameraModelSpace = inverseNormalMatrix*vec3(0.0, 0.0, 1.0);\n#else\n  vec3 rayOrigin = (inverseModelMatrix * vec4(cameraPosition, 1.0)).xyz;\n  vec3 objectToCameraModelSpace = rayOrigin - center;\n#endif\n\n#if defined (COGNITE_CONE)\n  float maxRadius = max(a_radiusA, a_radiusB);\n#elif defined (COGNITE_GENERAL_CYLINDER)\n  float maxRadius = a_radiusA;\n#endif\nfloat leftUpScale = maxRadius;\n\nvec3 lDir = dir;\nif (dot(objectToCameraModelSpace, dir) < 0.0) { // direction vector looks away, flip it\n  lDir = -lDir;\n}\n\nvec3 left = normalize(cross(objectToCameraModelSpace, lDir));\nvec3 up = normalize(cross(left, lDir));\n\n#ifndef GL_EXT_frag_depth\n// make sure the billboard will not overlap with cap geometry (flickering effect), not important if we write to depth buffer\nnewPosition.x *= 1.0 - (maxRadius * (position.x + 1.0) * 0.0025 / halfHeight);\n#endif\n\nvec3 surfacePoint = center + mat3(halfHeight*lDir, leftUpScale*left, leftUpScale*up) * newPosition;\nvec3 transformed = surfacePoint;\nsurfacePoint = mul3(modelViewMatrix, surfacePoint);\n\n// varying data\nv_angle = a_angle;\nv_arcAngle = a_arcAngle;\n\n// compute basis for cone\nv_W.xyz = dir;\nv_U.xyz = a_localXAxis;\nv_W.xyz = normalize(normalMatrix * v_W.xyz);\nv_U.xyz = normalize(normalMatrix * v_U.xyz);\n// We pack surfacePoint as w-components of U and W\nv_W.w = surfacePoint.z;\nv_U.w = surfacePoint.x;\n\n// We pack radii as w-components of v_centerB\nv_centerB.xyz = mul3(modelViewMatrix, a_centerB);\nv_centerB.w = displaceScalar(a_centerB, a_radiusB);\n\n#if defined (COGNITE_CONE)\n  v_V.xyz = -cross(v_U.xyz, v_W.xyz);\n  v_V.w = surfacePoint.y;\n\n  v_centerA.xyz = mul3(modelViewMatrix, a_centerA);\n  v_centerA.w = displaceScalar(a_centerA, a_radiusA);\n#endif\n\n#if defined (COGNITE_GENERAL_CYLINDER)\n  v_planeA = a_planeA;\n  v_planeB = a_planeB;\n  v_surfacePointY = surfacePoint.y;\n\n  v_centerB.w = a_radiusA;\n#endif\n";
  }, function (e, t) {
    e.exports = "float dist = dot(v_xy, v_xy);\nfloat theta = atan(v_xy.y, v_xy.x);\nif (theta < v_angle) theta += 2.0 * PI;\nif (\n  dist > 0.25 ||\n  dist < 0.25 * v_oneMinusThicknessSqr ||\n  theta >= v_angle + v_arcAngle\n)\n  discard;\n";
  }, function (e, t) {
    e.exports = "v_oneMinusThicknessSqr = (1.0 - a_thickness) * (1.0 - a_thickness);\nv_xy = vec2(position.x, position.y);\nv_angle = a_angle;\nv_arcAngle = a_arcAngle;\n";
  }, function (e, t) {
    e.exports = "// normalized theta and phi are packed into positions\nfloat theta = position.x * a_arcAngle;\nfloat phi = position.y;\nfloat cosTheta = cos(theta);\nfloat sinTheta = sin(theta);\nvec3 pos3 = vec3(0);\n\npos3.x = (a_radius + a_tubeRadius*cos(phi)) * cosTheta;\npos3.y = (a_radius + a_tubeRadius*cos(phi)) * sinTheta;\npos3.z = a_tubeRadius*sin(phi);\nvec3 transformed = (getInstanceMatrix() * vec4(pos3, 1.0)).xyz;\n\n// Calculate normal vectors if we're not picking\n#if !defined(FLAT_SHADED) && !defined(COGNITE_RENDER_COLOR_ID) && !defined(COGNITE_RENDER_DEPTH)\n  vec3 center = vec3(a_radius * cosTheta, a_radius * sinTheta, 0.0);\n  objectNormal = normalize(pos3 - center);\n#endif";
  }, function (e, t) {
    e.exports = "vec3 transformed;\n// reduce the avarage branchings\nif (position.x < 1.5) {\n  transformed = position.x == 0.0 ? a_vertex1 : a_vertex2;\n} else {\n  transformed = position.x == 2.0 ? a_vertex3 : a_vertex4;\n}\n\nobjectNormal = cross(a_vertex1 - a_vertex2, a_vertex1 - a_vertex3);\n";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0);

    var i = function () {
      function e(e, t, n) {
        this.name = e, this._onChange = n;
        var i,
            a,
            o = (i = t + 10, a = Math.ceil(Math.log2(i)) / 2, {
          width: Math.pow(2, Math.ceil(a)),
          height: Math.pow(2, Math.floor(a))
        }),
            s = o.width,
            c = o.height;
        this.width = s, this.height = c;
        var l = new Uint8Array(4 * s * c);
        this._texture = new r.THREE.DataTexture(l, s, c, r.THREE.RGBAFormat), this._texture.needsUpdate = !0;
      }

      return e.rgbaFromValue = function (e, t) {
        t || (e *= 255);
        var n = e >= 0 ? 255 : 127;
        return e = Math.abs(e), {
          r: Math.floor(e / 65025),
          g: Math.floor(e / 255) % 255,
          b: e % 255,
          a: n
        };
      }, e.valueFromRgba = function (e, t, n, r, i) {
        var a = 255 * e * 255 + 255 * t + n;
        return r < 255 && (a *= -1), i ? a : a / 255;
      }, e.rgbaFromDistanceFloat = function (e) {
        return {
          r: Math.floor(255 * e),
          g: Math.floor(255 * e * 255) % 255,
          b: Math.floor(255 * e * 255 * 255) % 255,
          a: 255
        };
      }, e.distanceFloatFromRgba = function (e, t, n, r) {
        return e / 255 + t / 65025 + n / 16581375;
      }, e.prototype.dispose = function () {
        this._texture.dispose();
      }, e.prototype.getRGBA = function (e) {
        var t = 4 * e;
        return {
          r: this._texture.image.data[t++],
          g: this._texture.image.data[t++],
          b: this._texture.image.data[t++],
          a: this._texture.image.data[t++]
        };
      }, e.prototype.setRGBA = function (e, t, n, r, i) {
        void 0 === i && (i = 255);
        var a = 4 * e;
        this._texture.image.data[a++] = t, this._texture.image.data[a++] = n, this._texture.image.data[a++] = r, this._texture.image.data[a++] = i, this._texture.needsUpdate = !0, this._onChange();
      }, e.prototype.getFloat = function (t) {
        var n = this.getRGBA(t),
            r = n.r,
            i = n.g,
            a = n.b,
            o = n.a;
        return e.valueFromRgba(r, i, a, o, !1);
      }, e.prototype.setFloat = function (t, n) {
        var r = e.rgbaFromValue(n, !1),
            i = r.r,
            a = r.g,
            o = r.b,
            s = r.a;
        this.setRGBA(t, i, a, o, s);
      }, e.prototype.getInteger = function (t) {
        var n = this.getRGBA(t),
            r = n.r,
            i = n.g,
            a = n.b,
            o = n.a;
        return e.valueFromRgba(r, i, a, o, !0);
      }, e.prototype.setInteger = function (t, n) {
        var r = e.rgbaFromValue(n, !0),
            i = r.r,
            a = r.g,
            o = r.b,
            s = r.a;
        this.setRGBA(t, i, a, o, s);
      }, e.prototype.getTexture = function () {
        return this._texture;
      }, e;
    }();

    t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.extractGeometryPart = function (e, t, n) {
      for (var r = 3 * n, i = 3 * t, a = i + r, o = 1 / 0, s = -1, c = e.getIndex(), l = i; l < a; l++) {
        (u = c.array[l]) < o && (o = u), u > s && (s = u);
      }

      var d = new Uint32Array(r);

      for (l = 0; l < r; l++) {
        var u = c.array[i + l];
        d[l] = u - o;
      }

      for (var f = e.getAttribute("position"), h = new Float32Array(3 * (s - o + 1)), p = (l = o, 0); l <= s; l++) {
        h[p++] = f.getX(l), h[p++] = f.getY(l), h[p++] = f.getZ(l);
      }

      return {
        index: d,
        position: h
      };
    };
  }, function (e, t) {
    e.exports = require("@cognite/three-combo-controls");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, a) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            a(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            a(e);
          }
        }

        function c(e) {
          e.done ? i(e.value) : new n(function (t) {
            t(e.value);
          }).then(o, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          a,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
        return this;
      }), a;

      function s(a) {
        return function (s) {
          return function (a) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;

                switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                  case 0:
                  case 1:
                    i = a;
                    break;

                  case 4:
                    return o.label++, {
                      value: a[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = a[1], a = [0];
                    continue;

                  case 7:
                    a = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === a[0] || 2 === a[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                      o.label = a[1];
                      break;
                    }

                    if (6 === a[0] && o.label < i[1]) {
                      o.label = i[1], i = a;
                      break;
                    }

                    if (i && o.label < i[2]) {
                      o.label = i[2], o.ops.push(a);
                      break;
                    }

                    i[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                a = t.call(e, o);
              } catch (e) {
                a = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & a[0]) throw a[1];
            return {
              value: a[0] ? a[1] : void 0,
              done: !0
            };
          }([a, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(0),
        o = n(64),
        s = n(65),
        c = n(66),
        l = n(67),
        d = n(68),
        u = n(69),
        f = n(70);

    function h(e) {
      var t = new a.THREE.Scene(),
          n = new a.THREE.ShaderMaterial({
        uniforms: e.uniforms,
        vertexShader: e.vertexShader,
        fragmentShader: e.fragmentShader,
        depthWrite: !1
      }),
          r = new a.THREE.Mesh(new a.THREE.PlaneBufferGeometry(2, 2), n);
      return r.frustumCulled = !1, t.add(r), t;
    }

    function p(e) {
      return new Promise(function (t) {
        e.toBlob(function (e) {
          return t(null != e ? e : void 0);
        });
      });
    }

    var v = new a.THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1),
        g = function () {
      function e(e) {
        var t = e.alpha,
            n = e.highlightColor;
        this.alpha = t, this.highlightColor = n, this.renderer = new a.THREE.WebGLRenderer({
          alpha: t
        }), this.modelTarget = new a.THREE.WebGLRenderTarget(0, 0), this.modelTarget.depthBuffer = !0, this.modelTarget.depthTexture = new a.THREE.DepthTexture(0, 0), this.modelTarget.depthTexture.type = a.THREE.UnsignedIntType, this.selectedTarget = new a.THREE.WebGLRenderTarget(0, 0), this.selectedTarget.depthBuffer = !0, this.selectedTarget.stencilBuffer = !1, this.screenshotTarget = new a.THREE.WebGLRenderTarget(0, 0), this.screenshotTarget.depthBuffer = !1, this.screenshotTarget.stencilBuffer = !1, this.rttTarget = new a.THREE.WebGLRenderTarget(0, 0), this.ssaoTarget = new a.THREE.WebGLRenderTarget(0, 0), this.ssaoTarget.depthBuffer = !1, this.ssaoTarget.stencilBuffer = !1, this.ssaoFinalTarget = new a.THREE.WebGLRenderTarget(0, 0), this.ssaoFinalTarget.depthBuffer = !1, this.ssaoFinalTarget.stencilBuffer = !1, this.GUIScene = new a.THREE.Scene();
        var r = this.createRTTScene(),
            i = r.scene,
            o = r.uniforms;
        this.rttScene = i, this.rttUniforms = o;
        var s = this.createAntialiasScene(),
            c = s.scene,
            l = s.uniforms;
        this.antiAliasScene = c, this.antiAliasUniforms = l;
        var d = this.createSSAOScene(),
            u = d.scene,
            f = d.uniforms;
        this.ssaoScene = u, this.ssaoUniforms = f;
        var h = this.createSSAOFinalScene(),
            p = h.scene,
            v = h.uniforms;
        this.ssaoFinalScene = p, this.ssaoFinalUniforms = v, this.onBeforeModelRender = function () {}, this.onBeforeSelectRender = function () {}, this.onAfterRender = function () {};
      }

      return e.prototype.dispose = function () {
        this.renderer.dispose(), this.modelTarget.depthTexture.dispose(), this.modelTarget.dispose(), this.selectedTarget.dispose(), this.screenshotTarget.dispose(), this.rttTarget.dispose(), this.ssaoTarget.dispose(), this.ssaoFinalTarget.dispose();
      }, e.prototype.addGUIComponent = function (e) {
        this.GUIScene.add(e);
      }, e.prototype.createRTTScene = function () {
        var e = {
          tBase: {
            value: this.modelTarget.texture
          },
          tSelected: {
            value: this.selectedTarget.texture
          },
          texelSize: {
            value: new a.THREE.Vector2()
          },
          uHighlightColor: {
            value: this.highlightColor
          }
        };
        return {
          scene: h({
            uniforms: e,
            vertexShader: o,
            fragmentShader: s
          }),
          uniforms: e
        };
      }, e.prototype.createAntialiasScene = function () {
        var e = {
          tDiffuse: {
            value: this.ssaoFinalTarget.texture
          },
          resolution: {
            value: new a.THREE.Vector2()
          }
        };
        return {
          scene: h({
            uniforms: e,
            vertexShader: c,
            fragmentShader: l
          }),
          uniforms: e
        };
      }, e.prototype.createSSAOScene = function () {
        var e = {
          tDiffuse: {
            value: this.rttTarget.texture
          },
          tDepth: {
            value: this.modelTarget.depthTexture
          },
          size: {
            value: new a.THREE.Vector2()
          },
          cameraNear: {
            value: 0
          },
          cameraFar: {
            value: 0
          },
          radius: {
            value: 6
          },
          onlyAO: {
            value: !0
          },
          aoClamp: {
            value: .25
          },
          lumInfluence: {
            value: .7
          }
        };
        return {
          scene: h({
            uniforms: e,
            vertexShader: d,
            fragmentShader: u
          }),
          uniforms: e
        };
      }, e.prototype.createSSAOFinalScene = function () {
        var e = {
          tDiffuse: {
            value: this.rttTarget.texture
          },
          ssaoTexture: {
            value: this.ssaoTarget.texture
          },
          size: {
            value: new a.THREE.Vector2()
          }
        };
        return {
          scene: h({
            uniforms: e,
            vertexShader: d,
            fragmentShader: f
          }),
          uniforms: e
        };
      }, e.prototype.setSize = function (e, t) {
        this.renderer.setSize(e, t, !1), this.modelTarget.setSize(e, t), this.selectedTarget.setSize(e, t), this.screenshotTarget.setSize(e, t), this.rttTarget.setSize(e, t), this.rttUniforms.texelSize.value.set(1.75 / e, 1.75 / t), this.antiAliasUniforms.resolution.value.set(e, t);
        var n = Math.floor(.5 * e),
            r = Math.floor(.5 * t);
        this.ssaoTarget.setSize(n, r), this.ssaoUniforms.size.value.set(e, t), this.ssaoFinalTarget.setSize(e, t), this.ssaoFinalUniforms.size.value.set(e, t);
      }, e.prototype.getSize = function () {
        return this.renderer.getSize();
      }, e.prototype.getScreenshot = function (e, t, n, a) {
        return void 0 === n && (n = this.getSize().width), void 0 === a && (a = this.getSize().height), r(this, void 0, void 0, function () {
          var r, o, s, c, l, d, u, f, h, v, g;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                for (r = this.getSize(), o = r.width, s = r.height, this.setSize(n, a), (c = document.createElement("canvas")).width = n, c.height = a, l = c.getContext("2d"), d = l.createImageData(n, 1), u = new Uint8Array(4 * n), this.render(e, t, this.screenshotTarget), f = 0; f < a; f++) {
                  if (this.renderer.readRenderTargetPixels(this.screenshotTarget, 0, f, n, 1, u), !this.alpha) for (h = 0; h < n; h++) {
                    0 === u[v = 4 * h + 3] && (u[v--] = 255, u[v--] = 0, u[v--] = 0, u[v--] = 0);
                  }
                  d.data.set(u), l.putImageData(d, 0, a - 1 - f);
                }

                return this.setSize(o, s), [4, p(c)];

              case 1:
                return g = i.sent(), c.remove(), [2, URL.createObjectURL(g)];
            }
          });
        });
      }, e.prototype.render = function (e, t, n) {
        this.onBeforeModelRender(), this.renderer.render(e, t, this.modelTarget), this.onBeforeSelectRender(), this.renderer.render(e, t, this.selectedTarget), this.renderer.render(this.rttScene, v, this.rttTarget), this.ssaoUniforms.cameraNear.value = t.near, this.ssaoUniforms.cameraFar.value = t.far, this.renderer.render(this.ssaoScene, v, this.ssaoTarget), this.renderer.render(this.ssaoFinalScene, v, this.ssaoFinalTarget), this.renderer.render(this.antiAliasScene, v, n), this.renderer.autoClear = !1, this.renderer.render(this.GUIScene, t), this.renderer.autoClear = !0, this.onAfterRender();
      }, e.prototype.getRawRenderer = function () {
        return this.renderer;
      }, e;
    }();

    t.default = g;
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/slicedToArray");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(0),
        i = function () {
      function e(e) {
        var t = this;
        this._camera = e, this.needsRedraw = !0, this._lastCameraPosition = new r.THREE.Vector3(), this._lastCameraRotation = new r.THREE.Euler(), this._lastCameraZoom = 0, window.addEventListener("focus", function () {
          t.redraw();
        });
      }

      return e.prototype.update = function () {
        var e = this._camera,
            t = this._lastCameraPosition,
            n = this._lastCameraRotation,
            r = this._lastCameraZoom,
            i = e.position,
            a = e.rotation,
            o = e.zoom,
            s = !i.equals(t) || !a.equals(n) || o !== r;
        t.copy(i), n.copy(a), this._lastCameraZoom = o, s && (this.needsRedraw = !0);
      }, e.prototype.clearNeedsRedraw = function () {
        this.needsRedraw = !1;
      }, e.prototype.redraw = function () {
        this.needsRedraw = !0;
      }, e;
    }();

    t.default = i;
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/typeof");
  }, function (e, t, n) {
    "use strict";

    var _r2,
        i = this && this.__extends || (_r2 = function r(e, t) {
      return (_r2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(0),
        o = n(116),
        s = n(117),
        c = function (e) {
      function t(n) {
        var r = e.call(this, t._createGeometry(), t._createMaterial()) || this;
        return r.onBeforeRender = function (e, t, n, i, o) {
          var s = n,
              c = s instanceof a.THREE.PerspectiveCamera ? s.aspect : s.right / s.top,
              l = o;
          l.uniforms.aspectRatio.value = c, l.uniforms.rotation.value = {
            x: -s.quaternion.x,
            y: -s.quaternion.y,
            z: -s.quaternion.z,
            w: s.quaternion.w
          };
          var d = 2 * (150 / e.domElement.clientHeight - 1),
              u = 2 * (150 / e.domElement.clientWidth - 1);
          l.uniforms.offset.value.y = r._snapBottom ? d : -d, l.uniforms.offset.value.x = r._snapLeft ? u : -u;
        }, r.frustumCulled = !1, r._snapBottom = n.includes("bottom"), r._snapLeft = n.includes("left"), r;
      }

      return i(t, e), t._createGeometry = function () {
        return new a.THREE.BoxGeometry(.15, .15, .15);
      }, t._createMaterial = function () {
        return new a.THREE.ShaderMaterial({
          uniforms: {
            aspectRatio: {
              type: "float",
              value: 1
            },
            rotation: {
              type: "vec4",
              value: new a.THREE.Vector4()
            },
            offset: {
              type: "vec4",
              value: new a.THREE.Vector4()
            }
          },
          vertexShader: o,
          fragmentShader: s
        });
      }, t;
    }(a.THREE.Mesh);

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(n(10)),
        a = n(118),
        o = function () {
      function e() {
        var e = this;
        this.logMetrics = function () {
          if (!(e.fpsData.length < 30)) {
            var t = {};

            if (performance.memory) {
              var n = performance.memory;
              t.memory = {
                usedJSHeapSize: n.usedJSHeapSize / 1048576,
                jsHeapSizeLimit: n.jsHeapSizeLimit / 1048576
              };
            }

            t.fpsMin = a.min(e.fpsData), t.fpsMax = a.max(e.fpsData), t.fpsMean = a.mean(e.fpsData), t.fpsQuantiles = a.quantile(e.fpsData, [.1, .2, .3, .4, .5, .6, .7, .8, .9]), i.track("Stats", "Performance", t), e.fpsData.length = 0;
          }
        }, this.beginTime = 0, this.frames = 0, this.fpsData = [], this.currentFPS = 30, this.active = !1, i.isEnabled() && setInterval(this.logMetrics, 1e4);
      }

      return e.prototype.start = function () {
        this.active ? this.update() : (this.beginTime = performance.now(), this.active = !0, this.frames = 0);
      }, e.prototype.end = function () {
        this.active = !1;
      }, e.prototype.update = function () {
        this.frames++;
        var e = performance.now();
        this.frames < 10 || (this.currentFPS = 1e3 * this.frames / (e - this.beginTime), this.fpsData.push(this.currentFPS), this.frames = 0, this.beginTime = e);
      }, e;
    }();

    t.default = o;
  }, function (e, t) {
    e.exports = require("idb");
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "VERSION", function () {
      return l;
    });
    var r = n(0);
    n.d(t, "THREE", function () {
      return r.THREE;
    });
    var i = n(5),
        a = n.n(i);
    n.d(t, "TWEEN", function () {
      return a.a;
    });
    var o = n(18);
    n.d(t, "Cognite3DViewer", function () {
      return o.a;
    });
    var s = n(16),
        c = n.n(s);
    n.d(t, "Cognite3DModelLoader", function () {
      return c.a;
    });
    var l = "6.0.3";
  },, function (e, t) {
    e.exports = "varying vec2 vUv;\n\n// selection outline\nuniform vec2 texelSize;\nvarying vec2 vUv0;\nvarying vec2 vUv1;\nvarying vec2 vUv2;\nvarying vec2 vUv3;\n\nvoid main() {\n  vUv = uv;\n\n  // selection outline\n  vUv0 = vec2(uv.x + texelSize.x, uv.y);\n\tvUv1 = vec2(uv.x - texelSize.x, uv.y);\n\tvUv2 = vec2(uv.x, uv.y + texelSize.y);\n  vUv3 = vec2(uv.x, uv.y - texelSize.y);\n\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}";
  }, function (e, t) {
    e.exports = "varying vec2 vUv;\n\n// selection outline\nvarying vec2 vUv0;\nvarying vec2 vUv1;\nvarying vec2 vUv2;\nvarying vec2 vUv3;\n\nuniform sampler2D tBase;\nuniform sampler2D tSelected;\nuniform vec3 uHighlightColor;\n\nvoid main() {\n  vec4 t0 = texture2D(tBase, vUv);\n  vec4 t1 = texture2D(tSelected, vUv);\n\n  vec3 highlightColor = uHighlightColor;\n  // blend in a bit of the original color into the highlight color\n  highlightColor.r = 0.8*highlightColor.r + 0.2*highlightColor.r * t1.r;\n  highlightColor.g = 0.8*highlightColor.g + 0.2*highlightColor.g * t1.g;\n  highlightColor.b = 0.8*highlightColor.b + 0.2*highlightColor.b * t1.b;\n\n  t1.rgb = highlightColor;\n  t1.a = min(t1.a, 0.5);\n\n  vec4 c = vec4(t0.a);\n  c.rgb = mix(t0.rgb, t1.rgb, t1.a);\n  \n  gl_FragColor = c;\n\n  float a0 = texture2D(tSelected, vUv0).a;\n  float a1 = texture2D(tSelected, vUv1).a;\n  float a2 = texture2D(tSelected, vUv2).a;\n  float a3 = texture2D(tSelected, vUv3).a;\n  float visibilityFactor = a0 + a1 + a2 + a3;\n\n  // it doesn't have a color itself, but at least one neighbour has\n  if (t1.a == 0.0 && visibilityFactor > 0.0) {\n    gl_FragColor = vec4(1.0);\n  }\n}";
  }, function (e, t) {
    e.exports = "varying vec2 vUv;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\nuniform vec2 resolution;\n\n// https://github.com/mattdesl/three-shader-fxaa\n\nvoid main() {\n  vUv = uv;\n\n  vec2 fragCoord = uv * resolution;\n  vec2 inverseVP = 1.0 / resolution.xy;\n  v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n  v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n  v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n  v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n  v_rgbM = vec2(fragCoord * inverseVP);\n\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}";
  }, function (e, t) {
    e.exports = "varying vec2 vUv;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec2 resolution;\nuniform sampler2D tDiffuse;\n\n#ifndef FXAA_REDUCE_MIN\n    #define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n    #define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n    #define FXAA_SPAN_MAX     8.0\n#endif\n\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n    vec2 v_rgbNW, vec2 v_rgbNE, \n    vec2 v_rgbSW, vec2 v_rgbSE, \n    vec2 v_rgbM) {\n  vec4 color;\n  mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n  vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n  vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n  vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n  vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n  vec4 texColor = texture2D(tex, v_rgbM);\n  vec3 rgbM  = texColor.xyz;\n  vec3 luma = vec3(0.299, 0.587, 0.114);\n  float lumaNW = dot(rgbNW, luma);\n  float lumaNE = dot(rgbNE, luma);\n  float lumaSW = dot(rgbSW, luma);\n  float lumaSE = dot(rgbSE, luma);\n  float lumaM  = dot(rgbM,  luma);\n  float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n  float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n\n  mediump vec2 dir;\n  dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n  dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n\n  float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                  (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n\n  float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n  dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n      max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n      dir * rcpDirMin)) * inverseVP;\n\n  vec4 rgbA = 0.5 * (\n    texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)) +\n    texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)));\n  vec4 rgbB = rgbA * 0.5 + 0.25 * (\n    texture2D(tex, fragCoord * inverseVP + dir * -0.5) +\n    texture2D(tex, fragCoord * inverseVP + dir * 0.5));\n\n  float lumaB = dot(rgbB.rgb, luma);\n  if ((lumaB < lumaMin) || (lumaB > lumaMax)) {\n    color = rgbA;\n  } else {\n    color = rgbB;\n  }\n  return color;\n}\n\nvoid main() {\n  vec2 fragCoord = vUv * resolution;\n  gl_FragColor = fxaa(tDiffuse, fragCoord, resolution, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}";
  }, function (e, t) {
    e.exports = "varying vec2 vUv;\n\nvoid main() {\n  vUv = uv;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}";
  }, function (e, t) {
    e.exports = "uniform float cameraNear;\nuniform float cameraFar;\n#ifdef USE_LOGDEPTHBUF\n  uniform float logDepthBufFC;\n#endif\n\nuniform float radius;    // ao radius\nuniform bool onlyAO;     // use only ambient occlusion pass?\n\nuniform vec2 size;       // texture width, height\nuniform float aoClamp;   // depth clamp - reduces haloing at screen edges\n\nuniform float lumInfluence; // how much luminance affects occlusion\n\nuniform sampler2D tDiffuse;\nuniform highp sampler2D tDepth;\n\nvarying vec2 vUv;\n\n#define DL 2.399963229728653 // PI * ( 3.0 - sqrt( 5.0 ) )\n#define EULER 2.718281828459045\n\n// user variables\n\nconst int samples = 12;   // ao sample count\n\nconst bool useNoise = true;     // use noise instead of pattern for sample dithering\nconst float noiseAmount = 0.0004;// dithering amount\n\nconst float diffArea = 0.4;  // self-shadowing reduction\nconst float gDisplace = 0.4; // gauss bell center\n\n\n// RGBA depth\n\n#include <packing>\n\n// generating noise / pattern texture for dithering\n\nvec2 rand( const vec2 coord ) {\n  vec2 noise;\n  if (useNoise) {\n    float nx = dot(coord, vec2(12.9898, 78.233));\n    float ny = dot(coord, vec2(12.9898, 78.233) * 2.0);\n    noise = clamp(fract ( 43758.5453 * sin( vec2( nx, ny ) ) ), 0.0, 1.0);\n  } else {\n    float ff = fract( 1.0 - coord.s * ( size.x / 2.0 ) );\n    float gg = fract( coord.t * ( size.y / 2.0 ) );\n    noise = vec2( 0.25, 0.75 ) * vec2( ff ) + vec2( 0.75, 0.25 ) * gg;\n  }\n  return ( noise * 2.0  - 1.0 ) * noiseAmount;\n}\n\nfloat readDepth( vec2 coord ) {\n  float fragCoordZ = texture2D( tDepth, coord ).x;\n  float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );\n  return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );\n}\n\nfloat compareDepths( const in float depth1, const in float depth2, inout int far ) {\n  float garea = 8.0;                        // gauss bell width\n  float diff = ( depth1 - depth2 ) * 100.0; // depth difference (0-100)\n\n  // reduce left bell width to avoid self-shadowing\n  if ( diff < gDisplace ) {\n    garea = diffArea;\n  } else {\n    far = 1;\n  }\n\n  float dd = diff - gDisplace;\n  float gauss = pow( EULER, -2.0 * ( dd * dd ) / ( garea * garea ) );\n  return gauss;\n}\n\nfloat calcAO( float depth, float dw, float dh ) {\n  vec2 vv = vec2( dw, dh );\n\n  vec2 coord1 = vUv + radius * vv;\n  vec2 coord2 = vUv - radius * vv;\n\n  float temp1 = 0.0;\n  float temp2 = 0.0;\n\n  int far = 0;\n  temp1 = compareDepths( depth, readDepth( coord1 ), far );\n\n  // DEPTH EXTRAPOLATION\n\n  if (far > 0) {\n    temp2 = compareDepths( readDepth( coord2 ), depth, far );\n    temp1 += ( 1.0 - temp1 ) * temp2;\n  }\n  return temp1;\n}\n\nvoid main() {\n  vec2 noise = rand( vUv );\n  float depth = readDepth( vUv );\n\n  float tt = clamp( depth, aoClamp, 1.0 );\n\n  float w = ( 1.0 / size.x ) / tt + ( noise.x * ( 1.0 - noise.x ) );\n  float h = ( 1.0 / size.y ) / tt + ( noise.y * ( 1.0 - noise.y ) );\n\n  float ao = 0.0;\n\n  float dz = 1.0 / float( samples );\n  float l = 0.0;\n  float z = 1.0 - dz / 2.0;\n\n  for ( int i = 0; i <= samples; i ++ ) {\n    float r = sqrt( 1.0 - z );\n    float pw = cos( l ) * r;\n    float ph = sin( l ) * r;\n    ao += calcAO( depth, pw * w, ph * h );\n    z = z - dz;\n    l = l + DL;\n  }\n\n  ao /= float( samples );\n  ao = 1.0 - ao;\n\n  vec3 color = texture2D( tDiffuse, vUv ).rgb;\n\n  vec3 lumcoeff = vec3( 0.299, 0.587, 0.114 );\n  float lum = dot( color.rgb, lumcoeff );\n  vec3 luminance = vec3( lum );\n\n  vec3 final = vec3( mix( vec3( ao ), vec3( 1.0 ), luminance * lumInfluence ) ); // ambient occlusion only\n  if (!onlyAO) {\n    final = vec3( color * mix( vec3( ao ), vec3( 1.0 ), luminance * lumInfluence ) ); // mix( color * ao, white, luminance )\n  }\n\n  gl_FragColor = vec4( final, 1.0 );\n}";
  }, function (e, t) {
    e.exports = "// Copyright Cognite (C) 2019 Cognite\n//\n// Efficient Gaussian blur based on technique described by Daniel Rákos in\n// http://rastergrid.com/blog/2010/09/efficient-gaussian-blur-with-linear-sampling/\n\nvarying vec2 vUv;\n\nuniform sampler2D tDiffuse;\nuniform sampler2D ssaoTexture;\n\nuniform vec2 size;\n\nconst bool blur = true;\n\nvoid main() {\n  vec3 blurredAO;\n  if (blur) {\n    vec3 result = 0.5 * (\n      2.0 * texture2D(ssaoTexture, vUv).rgb * 0.2270270270 +\n      texture2D(ssaoTexture, vUv + vec2(1.3746153846, 0.0) / size.x).rgb * 0.3162162162 +\n      texture2D(ssaoTexture, vUv + vec2(3.2307692308, 0.0) / size.x).rgb * 0.0702702703 +\n      texture2D(ssaoTexture, vUv - vec2(1.3746153846, 0.0) / size.x).rgb * 0.3162162162 +\n      texture2D(ssaoTexture, vUv - vec2(3.2307692308, 0.0) / size.x).rgb * 0.0702702703 +\n      texture2D(ssaoTexture, vUv + vec2(0.0, 1.3746153846) / size.y).rgb * 0.3162162162 +\n      texture2D(ssaoTexture, vUv + vec2(0.0, 3.2307692308) / size.y).rgb * 0.0702702703 +\n      texture2D(ssaoTexture, vUv - vec2(0.0, 1.3746153846) / size.y).rgb * 0.3162162162 +\n      texture2D(ssaoTexture, vUv - vec2(0.0, 3.2307692308) / size.y).rgb * 0.0702702703\n    );\n    blurredAO = result;\n  } else {\n    blurredAO = texture2D(ssaoTexture, vUv).rgb;\n  }\n  vec4 color = texture2D(tDiffuse, vUv);\n  gl_FragColor = vec4(vec3(color.rgb * blurredAO), color.a);\n}\n";
  }, function (e, t) {
    e.exports = require("mixpanel-browser");
  }, function (e, t, n) {
    "use strict";

    var _r3,
        i = this && this.__extends || (_r3 = function r(e, t) {
      return (_r3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, a) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            a(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            a(e);
          }
        }

        function c(e) {
          e.done ? i(e.value) : new n(function (t) {
            t(e.value);
          }).then(o, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          a,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
        return this;
      }), a;

      function s(a) {
        return function (s) {
          return function (a) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;

                switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                  case 0:
                  case 1:
                    i = a;
                    break;

                  case 4:
                    return o.label++, {
                      value: a[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = a[1], a = [0];
                    continue;

                  case 7:
                    a = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === a[0] || 2 === a[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                      o.label = a[1];
                      break;
                    }

                    if (6 === a[0] && o.label < i[1]) {
                      o.label = i[1], i = a;
                      break;
                    }

                    if (i && o.label < i[2]) {
                      o.label = i[2], o.ops.push(a);
                      break;
                    }

                    i[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                a = t.call(e, o);
              } catch (e) {
                a = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & a[0]) throw a[1];
            return {
              value: a[0] ? a[1] : void 0,
              done: !0
            };
          }([a, s]);
        };
      }
    },
        c = this && this.__values || function (e) {
      var t = "function" == typeof Symbol && e[Symbol.iterator],
          n = 0;
      return t ? t.call(e) : {
        next: function next() {
          return e && n >= e.length && (e = void 0), {
            value: e && e[n++],
            done: !e
          };
        }
      };
    },
        l = this && this.__read || function (e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          i,
          a = n.call(e),
          o = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = a.next()).done;) {
          o.push(r.value);
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = a.return) && n.call(a);
        } finally {
          if (i) throw i.error;
        }
      }

      return o;
    },
        d = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = n(0),
        f = d(n(73)),
        h = d(n(7)),
        p = n(109),
        v = d(n(113)),
        g = n(14),
        m = n(17),
        _ = n(36),
        x = n(6),
        y = d(n(52)),
        b = n(15),
        w = new u.THREE.Matrix4(),
        E = new u.THREE.Matrix4(),
        M = new u.THREE.Matrix3(),
        S = new u.THREE.Matrix3(),
        T = new u.THREE.Box3();

    var C = function C(e, t, n) {
      var r = [],
          i = function i(t, a) {
        var o = t.object3d,
            s = t.children;
        if (null == o) return [];
        R.copy(t.min), D.copy(t.max);
        var c = P;
        c.set(R, D), c.applyMatrix4(n), o.visible = e.intersectsBox(c), o.visible && (r.push({
          sector: t,
          depth: a
        }), null != s && s.forEach(function (e) {
          i(e, a + 1);
        }));
      };

      return i(t, 0), r;
    },
        R = new u.THREE.Vector3(),
        D = new u.THREE.Vector3(),
        I = new u.THREE.Frustum(),
        P = new u.THREE.Box3(),
        B = new u.THREE.Matrix4(),
        z = new u.THREE.Vector3();

    var N = function (e) {
      function t(t, n, r, i, d, N, O, A) {
        var k = e.call(this) || this;
        return k._screenRatioLimit = .025, k.getSubtreeNodeIds = function (e, t) {
          return o(k, void 0, void 0, function () {
            var n, r, i, a;
            return s(this, function (o) {
              switch (o.label) {
                case 0:
                  return null != (n = this._getTreeIndex(e)) && null != t ? [3, 2] : [4, this._getSubtreeSizeAndTreeIndex(e)];

                case 1:
                  r = o.sent(), i = r.subtreeSize, a = r.treeIndex, t = t || i, n = n || a, o.label = 2;

                case 2:
                  return [2, this._getSubtreeNodeIdsFromTreeIndex(n, t)];
              }
            });
          });
        }, k.getBoundingBox = function (e, t) {
          if (void 0 === t && (t = new u.THREE.Box3()), null == e) return t.set(k._rootSector.min, k._rootSector.max), t.applyMatrix4(k.matrix), t;

          var n = k._getTreeIndex(e);

          if (null === n) return t;

          var r = k._treeIndexNodeMap.get(n);

          if (null == r) throw Error("No geometry found for tree index " + n);
          return T.makeEmpty(), r.forEach(function (e) {
            if (e instanceof b.InstancedMeshGroup || e instanceof b.MergedMeshGroup) e.computeBoundingBox(k.matrix, T, n), t.union(T);else if (e instanceof b.PrimitiveGroup) {
              e.treeIndexMap[n].forEach(function (n) {
                e.computeBoundingBox(k.matrix, T, n), t.union(T);
              });
            }
          }), t;
        }, k.iterateNodes = function (e) {
          k._treeIndexNodeIdMap.forEach(function (t) {
            var n = k._nodeIdTreeIndexMap.get(t);

            e(t, n);
          });
        }, k.iterateSubtree = function (e, t, n, r) {
          return o(k, void 0, void 0, function () {
            var i, a, o, c, l;
            return s(this, function (s) {
              switch (s.label) {
                case 0:
                  return this._getNodeProxy(e) ? null != n && null != r ? [3, 2] : [4, this._getSubtreeSizeAndTreeIndex(e)] : [3, 3];

                case 1:
                  i = s.sent(), a = i.subtreeSize, o = i.treeIndex, r = r || a, n = n || o, s.label = 2;

                case 2:
                  for (c = n; c < n + r; c++) {
                    null != (l = this._getNodeId(n)) && t(l, n);
                  }

                  return [2, !0];

                case 3:
                  return [2, !1];
              }
            });
          });
        }, k.getNodeColor = function (e) {
          var t = k._nodeColorTexture.getRGBA(k._getTreeIndex(e));

          return {
            r: t.r,
            g: t.g,
            b: t.b
          };
        }, k.setNodeColor = function (e, t, n, r) {
          var i = k._getNodeAlphaValue(e);

          k._nodeColorTexture.setRGBA(k._getTreeIndex(e), t, n, r, i);
        }, k.resetNodeColor = function (e) {
          var t = k._getTreeIndex(e);

          if (null == t) throw new Error("Unknown nodeId");
          var n = k._colorMap[t];
          k.setNodeColor(e, 255 * n.r, 255 * n.g, 255 * n.b);
        }, k.selectNode = function (e) {
          k._hiddenNodes.has(e) ? console.warn("Hidden nodes cannot be selected") : (k._setNodeAlphaValue(e, 242.25), k._selectedNodes.add(k._getTreeIndex(e)));
        }, k.deselectNode = function (e) {
          k._hiddenNodes.has(e) || (k._setNodeAlphaValue(e, 255), k._selectedNodes.delete(k._getTreeIndex(e)));
        }, k.deselectAllNodes = function () {
          k._selectedNodes.forEach(function (e) {
            k.deselectNode(k._getNodeId(e));
          });
        }, k.showNode = function (e) {
          var t = k._selectedNodes.has(k._getTreeIndex(e));

          k._setNodeAlphaValue(e, t ? 242.25 : 255), k._hiddenNodes.delete(e), k._removePotentiallyGhostedNode(e);
        }, k.showAllNodes = function () {
          k._hiddenNodes.forEach(k.showNode);
        }, k.hideAllNodes = function (e) {
          void 0 === e && (e = !1), k._treeIndexNodeIdMap.forEach(function (t) {
            k.hideNode(t, e);
          });
        }, k.hideNode = function (e, t) {
          void 0 === t && (t = !1), k.deselectNode(e), t ? (k._setNodeAlphaValue(e, 25.5), k._addGhostedNode(e)) : k._setNodeAlphaValue(e, 0), k._hiddenNodes.add(e);
        }, k._dispose = function () {
          var e, t, n, r, i, a, o, s;

          try {
            for (var l = c(k._materialsArray), d = l.next(); !d.done; d = l.next()) {
              d.value.dispose();
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              d && !d.done && (t = l.return) && t.call(l);
            } finally {
              if (e) throw e.error;
            }
          }

          try {
            for (var u = c(k.children), f = u.next(); !f.done; f = u.next()) {
              var h = f.value;
              k.remove(h);
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              f && !f.done && (r = u.return) && r.call(u);
            } finally {
              if (n) throw n.error;
            }
          }

          k._meshLoader.dispose(), k._nodeColorTexture.dispose(), k._modelPicker.dispose();

          try {
            for (var p = c(Object.values(k._sectors)), v = p.next(); !v.done; v = p.next()) {
              var g = v.value;
              if (g.object3d) try {
                for (var m = c(g.object3d.children), _ = m.next(); !_.done; _ = m.next()) {
                  (h = _.value) instanceof x.CogniteBaseMesh && h.dispose();
                }
              } catch (e) {
                o = {
                  error: e
                };
              } finally {
                try {
                  _ && !_.done && (s = m.return) && s.call(m);
                } finally {
                  if (o) throw o.error;
                }
              }
            }
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              v && !v.done && (a = p.return) && a.call(p);
            } finally {
              if (i) throw i.error;
            }
          }
        }, k._calculateMeanIntensity = function () {
          var e = Object.keys(k._colorMap);
          return e.reduce(function (e, t) {
            var n = k._colorMap[parseInt(t, 10)];

            return e + .299 * n.r + .587 * n.g + .114 * n.b;
          }, 0) / e.length;
        }, k._getMeanObjectSize = function () {
          return k._meanObjectSizeData.sum / (k._meanObjectSizeData.count + 1);
        }, k._generateNodeMap = function () {
          var e,
              t,
              n = new Map(),
              r = function r(e, t, _r4) {
            var i = n.get(t);
            void 0 === i ? n.set(t, [_r4]) : -1 === i.indexOf(_r4) && i.push(_r4);
          },
              i = function i(e) {
            var t, n;

            try {
              for (var i = c(e.primitiveGroups), a = i.next(); !a.done; a = i.next()) {
                for (var o = a.value, s = 0; s < o.data.count; s++) {
                  var l = o.getTreeIndex(s);
                  k._treeIndexNodeIdMap[l];
                  r(0, l, o);
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (n = i.return) && n.call(i);
              } finally {
                if (t) throw t.error;
              }
            }

            var d = e.mergedMeshGroup.meshes;
            d.length > 0 && (k._numMeshes += 1), d.forEach(function (t) {
              for (var n = t.mappings, i = 0; i < n.count; i++) {
                var a = n.getTreeIndex(i);
                k._treeIndexNodeIdMap[a];
                r(0, a, e.mergedMeshGroup);
              }
            });
            var u = e.instancedMeshGroup.meshes;
            k._numMeshes += u.length, u.forEach(function (t) {
              for (var n = t.collections, i = 0; i < n.length; i++) {
                for (var a = t.collections[i].mappings, o = 0; o < a.count; o++) {
                  var s = a.getTreeIndex(o);
                  k._treeIndexNodeIdMap[s];
                  r(0, s, e.instancedMeshGroup);
                }
              }
            });
          };

          try {
            for (var a = c(k._rootSector.traverseSectors()), o = a.next(); !o.done; o = a.next()) {
              i(o.value);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              o && !o.done && (t = a.return) && t.call(a);
            } finally {
              if (e) throw e.error;
            }
          }

          return n;
        }, k._createDataTexture = function (e) {
          return new y.default(e, k._treeIndexNodeIdMap.length, function () {
            return k._onChange();
          });
        }, k._createNodeColorTexture = function () {
          var e = k._createDataTexture("colorTexture");

          return Object.keys(k._colorMap).forEach(function (t) {
            var n = parseInt(t, 10),
                r = k._colorMap[n];
            e.setRGBA(n, 255 * r.r, 255 * r.g, 255 * r.b);
          }), e;
        }, k._setupDataTextures = function (e) {
          var t = {};
          return m.GeometryTypes.forEach(function (n) {
            t[n] = {
              colorTexture: e
            };
          }), t;
        }, k._setupMaterials = function (e) {
          return {
            Box: _.generateMaterial("Instance", e.Box),
            Circle: _.generateMaterial("Circle", e.Circle),
            SphericalSegment: _.generateMaterial("EllipsoidSegment", e.SphericalSegment),
            Cone: _.generateMaterial("Cone", e.Cone),
            EccentricCone: _.generateMaterial("EccentricCone", e.EccentricCone),
            EllipsoidSegment: _.generateMaterial("EllipsoidSegment", e.EllipsoidSegment),
            GeneralRing: _.generateMaterial("GeneralRing", e.GeneralRing),
            GeneralCylinder: _.generateMaterial("GeneralCylinder", e.GeneralCylinder),
            InstancedMesh: _.generateMaterial("InstancedMesh", e.InstancedMesh),
            MergedMesh: _.generateMaterial("Mesh", e.MergedMesh),
            Nut: _.generateMaterial("Instance", e.Nut),
            Quad: _.generateMaterial("Instance", e.Quad),
            Trapezium: _.generateMaterial("Trapezium", e.Trapezium),
            TorusSegment: _.generateMaterial("TorusSegment", e.TorusSegment)
          };
        }, k._setupMeshes = function () {
          return o(k, void 0, void 0, function () {
            var e,
                t,
                n,
                r,
                i,
                a,
                o,
                c,
                l = this;
            return s(this, function (s) {
              switch (s.label) {
                case 0:
                  e = function e(_e2) {
                    l._modelPicker.makeObjectPickable(_e2);
                  }, (t = Object.keys(this._sectors)).sort(function (e, t) {
                    return e.length - t.length;
                  }), n = 0, s.label = 1;

                case 1:
                  return n < t.length ? (r = t[n], i = this._sectors[r], p.generatePrimitiveInstances(i, this._materials, this._treeIndexMeshMap, this._meanObjectSizeData), i.object3d.traverse(e), n % 20 != 0 ? [3, 3] : [4, h.default(1)]) : [3, 4];

                case 2:
                  s.sent(), s.label = 3;

                case 3:
                  return n++, [3, 1];

                case 4:
                  return a = this._progress.addNewStep("Loading additional details..."), o = function o(e) {
                    a.increaseProgress(e);
                  }, c = Object.values(this._sectors).reduce(function (e, t) {
                    var n = 0;
                    return t.mergedMeshGroup.meshes.length > 0 && (n += 1), e + (n += t.instancedMeshGroup.meshes.length);
                  }, 0), a.setMax(c), Object.values(this._sectors).forEach(function (t) {
                    t.mergedMeshGroup.meshes.length > 0 && p.generateMergedMeshInstances(t.mergedMeshGroup, l._materials, l._meshLoader, l._treeIndexMeshMap, l._meanObjectSizeData, o, l._geometryFilter).then(function (n) {
                      e(n), n.setBoundingBox(new u.THREE.Box3(t.min, t.max)), t.object3d.add(n);
                    }), t.instancedMeshGroup.meshes.length > 0 && p.generateInstancedMeshInstances(t.instancedMeshGroup, l._materials, l._meshLoader, l._treeIndexMeshMap, l._meanObjectSizeData, o, l._treeIndexNodeMap, l._geometryFilter).then(function (n) {
                      n.forEach(function (n) {
                        e(n), n.setBoundingBox(new u.THREE.Box3(t.min, t.max)), t.object3d.add(n);
                      });
                    });
                  }), [2];
              }
            });
          });
        }, k._updateUniforms = function (e) {
          w.getInverse(k.matrixWorld), E.copy(e.matrixWorldInverse).multiply(k.matrixWorld), M.getNormalMatrix(E), S.getInverse(M), k._materialsArray.forEach(function (e) {
            null != e.uniforms.inverseModelMatrix && e.uniforms.inverseModelMatrix.value.copy(w), null != e.uniforms.inverseNormalMatrix && e.uniforms.inverseNormalMatrix.value.copy(S);
          });
        }, k._update = function (e, t, n) {
          e.matrixWorldNeedsUpdate && e.updateMatrixWorld(!0), k.matrixWorldNeedsUpdate && k.updateMatrixWorld(!0), k._updateUniforms(e), B.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), I.setFromMatrix(B), k._visibleSectors = C(I, k._rootSector, k.matrix).map(function (t) {
            var n,
                r,
                i = P,
                o = t.sector;
            return R.copy(o.min), D.copy(o.max), i.set(R, D), i.applyMatrix4(k.matrix), a({}, t, {
              distanceSquared: (n = i, r = e.position, z.copy(r).clamp(n.min, n.max).sub(r).lengthSq())
            });
          }), k._visibleSectors.forEach(function (t) {
            var n = t.sector,
                r = t.distanceSquared;

            k._updateSectorGeometries(n, Math.sqrt(r), I, e);
          }), null != k._postUpdate && k._postUpdate();
        }, k._updateSectorGeometries = function (e, t, n, r) {
          var i = e.object3d;

          if (i) {
            var a;

            if (r instanceof u.THREE.PerspectiveCamera) {
              var o = k._screenRatioLimit * r.fov * g.degToRadFactor;
              a = Math.tan(o) * t;
            } else a = k._screenRatioLimit * (r.right - r.left + r.top - r.bottom) / (2 * r.zoom);

            var s = e.max.distanceTo(e.min),
                l = 1;
            t > s && (l = Math.min(3, Math.pow(t / s, 1 / 3))), a *= l;

            var d = function d(e) {
              var t = e.getBoundingBox();
              if (null != t && (P.set(t.min, t.max), P.applyMatrix4(k.matrix), !n.intersectsBox(P))) return !1;
              var r = e.getBiggestObjectSize();
              return !(null != r && r < a);
            },
                f = !1;

            i.children.forEach(function (n) {
              var r, i;

              if (n instanceof u.THREE.LOD) {
                var o = n.getObjectForDistance(t);
                n.levels.forEach(function (e) {
                  var t = e.object;
                  if (t instanceof x.CogniteBaseMesh) if (t.hasBeenRendered) {
                    var n = t === o;
                    t.visible = n && d(t);
                  } else t.visible = !0, t.hasBeenRendered = !0, f = !0;
                });
              }

              if (n instanceof x.CogniteBaseMesh && (n.hasBeenRendered ? n.visible = d(n) : (n.visible = !0, n.hasBeenRendered = !0, f = !0)), t < 30 * k._getMeanObjectSize() && (f = !0), e.depth < 2 && (f = !0), n instanceof x.CogniteMergedPolygonMesh) {
                var s = f ? 1 / 0 : n.getDrawTriangleOffset(a);
                n.geometry.setDrawRange(0, s);
              }

              if (n instanceof x.CogniteInstancedPolygonMesh) {
                var l = f ? n.sizes.length : n.getMaxInstancedCount(a);
                n.geometry.maxInstancedCount = l;
              }

              if (n instanceof x.CognitePrimitiveMesh) {
                l = f ? n.sizes.length : n.getMaxInstancedCount(a);
                n.geometry.maxInstancedCount = l;
              }

              if (n instanceof x.CogniteLOD) try {
                for (var h = c(n.children), p = h.next(); !p.done; p = h.next()) {
                  var v = p.value;

                  if (v.visible) {
                    l = f ? v.sizes.length : v.getMaxInstancedCount(a);
                    v.geometry.maxInstancedCount = l;
                  }
                }
              } catch (e) {
                r = {
                  error: e
                };
              } finally {
                try {
                  p && !p.done && (i = h.return) && i.call(h);
                } finally {
                  if (r) throw r.error;
                }
              }
            });
          }
        }, k._getTreeIndicesFromMesh = function (e) {
          return Object.keys(k._treeIndexMeshMap).map(function (e) {
            return parseInt(e, 10);
          }).filter(function (t) {
            return k._treeIndexMeshMap[t].some(function (t) {
              return t === e;
            });
          });
        }, k._getNodeProxy = function (e) {
          var t = k._getTreeIndex(e);

          if (!t) return null;

          var n = k._treeIndexNodeMap.get(t);

          if (null == n || 0 === n.length) return null;
          var r = [];
          return n.forEach(function (e) {
            if (e instanceof b.InstancedMeshGroup || e instanceof b.MergedMeshGroup) r.push({
              group: e
            });else if (e instanceof b.PrimitiveGroup) {
              e.treeIndexMap[t].forEach(function (t) {
                r.push({
                  index: t,
                  group: e,
                  properties: e.data.getPropertiesAsObject(t)
                });
              });
            }
          }), new v.default(e, t, r);
        }, k._getTreeIndex = function (e) {
          var t = k._nodeIdTreeIndexMap.get(e);

          return null != t ? t : null;
        }, k._getNodeId = function (e) {
          var t = k._treeIndexNodeIdMap[e];
          return null != t ? t : null;
        }, k._getSubtreeSizeAndTreeIndex = function (e) {
          return o(k, void 0, void 0, function () {
            var t, n;
            return s(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!this._sdk) throw new Error("Cannot find " + e + " details as sdk:<CogniteClient> was not provided to the Cognite3DViewer");
                  return [4, this._sdk.revisions3D.list3DNodes(this.modelId, this.revisionId, {
                    nodeId: e,
                    limit: 1
                  })];

                case 1:
                  if (0 === (t = r.sent()).items.length) throw new Error("Node with nodeId " + e + " not found");
                  return n = l(t.items, 1), [2, {
                    treeIndex: n[0].treeIndex,
                    subtreeSize: t.items[0].subtreeSize
                  }];
              }
            });
          });
        }, k._getSubtreeNodeIdsFromTreeIndex = function (e, t) {
          return o(k, void 0, void 0, function () {
            var n, r, i, a;
            return s(this, function (o) {
              for (n = [], r = e + t, i = e; i < r; i++) {
                null != (a = this._getNodeId(i)) && n.push(a);
              }

              return [2, n];
            });
          });
        }, k._getIntersectionFromPixel = function (e, t, n, r) {
          var i = t.getRawRenderer(),
              a = k._modelPicker.getIntersectedTreeIndexFromPixel(e, i, n, r);

          if (null == a) return null;

          var o = k._getNodeId(a);

          return null == o ? null : (P.makeEmpty(), k.getBoundingBox(o, P), {
            nodeId: o,
            point: k._modelPicker.getIntersectionFromPixel(e, i, P, k._treeIndexMeshMap[a], n, r)
          });
        }, k._getNodeAlphaValue = function (e) {
          return k._nodeColorTexture.getRGBA(k._getTreeIndex(e)).a;
        }, k._setNodeAlphaValue = function (e, t) {
          var n = k.getNodeColor(e),
              r = n.r,
              i = n.g,
              a = n.b;

          k._nodeColorTexture.setRGBA(k._getTreeIndex(e), r, i, a, t);
        }, k._addGhostedNode = function (e) {
          k._ghostedNodes.add(e), 1 === k._ghostedNodes.size && k._materialsArray.forEach(function (e) {
            e.transparent = !0;
          });
        }, k._removePotentiallyGhostedNode = function (e) {
          k._ghostedNodes.delete(e), 0 === k._ghostedNodes.size && k._materialsArray.forEach(function (e) {
            e.transparent = !1;
          });
        }, k._onlyShowSelectedNodes = function (e) {
          if (void 0 === e && (e = !0), k._materialsArray.forEach(function (t) {
            null == t.uniforms && (t.uniforms = {}), t.uniforms.renderSelectedNodes = {
              value: !0
            }, t.uniforms.renderOnlySelectedNodes = {
              value: e
            };
          }), e) {
            k._rootSector.object3d.traverse(function (e) {
              e.visible = !1;
            });

            var t = k._treeIndexMeshMap;
            k._selectedNodes.forEach(function (e) {
              var n = t[e];
              n && n.forEach(function (e) {
                e instanceof x.CogniteLOD ? e.levels[0].object.visible = !0 : e.visible = !0;
              });
            }), function e(t) {
              var n = t.children;
              0 !== n.length && n.forEach(function (n) {
                e(n), n.visible && (t.visible = !0);
              });
            }(k._rootSector.object3d);
          } else k._rootSector.object3d.traverse(function (e) {
            e.visible = !0;
          });
        }, k._setOrthographicCameraMaterials = function () {
          k._materialsArray.forEach(function (e) {
            _.addDefinitionToMaterial(e, "COGNITE_ORTHOGRAPHIC_CAMERA");
          });
        }, k._updateSlicing = function (e) {
          k._materialsArray.forEach(function (t) {
            _.updateSlicingForMaterial(t, e);
          }), k._modelPicker.updateSlicing(e);
        }, k._onChange = function () {}, k.modelId = t, k.revisionId = n, k._sdk = A.sdk, k._sectors = d.sectors, k._sceneStats = i, k._rootSector = r, k._progress = N, k._geometryFilter = A.geometryFilter, k._meshLoader = O, k._numMeshes = k._sceneStats.geometryCount.InstancedMesh + k._sceneStats.geometryCount.MergedMesh, k._treeIndexNodeIdMap = d.treeIndexNodeIdMap, k._nodeIdTreeIndexMap = d.nodeIdTreeIndexMap, k._colorMap = d.colorMap, k._treeIndexMeshMap = {}, k._nodeColorTexture = k._createNodeColorTexture(), k._meanIntensity = k._calculateMeanIntensity(), k._dataTextures = k._setupDataTextures(k._nodeColorTexture), k._materials = k._setupMaterials(k._dataTextures), k._materialsArray = Object.values(k._materials), !0 === A.orthographicCamera && k._setOrthographicCameraMaterials(), k._treeIndexNodeMap = k._generateNodeMap(), k._meanObjectSizeData = {
          sum: 0,
          count: 0
        }, k._modelPicker = new f.default(k._rootSector), k._selectedNodes = new Set(), k._hiddenNodes = new Set(), k._ghostedNodes = new Set(), k._visibleSectors = [], k.add(k._rootSector.object3d), k._setupMeshes(), k;
      }

      return i(t, e), t;
    }(u.THREE.Object3D);

    t.default = N;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__read || function (e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          i,
          a = n.call(e),
          o = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = a.next()).done;) {
          o.push(r.value);
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = a.return) && n.call(a);
        } finally {
          if (i) throw i.error;
        }
      }

      return o;
    },
        i = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(0),
        o = n(36),
        s = n(6),
        c = i(n(52)),
        l = n(11);

    function d(e, t, n) {
      return 255 * e * 255 + 255 * t + n;
    }

    var u = new a.THREE.Color(1, 1, 1),
        f = d(255 * u.r, 255 * u.g, 255 * u.b),
        h = new a.THREE.Vector3(),
        p = new a.THREE.Quaternion(),
        v = new a.THREE.Vector3(),
        g = (new a.THREE.Box3(), function () {
      function e(e) {
        this._rootSector = e, this._pickScene = new a.THREE.Scene(), this._pickScene.background = u, this._pickObjectWrapper = new a.THREE.Object3D(), this._pickScene.add(this._pickObjectWrapper), this._pickingTexture = new a.THREE.WebGLRenderTarget(0, 0), this._depthScene = new a.THREE.Scene(), this._depthObjectWrapper = new a.THREE.Object3D(), this._depthScene.add(this._depthObjectWrapper), this._depthTexture = new a.THREE.WebGLRenderTarget(0, 0), this._objectParentMap = new Map(), this._pixelBuffer = new Uint8Array(4), this._depthBuffer = new Uint8Array(4), this._cachedMaterials = new Map(), e.object3d.traverse(this.makeObjectPickable.bind(this));
      }

      return e.prototype.dispose = function () {
        this._pickingTexture.dispose(), this._depthTexture.dispose();
      }, e.prototype.makeObjectPickable = function (e) {
        if (e instanceof s.CogniteBaseMesh && null == e.pickMaterial) {
          var t = this._cachedMaterials,
              n = e.standardMaterial;

          if (t.has(n)) {
            var r = t.get(n);
            e.pickMaterial = r.pickMaterial, e.depthMaterial = r.depthMaterial;
          } else e.pickMaterial = n.clone(), o.addDefinitionToMaterial(e.pickMaterial, "COGNITE_RENDER_COLOR_ID"), e.depthMaterial = n.clone(), o.addDefinitionToMaterial(e.depthMaterial, "COGNITE_RENDER_DEPTH"), t.set(n, {
            pickMaterial: e.pickMaterial,
            depthMaterial: e.depthMaterial
          });
        }
      }, e.prototype.getIntersectedTreeIndexFromPixel = function (e, t, n, r) {
        return this._renderToPickTexture(e, t), this._getTreeIndexFromPickTexture(t, n, r);
      }, e.prototype.getIntersectionFromPixel = function (e, t, n, r, i, a) {
        var o = e.near,
            s = e.far;
        !function (e, t) {
          var n = l.calculateNearAndFarDistanceForBoundingBox(e, t),
              r = n.near,
              i = n.far;
          e.near = Math.max(5e-4 * i, r), e.far = i, e.updateProjectionMatrix();
        }(e, n), this._renderToDepthTexture(e, t, r);

        var c = this._getUnprojectedPointFromDepthTexture(e, t, i, a);

        return e.near = o, e.far = s, e.updateProjectionMatrix(), c;
      }, e.prototype.updateSlicing = function (e) {
        this._cachedMaterials.forEach(function (t) {
          o.updateSlicingForMaterial(t.pickMaterial, e), o.updateSlicingForMaterial(t.depthMaterial, e);
        });
      }, e.prototype._renderToPickTexture = function (e, t) {
        var n = this._rootSector.object3d,
            r = n.parent;
        r.getWorldPosition(h), r.getWorldQuaternion(p), r.getWorldScale(v), this._pickObjectWrapper.position.copy(h), this._pickObjectWrapper.rotation.setFromQuaternion(p), this._pickObjectWrapper.scale.copy(v), this._pickObjectWrapper.add(n), n.traverseVisible(function (e) {
          e instanceof s.CogniteBaseMesh && null != e.pickMaterial && (e.material = e.pickMaterial);
        });
        var i = t.getSize(),
            a = i.width,
            o = i.height;
        this._pickingTexture.setSize(a, o), t.render(this._pickScene, e, this._pickingTexture), n.traverseVisible(function (e) {
          e instanceof s.CogniteBaseMesh && (e.material = e.standardMaterial);
        }), r.add(n);
      }, e.prototype._renderToDepthTexture = function (e, t, n) {
        var r = this,
            i = n[0];
        i.getWorldPosition(h), i.getWorldQuaternion(p), i.getWorldScale(v), this._depthObjectWrapper.position.copy(h), this._depthObjectWrapper.rotation.setFromQuaternion(p), this._depthObjectWrapper.scale.copy(v), n.forEach(function (e) {
          r._objectParentMap.has(e) || r._objectParentMap.set(e, e.parent), r._depthObjectWrapper.add(e), e instanceof a.THREE.LOD ? e.children.forEach(function (e) {
            e instanceof s.CogniteBaseMesh && null != e.depthMaterial && (e.material = e.depthMaterial);
          }) : e instanceof s.CogniteBaseMesh && null != e.depthMaterial && (e.material = e.depthMaterial);
        });
        var o = t.getSize(),
            c = o.width,
            l = o.height;
        this._depthTexture.setSize(c, l), t.render(this._depthScene, e, this._depthTexture), n.forEach(function (e) {
          var t = r._objectParentMap.get(e);

          t ? t.add(e) : r._depthObjectWrapper.remove(e), e instanceof a.THREE.LOD ? e.children.forEach(function (e) {
            e instanceof s.CogniteBaseMesh && (e.material = e.standardMaterial);
          }) : e instanceof s.CogniteBaseMesh && (e.material = e.standardMaterial);
        });
      }, e.prototype._getTreeIndexFromPickTexture = function (e, t, n) {
        e.readRenderTargetPixels(this._pickingTexture, t, this._pickingTexture.height - n, 1, 1, this._pixelBuffer);
        var r = d(this._pixelBuffer[0], this._pixelBuffer[1], this._pixelBuffer[2]);
        return r === f ? null : r;
      }, e.prototype._getUnprojectedPointFromDepthTexture = function (e, t, n, i) {
        t.readRenderTargetPixels(this._depthTexture, n, this._depthTexture.height - i, 1, 1, this._depthBuffer);
        var o = r(this._depthBuffer, 4),
            s = o[0],
            l = o[1],
            d = o[2],
            u = o[3],
            f = 2 * c.default.distanceFloatFromRgba(s, l, d, u) - 1,
            h = t.getSize(),
            p = n / h.width * 2 - 1,
            v = i / h.height * -2 + 1;
        return new a.THREE.Vector3(p, v, f).unproject(e);
      }, e;
    }());
    t.default = g;
  }, function (e, t, n) {
    "use strict";

    var _r5,
        i = this && this.__extends || (_r5 = function r(e, t) {
      return (_r5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        s = n(0),
        c = n(37);
    !function (e) {
      e[e.Single = 0] = "Single", e[e.Double = 1] = "Double", e[e.DoubleIfSlicingEnabled = 2] = "DoubleIfSlicingEnabled";
    }(o = t.Side || (t.Side = {}));

    var l = function (e) {
      function t(t, n) {
        var r,
            i = this;
        if (null != n) switch (n) {
          case o.Single:
          case o.DoubleIfSlicingEnabled:
            r = s.THREE.FrontSide;
            break;

          case o.Double:
            r = s.THREE.DoubleSide;
            break;

          default:
            c.assertUnreachable(n);
        }
        return (i = e.call(this, a({}, t, {
          side: r
        })) || this).uniforms = {}, i.extensions = {}, i.defines = {}, i.cogniteSide = n, i;
      }

      return i(t, e), t.prototype.copy = function (e) {
        s.THREE.MeshPhongMaterial.prototype.copy.call(this, e);
        var t = e;
        return this.defines = a({}, t.defines), this.uniforms = t.uniforms, this.onBeforeCompile = t.onBeforeCompile, this.extensions = t.extensions, this.cogniteSide = t.cogniteSide, this;
      }, t.prototype.clone = function () {
        var e = new s.THREE.MeshPhongMaterial();
        return t.prototype.copy.call(e, this), e;
      }, t;
    }(s.THREE.MeshPhongMaterial);

    t.CogniteMaterial = l;
  }, function (e, t, n) {
    var r = {
      "./base/color.frag": 76,
      "./base/color.vert": 77,
      "./base/data.vert": 78,
      "./base/data_pars.frag": 79,
      "./base/data_pars.vert": 80,
      "./base/displaceVertex.vert": 81,
      "./base/displaceVertex_pars.vert": 82,
      "./base/hideNode.vert": 83,
      "./base/hideNode_pars.vert": 84,
      "./base/isSliced.frag": 85,
      "./base/nodePick.frag": 86,
      "./base/nodePick.vert": 87,
      "./base/selectNode.vert": 88,
      "./base/selectNode_pars.vert": 89,
      "./base/transformMatrix.vert": 90,
      "./base/transformMatrix_pars.vert": 91,
      "./base/transformNormal.vert": 92,
      "./base/treeIndex_pars.vert": 93,
      "./geometries/circle/circle.frag": 39,
      "./geometries/circle/circle.vert": 40,
      "./geometries/circle/circle_pars.frag": 19,
      "./geometries/circle/circle_pars.vert": 20,
      "./geometries/debug/color_normal.frag": 41,
      "./geometries/debug/debug_pars.glsl": 94,
      "./geometries/eccentricCone/eccentricCone.frag": 42,
      "./geometries/eccentricCone/eccentricCone.vert": 43,
      "./geometries/eccentricCone/eccentricCone_pars.frag": 21,
      "./geometries/eccentricCone/eccentricCone_pars.vert": 22,
      "./geometries/ellipsoid/ellipsoid.frag": 44,
      "./geometries/ellipsoid/ellipsoid.vert": 45,
      "./geometries/ellipsoid/ellipsoid_pars.frag": 23,
      "./geometries/ellipsoid/ellipsoid_pars.vert": 24,
      "./geometries/generalCylinder/generalCylinder.frag": 46,
      "./geometries/generalCylinder/generalCylinder.vert": 47,
      "./geometries/generalCylinder/generalCylinder_pars.frag": 25,
      "./geometries/generalCylinder/generalCylinder_pars.vert": 26,
      "./geometries/generalRing/generalRing.frag": 48,
      "./geometries/generalRing/generalRing.vert": 49,
      "./geometries/generalRing/generalRing_pars.frag": 27,
      "./geometries/generalRing/generalRing_pars.vert": 28,
      "./geometries/torus/torus.vert": 50,
      "./geometries/torus/torus_pars.vert": 29,
      "./geometries/trapezium/trapezium.vert": 51,
      "./geometries/trapezium/trapezium_pars.vert": 30,
      "./optional/GL_EXT_frag_depth.frag": 38,
      "./optional/clamp.glsl": 95,
      "./optional/data_pack.glsl": 96,
      "./optional/data_unpack.glsl": 97,
      "./optional/inverseMatrices_pars.vert": 98,
      "./optional/makePerpendicular.glsl": 99,
      "./optional/mul3.glsl": 100,
      "./optional/slicingPlanes.frag": 101,
      "./optional/slicingPlanes.vert": 102,
      "./optional/slicingPlanes_pars.frag": 103,
      "./optional/slicingPlanes_pars.vert": 104
    };

    function i(e) {
      var t = a(e);
      return n(t);
    }

    function a(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, e.exports = i, i.id = 75;
  }, function (e, t) {
    e.exports = "vec4 cogniteColor = texture2D(colorTexture, textureIndex);\n\ndiffuseColor.xyz *= cogniteColor.xyz;\nif (cogniteColor.a < 0.2) {\n  // Set ghost color if hideNode(nodeId, ghost = true); is called in js\n  diffuseColor.xyz = vec3(0.2);\n  diffuseColor.a = 0.1;\n}\n";
  }, function (e, t) {
    e.exports = "vec4 nodeColor = texture2D(colorTexture, textureIndex);\n";
  }, function (e, t) {
    e.exports = "float x = mod(treeIndex, dataTextureWidth);\nfloat y = floor(treeIndex / dataTextureWidth);\nfloat xCoord = (x + 0.5) / dataTextureWidth;\nfloat yCoord = (y + 0.5) / dataTextureHeight; // invert Y axis\ntextureIndex = vec2(xCoord, yCoord);\n";
  }, function (e, t) {
    e.exports = "varying vec2 textureIndex;\n";
  }, function (e, t) {
    e.exports = "varying vec2 textureIndex;\nuniform float dataTextureWidth;\nuniform float dataTextureHeight;\n";
  }, function (e, t) {
    e.exports = '// Translate vertex randomly based on treeIndex\n// to avoid flickering of overlapping meshes.\n\n// Create a "seed" based on object size\nvec2 seed = vec2(objectSize, objectSize);\ntransformed = displaceVertex(transformed, seed);\n';
  }, function (e, t) {
    e.exports = 'vec3 displaceVertex(vec3 point, vec2 seed) {\n  // Displace a point based on distance to camera to avoid z-fighting\n  vec3 cameraPositionModelSpace = (inverseModelMatrix * vec4(cameraPosition, 1.0)).xyz;\n  vec3 pointToCamera = cameraPositionModelSpace - point;\n  \n  // "Random" number in the range [0, 1], based on treeIndex and some seed (typically bounding box)\n  float rnd = 0.5 * (rand(seed) + mod(treeIndex, 64.) / 64.);\n  \n  // Compute distance to camera, but cap it\n  float maxDistanceToCamera = 50.;\n  float distanceToCamera = min(length(pointToCamera), maxDistanceToCamera);\n  \n  float maxDisplacement = 0.02;\n  float scaleFactor = 0.02;\n  float displacement = min(maxDisplacement,  scaleFactor * rnd * distanceToCamera / maxDistanceToCamera);\n  return point + normalize(pointToCamera) * displacement;\n}\n\nfloat displaceScalar(vec3 point, float scalar) {\n  // Displaces a scalar based on distance to camera to avoid z-fighting\n  vec3 cameraPositionModelSpace = (inverseModelMatrix * vec4(cameraPosition, 1.0)).xyz;\n  vec3 pointToCamera = cameraPositionModelSpace - point;\n  \n  // "Random" number in the range [0, 1], based on treeIndex\n  float rnd = mod(treeIndex, 64.) / 64.;\n  // Compute distance to camera, but cap it\n  float maxDistanceToCamera = 50.;\n  float distanceToCamera = min(length(pointToCamera), maxDistanceToCamera);\n  \n  float maxDisplacement = 0.01;\n  float scaleFactor = 0.01;\n  float displacement = min(maxDisplacement, scaleFactor * rnd * distanceToCamera / maxDistanceToCamera);\n  return scalar + displacement;\n}\n\nattribute float objectSize;\n';
  }, function (e, t) {
    e.exports = 'if (nodeColor.a < 0.05) {\n  // Node is marked as hidden\n  gl_Position = vec4(hide(), 1.0);\n  return;\n}\n\n#if defined(COGNITE_RENDER_COLOR_ID)\nif (nodeColor.a < 0.2) {\n  // Ghosted nodes should not "block" other clickable objects\n  gl_Position = vec4(hide(), 1.0);\n  return;\n}\n#endif\n';
  }, function (e, t) {
    e.exports = "vec3 hide() {\n  float inf = 1. / 1e-8;\n  return vec3(inf);\n}\n";
  }, function (e, t) {
    e.exports = "#if NUM_CLIPPING_PLANES > 0\nbool isSliced(vec3 point) {\n  vec3 pointFlipped = -point;\n  vec4 plane;\n\n  for (int i = 0; i < NUM_CLIPPING_PLANES; i++) {\n    plane = clippingPlanes[i];\n    if (dot(pointFlipped, plane.xyz) > plane.w) return true;\n  }\n  return false;\n}\n#endif\n";
  }, function (e, t) {
    e.exports = "#if defined(COGNITE_RENDER_COLOR_ID)\n  /**\n   * vViewPosition is a varying reserved by THREE.js Phong shading material.\n   * It's used for lighting calculation to calculate the specular light intensity.\n   * Apparently, we don't need to know the phong color in color picking pass.\n   * So we reuse this varying to pass the color id of objects.\n   * Since on mobile platforms, there are very limited registers to vary\n   * values from vertex shader to fragment shader, so it's a good idea to reuse\n   * the varying as much as we can.\n   */\n  {\n    vec4 cogniteColor = texture2D(colorTexture, textureIndex);\n    if (cogniteColor.a < 0.2) {\n      // If markGray is true, we show nodes that aren't selectable.\n      // White is the color used for missed click.\n      gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);\n    } else {\n      gl_FragColor = vec4(vViewPosition, 1.0);\n    }\n    \n    return;\n  }\n#elif defined(COGNITE_RENDER_DEPTH)\n  #if defined(COGNITE_WRITE_TO_DEPTH)\n    gl_FragColor = packDistanceFloat(gl_FragDepthEXT);\n  #else\n    gl_FragColor = packDistanceFloat(gl_FragCoord.z);\n  #endif\n    return;\n#endif\n";
  }, function (e, t) {
    e.exports = "#if defined(COGNITE_RENDER_COLOR_ID)\n  /**\n   * vViewPosition is a varying reserved by THREE.js Phong shading material.\n   * It's used for lighting calculation to calculate the specular light intensity.\n   * Apparently, we don't need to know the phong color in color picking pass.\n   * So we reuse this varying to pass the color id of objects.\n   * Since on mobile platforms, there are very limited registers to vary\n   * values from vertex shader to fragment shader, so it's a good idea to reuse\n   * the varying as much as we can.\n   */\n  float r = floor(treeIndex / (255.0 * 255.0)) / 255.0;\n  float g = mod(floor(treeIndex / 255.0), 255.0) / 255.0;\n  float b = mod(treeIndex, 255.0) / 255.0;\n  vViewPosition = vec3(r, g, b);\n#endif\n";
  }, function (e, t) {
    e.exports = "bool isSelected = nodeColor.a > 0.9 && nodeColor.a < 0.99;\nif (isSelected && !renderSelectedNodes) {\n  float inf = 1. / 1e-8;\n  transformed = vec3(inf);\n} else if (!isSelected && renderOnlySelectedNodes) {\n  float inf = 1. / 1e-8;\n  transformed = vec3(inf);\n}";
  }, function (e, t) {
    e.exports = "uniform bool renderSelectedNodes;\nuniform bool renderOnlySelectedNodes;";
  }, function (e, t) {
    e.exports = "transformed = (getInstanceMatrix() * vec4(position, 1.0)).xyz;";
  }, function (e, t) {
    e.exports = "attribute vec3 matCol0;\nattribute vec3 matCol1;\nattribute vec3 matCol2;\nattribute vec3 matCol3;\n\nmat4 getInstanceMatrix() {\n  return mat4(\n    matCol0, 0,\n    matCol1, 0,\n    matCol2, 0,\n    matCol3, 1\n  );\n}\n";
  }, function (e, t) {
    e.exports = "transformedNormal = normalMatrix*(getInstanceMatrix() * vec4(objectNormal, 0.0)).xyz;\n";
  }, function (e, t) {
    e.exports = "attribute float treeIndex;";
  }, function (e, t) {
    e.exports = "varying vec3 debug_vector;\nuniform float debug;\n";
  }, function (e, t) {
    e.exports = "vec3 myClamp(vec3 v, vec3 lo, vec3 hi) {\n  float x = max(lo.x, min(hi.x, v.x ) );\n  float y = max(lo.y, min(hi.y, v.y ) );\n  float z = max(lo.z, min(hi.z, v.z ) );\n  return vec3(x,y,z);\n}";
  }, function (e, t) {
    e.exports = "vec4 pack(float value) {\n  // Store sign of value in alpha \n  float a = value < 0.0 ? 0.5 : 1.0;\n  value = abs(value);\n\n  float r = floor(value / (255.0 * 255.0));\n  float g = mod(floor(value / 255.0), 255.0);\n  float b = mod(value, 255.0);\n  \n  return vec4(r, g, b, a);\n}\n\nvec4 packDistanceFloat (float value) {\n  float r = value;\n  float g = mod(value * 255.0, 1.0);\n  float b = mod(value * 255.0 * 255.0, 1.0);\n  float a = 1.0;\n  \n  return vec4(r, g, b, a);\n}\n";
  }, function (e, t) {
    e.exports = "float unpack(vec4 rgba) {\n  float value = (rgba.r * 255. * 255. + rgba.g * 255. + rgba.b);\n  if (rgba.a < 1.0) {\n    return -value;\n  }\n  return value;\n}\n\nfloat unpackDistanceFloat(vec4 rgba) {\n  float value = (rgba.r + rgba.g / 255. + rgba.b / (255. * 255.) + rgba.a / (255. * 255. * 255.));\n  return value;\n}\n\nfloat getDataTextureFloat(sampler2D sampler) {\n  return unpack(texture2D(sampler, textureIndex));\n}\n\nint getDataTextureInt(sampler2D sampler) {\n  return int(unpack(texture2D(sampler, textureIndex)) * 255.);\n}\n";
  }, function (e, t) {
    e.exports = "uniform mat4 inverseModelMatrix;\nuniform mat3 inverseNormalMatrix;\n";
  }, function (e, t) {
    e.exports = "vec3 makePerpendicular(vec3 v) {\n    if(v.x == 0.0 && v.y == 0.0) {\n        if(v.z == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        return vec3(0.0, 1.0, 0.0);\n    }\n    return vec3(-v.y, v.x, 0.0);\n}\n";
  }, function (e, t) {
    e.exports = "vec3 mul3(mat4 M, vec3 v) {\n  vec4 u = M * vec4(v, 1.0);\n  return u.xyz / u.w;\n}\n";
  }, function (e, t) {
    e.exports = "#if NUM_CLIPPING_PLANES > 0\nif (isSliced(position_for_slicing)) {\n    discard;\n}\n#endif\n";
  }, function (e, t) {
    e.exports = "#if NUM_CLIPPING_PLANES > 0\nposition_for_slicing = mvPosition.xyz;\n#endif\n";
  }, function (e, t) {
    e.exports = "// three.js uses vViewPosition for testing slicing planes, but we use vViewPosition for node picking.\n// We therefore define our own varying for this. Note that billboarding shaders already pass the position\n// of the intersection in varyings, so we should not use this shader chunk for those.\n#if NUM_CLIPPING_PLANES > 0\nvarying vec3 position_for_slicing;\n#endif\n";
  }, function (e, t) {
    e.exports = "// three.js uses vViewPosition for testing slicing planes, but we use vViewPosition for node picking.\n// We therefore define our own varying for this. Note that billboarding shaders already pass the position\n// of the intersection in varyings, so we should not use this shader chunk for those.\n#if NUM_CLIPPING_PLANES > 0\nvarying vec3 position_for_slicing;\n#endif\n";
  }, function (e, t, n) {
    var r = {
      "./circle/circle.vert": 40,
      "./circle/circle_pars.vert": 20,
      "./eccentricCone/eccentricCone.vert": 43,
      "./eccentricCone/eccentricCone_pars.vert": 22,
      "./ellipsoid/ellipsoid.vert": 45,
      "./ellipsoid/ellipsoid_pars.vert": 24,
      "./generalCylinder/generalCylinder.vert": 47,
      "./generalCylinder/generalCylinder_pars.vert": 26,
      "./generalRing/generalRing.vert": 49,
      "./generalRing/generalRing_pars.vert": 28,
      "./torus/torus.vert": 50,
      "./torus/torus_pars.vert": 29,
      "./trapezium/trapezium.vert": 51,
      "./trapezium/trapezium_pars.vert": 30
    };

    function i(e) {
      var t = a(e);
      return n(t);
    }

    function a(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, e.exports = i, i.id = 105;
  }, function (e, t, n) {
    var r = {
      "./circle/circle_pars.vert": 20,
      "./eccentricCone/eccentricCone_pars.vert": 22,
      "./ellipsoid/ellipsoid_pars.vert": 24,
      "./generalCylinder/generalCylinder_pars.vert": 26,
      "./generalRing/generalRing_pars.vert": 28,
      "./torus/torus_pars.vert": 29,
      "./trapezium/trapezium_pars.vert": 30
    };

    function i(e) {
      var t = a(e);
      return n(t);
    }

    function a(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, e.exports = i, i.id = 106;
  }, function (e, t, n) {
    var r = {
      "./circle/circle.frag": 39,
      "./circle/circle_pars.frag": 19,
      "./debug/color_normal.frag": 41,
      "./eccentricCone/eccentricCone.frag": 42,
      "./eccentricCone/eccentricCone_pars.frag": 21,
      "./ellipsoid/ellipsoid.frag": 44,
      "./ellipsoid/ellipsoid_pars.frag": 23,
      "./generalCylinder/generalCylinder.frag": 46,
      "./generalCylinder/generalCylinder_pars.frag": 25,
      "./generalRing/generalRing.frag": 48,
      "./generalRing/generalRing_pars.frag": 27
    };

    function i(e) {
      var t = a(e);
      return n(t);
    }

    function a(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, e.exports = i, i.id = 107;
  }, function (e, t, n) {
    var r = {
      "./circle/circle_pars.frag": 19,
      "./eccentricCone/eccentricCone_pars.frag": 21,
      "./ellipsoid/ellipsoid_pars.frag": 23,
      "./generalCylinder/generalCylinder_pars.frag": 25,
      "./generalRing/generalRing_pars.frag": 27
    };

    function i(e) {
      var t = a(e);
      return n(t);
    }

    function a(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = a, e.exports = i, i.id = 108;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (i, a) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            a(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            a(e);
          }
        }

        function c(e) {
          e.done ? i(e.value) : new n(function (t) {
            t(e.value);
          }).then(o, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          i,
          a,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
        return this;
      }), a;

      function s(a) {
        return function (s) {
          return function (a) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;

                switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                  case 0:
                  case 1:
                    i = a;
                    break;

                  case 4:
                    return o.label++, {
                      value: a[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = a[1], a = [0];
                    continue;

                  case 7:
                    a = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === a[0] || 2 === a[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                      o.label = a[1];
                      break;
                    }

                    if (6 === a[0] && o.label < i[1]) {
                      o.label = i[1], i = a;
                      break;
                    }

                    if (i && o.label < i[2]) {
                      o.label = i[2], o.ops.push(a);
                      break;
                    }

                    i[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                a = t.call(e, o);
              } catch (e) {
                a = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & a[0]) throw a[1];
            return {
              value: a[0] ? a[1] : void 0,
              done: !0
            };
          }([a, s]);
        };
      }
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = a(n(110)),
        s = a(n(111)),
        c = a(n(112));

    function l(e, t, n) {
      var r = n[e];
      r ? r.push(t) : n[e] = [t];
    }

    function d(e, t) {
      e.sum += t, e.count++;
    }

    t.generatePrimitiveInstances = function (e, t, n, r) {
      e.primitiveGroups.forEach(function (i) {
        if (i.data.count > 0) {
          i.computeTransformAttributes();
          var a = c.default.createObject3D(i, t[i.type]);
          e.object3d.add(a), Object.keys(i.treeIndexMap).forEach(function (e) {
            l(parseInt(e, 10), a, n);
          });
        }

        for (var o = 0; o < i.data.count; o++) {
          d(r, i.data.arrays.size[o]);
        }
      });
    }, t.generateMergedMeshInstances = function (e, t, n, a, s, c, u) {
      return r(this, void 0, void 0, function () {
        var f,
            h,
            p = this;
        return i(this, function (v) {
          switch (v.label) {
            case 0:
              return [4, Promise.all(e.meshes.map(function (e) {
                return r(p, void 0, void 0, function () {
                  return i(this, function (t) {
                    return [2, n.getGeometry(e.fileId)];
                  });
                });
              }))];

            case 1:
              return f = v.sent(), h = o.default.createObject3D(e, f, t.MergedMesh, u), e.meshes.forEach(function (e) {
                for (var t = 0; t < e.mappings.count; t++) {
                  l(e.mappings.getTreeIndex(t), h, a);
                }
              }), c(1), e.meshes.forEach(function (e) {
                e.mappings.size.forEach(function (e) {
                  d(s, e);
                });
              }), [2, h];
          }
        });
      });
    }, t.generateInstancedMeshInstances = function (e, t, n, a, o, c, u, f) {
      return r(this, void 0, void 0, function () {
        var h,
            p = this;
        return i(this, function (v) {
          switch (v.label) {
            case 0:
              return h = [], [4, Promise.all(e.meshes.map(function (v) {
                return r(p, void 0, void 0, function () {
                  var r;
                  return i(this, function (i) {
                    switch (i.label) {
                      case 0:
                        return [4, n.getGeometry(v.fileId)];

                      case 1:
                        return r = i.sent(), s.default.createObject3D(e, v, r, t.InstancedMesh, u, f).forEach(function (e) {
                          var t = e.mesh,
                              n = e.collection;
                          n.geometry = t.geometry, h.push(t), n.mappings.size.forEach(function (e) {
                            d(o, e);
                          });

                          for (var r = 0; r < n.mappings.count; r++) {
                            l(n.mappings.getTreeIndex(r), t, a);
                          }
                        }), c(1), [2];
                    }
                  });
                });
              }))];

            case 1:
              return v.sent(), [2, h];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(0),
        i = n(6),
        a = n(53),
        o = n(15),
        s = new r.THREE.Vector3(),
        c = new r.THREE.Matrix4(),
        l = new r.THREE.Box3(),
        d = function () {
      function e() {}

      return e.createObject3D = function (e, t, n, a) {
        var c = {};
        e.meshes.forEach(function (e, n) {
          c[n] = {};

          for (var r = 0; r < e.mappings.count; r++) {
            c[n][r] = u(e, r, t[n]);
          }
        });
        var d = 0 === e.meshes[0].mappings.getSize(0);
        (null != a.boundingBox || d) && Object.keys(c).forEach(function (t) {
          Object.keys(c[t]).forEach(function (n) {
            var r = c[t][n].position;
            l.makeEmpty();

            for (var i = 0; i < r.length / 3; i++) {
              s.set(r[3 * i], r[3 * i + 1], r[3 * i + 2]), l.expandByPoint(s);
            }

            if (null == a.boundingBox || a.boundingBox.intersectsBox(l)) {
              if (d) {
                var o = parseInt(t, 10),
                    u = parseInt(n, 10),
                    f = l.min.distanceTo(l.max);
                e.meshes[o].mappings.setSize(f, u);
              }
            } else delete c[t][n];
          });
        });
        var f = 0,
            h = 0;
        Object.keys(c).forEach(function (e) {
          Object.keys(c[e]).forEach(function (t) {
            var n = c[e][t];
            f += n.position.length, h += n.index.length;
          });
        });
        var p = new Float32Array(f),
            v = new Uint32Array(h),
            g = e.meshes.reduce(function (e, t) {
          return e + t.mappings.count;
        }, 0),
            m = new o.MergedMeshMappings(g),
            _ = [];
        Object.keys(c).forEach(function (t) {
          var n = parseInt(t, 10),
              r = e.meshes[n];
          Object.keys(c[n]).forEach(function (e) {
            var t = parseInt(e, 10);

            _.push({
              meshIndex: n,
              mappingIndex: t,
              size: r.mappings.getSize(t)
            });
          });
        }), _.sort(function (e, t) {
          return t.size - e.size;
        });
        var x = 0,
            y = 0;

        _.forEach(function (t) {
          var n = t.meshIndex,
              r = t.mappingIndex,
              i = c[n][r];
          p.set(i.position, x), v.set(i.index, y);

          for (var a = 0; a < i.index.length; a++) {
            v[y + a] += x / 3;
          }

          var o = e.meshes[n].mappings,
              s = y / 3,
              l = o.getTriangleCount(r),
              d = o.getTreeIndex(r),
              u = o.getSize(r);
          m.add(s, l, d, u), x += i.position.length, y += i.index.length;
        });

        var b = new r.THREE.BufferGeometry(),
            w = new r.THREE.BufferAttribute(v, 1, !1),
            E = new r.THREE.BufferAttribute(p, 3, !1);
        b.setIndex(w), b.addAttribute("position", E), function (e, t) {
          if (0 === t.count) return;

          for (var n = e.getAttribute("position").count, i = new Float32Array(n), a = new Float32Array(n), o = e.getIndex().array, s = 0; s < t.count; s++) {
            for (var c = t.getSize(s), l = t.getTreeIndex(s), d = t.getTriangleOffset(s), u = t.getTriangleCount(s), f = 3 * d, h = f + 3 * u, p = f; p < h; p++) {
              var v = o[p];
              a[v] = l, i[v] = c;
            }
          }

          e.addAttribute("treeIndex", new r.THREE.BufferAttribute(a, 1, !1)), e.addAttribute("objectSize", new r.THREE.BufferAttribute(i, 1, !1));
        }(b, m);
        var M = new i.CogniteMergedPolygonMesh(b, n, m.triangleOffsets, m.size);
        M.cogniteType = "MergedMesh";
        var S = new o.MergedMesh(m.capacity, 0);
        S.mappings = m, e.meshes = [S], e.geometry = b, e.createTreeIndexMap();
        var T = m.getSize(0);
        return M.setBiggestObjectSize(T), M;
      }, e;
    }();

    function u(e, t, n) {
      var r = e.mappings.getTriangleOffset(t),
          i = e.mappings.getTriangleCount(t),
          o = a.extractGeometryPart(n, r, i);

      if (e.createdByInstancedMesh) {
        e.mappings.getTransformMatrix(c, t);

        for (var l = o.position, d = 0; d < l.length / 3; d++) {
          s.set(l[3 * d], l[3 * d + 1], l[3 * d + 2]), s.applyMatrix4(c), l[3 * d] = s.x, l[3 * d + 1] = s.y, l[3 * d + 2] = s.z;
        }
      }

      return o;
    }

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        i = n(53),
        a = n(15),
        o = n(6),
        s = n(14),
        c = new r.THREE.Matrix4(),
        l = new r.THREE.Box3();

    function d(e, t, n, i) {
      for (var o = new r.THREE.Box3(), s = t.getIndex(), l = t.getAttribute("position"), d = 0; d < e.mappings.count; d++) {
        e.mappings.getTransformMatrix(c, d), a.computeBoundingBox(o, c, l, s, n, i);
        var u = o.min.distanceTo(o.max);
        e.mappings.setSize(u, d);
      }
    }

    t.calculateMeshSizes = d;

    var u = function () {
      function e() {}

      return e.createObject3D = function (e, t, n, a, c, u) {
        return t.collections.map(function (t) {
          var f = t.triangleOffset,
              h = t.triangleCount,
              p = i.extractGeometryPart(n, f, h),
              v = new r.THREE.BufferAttribute(p.index, 1, !1),
              g = new r.THREE.BufferAttribute(p.position, 3, !1),
              m = new r.THREE.InstancedBufferGeometry();

          if (m.addAttribute("position", g), m.setIndex(v), m.maxInstancedCount = t.mappings.count, m.addAttribute("treeIndex", new r.THREE.InstancedBufferAttribute(t.mappings.treeIndex, 1, !1, 1)), null != u.boundingBox) {
            for (var _ = [], x = 0; x < t.mappings.count; x++) {
              var y = t.mappings.getTreeIndex(x);

              if (e.computeBoundingBox(s.identityMatrix4, l, y, m), !u.boundingBox.intersectsBox(l)) {
                _.push(y);

                var b = c.get(y);
                b.splice(b.indexOf(e), 1);
              }
            }

            e.removeTreeIndicesFromCollection(_, t);
          }

          if (0 !== t.mappings.count) {
            [t.mappings.transform0, t.mappings.transform1, t.mappings.transform2, t.mappings.transform3].forEach(function (e, t) {
              var n = "matCol" + t;
              m.addAttribute(n, new r.THREE.InstancedBufferAttribute(e, 3, !1));
            });
            var w = new o.CogniteInstancedPolygonMesh(m, a, t.mappings.size);
            w.frustumCulled = !1, w.cogniteType = "InstancedMesh", 0 === t.mappings.getSize(0) && d(t, n, f, h);
            var E = t.mappings.size,
                M = new r.THREE.InstancedBufferAttribute(E, 1);
            m.addAttribute("objectSize", M);
            var S = E.reduce(function (e, t) {
              return Math.max(e, t);
            });
            return w.setBiggestObjectSize(S), {
              mesh: w,
              collection: t
            };
          }
        }).filter(function (e) {
          return void 0 !== e;
        });
      }, e;
    }();

    t.default = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        i = n(31),
        a = n(6);

    var o = function () {
      function e() {}

      return e.createObject3D = function (e, t) {
        var n = e.type,
            o = i.getGeometryLODs(n),
            s = o.length > 1,
            c = s ? new a.CogniteLOD() : void 0,
            l = [];
        e.attributes.forEach(function (t) {
          l.push({
            attributeName: t.name,
            data: new r.THREE.InstancedBufferAttribute(t.array.subarray(0, e.data.count * t.itemSize), t.itemSize, !1, 1)
          });
        });

        for (var d = function d(i) {
          var d = o[i],
              u = new r.THREE.InstancedBufferGeometry();
          u.maxInstancedCount = e.data.count, Object.keys(d).forEach(function (e) {
            "index" === e ? u.setIndex(d.index) : u.addAttribute(e, d[e]);
          }), l.forEach(function (e) {
            var t = e.attributeName,
                n = e.data;
            u.addAttribute(t, n);
          });
          var f = new a.CognitePrimitiveMesh(u, t, e.data.arrays.size);
          f.frustumCulled = !1;

          var h = function (e) {
            for (var t = new r.THREE.Matrix4(), n = new r.THREE.Box3(), i = new r.THREE.Box3(), a = [], o = 0; o < e.data.count; o++) {
              e.computeBoundingBox(t, i, o), n.expandByPoint(i.min), n.expandByPoint(i.max), a.push(i.min.distanceTo(i.max));
            }

            return {
              boundingBox: n,
              objectSizes: a
            };
          }(e),
              p = h.boundingBox,
              v = h.objectSizes,
              g = new Float32Array(v),
              m = new r.THREE.InstancedBufferAttribute(g, 1, !1);

          u.addAttribute("objectSize", m);

          var _ = v.reduce(function (e, t) {
            return Math.max(e, t);
          });

          if (f.setBoundingBox(p), f.setBiggestObjectSize(_), !s) return f.cogniteType = n, {
            value: f
          };
          var x,
              y,
              b,
              w = (x = _, y = i, b = o.length, y >= b - 1 ? 0 : x * Math.pow(15, b - 1 - y));
          null != w && (f.visible = 0 === c.levels.length, f.cogniteType = n, c.addLevel(f, w));
        }, u = 0; u < o.length; u++) {
          var f = d(u);
          if ("object" == typeof f) return f.value;
        }

        return s ? (c.cogniteType = n, c) : new r.THREE.Object3D();
      }, e;
    }();

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t, n) {
        console.warn("_getNodeProxy should be used for debugging only. It may cause performance issues in applications."), this._nodeId = e, this._treeIndex = t, this._geometries = n;
      }

      return Object.defineProperty(e.prototype, "nodeId", {
        get: function get() {
          return this._nodeId;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "treeIndex", {
        get: function get() {
          return this._treeIndex;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "geometries", {
        get: function get() {
          return this._geometries;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.default = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t, n) {
        this._title = e, this._max = t, this._onProgress = n, this._progress = 0, this._triggerUpdate();
      }

      return e.prototype.setProgress = function (e) {
        this._progress = e, this._triggerUpdate();
      }, e.prototype.increaseProgress = function (e) {
        void 0 === e && (e = 1), this.setProgress(this._progress + e);
      }, e.prototype.setMax = function (e) {
        this._max = e, this._triggerUpdate();
      }, e.prototype._triggerUpdate = function () {
        this._onProgress({
          title: this._title,
          progress: this._progress,
          max: this._max
        });
      }, e;
    }();

    t.ProgressStep = r;

    var i = function () {
      function e(e, t, n) {
        this._numSteps = e, this._nextStepId = 1, this._onProgress = t, this._onComplete = n;
      }

      return e.prototype.addNewStep = function (e, t) {
        var n = this;
        void 0 === t && (t = 1);
        var i = this._onProgress,
            a = this._nextStepId++;
        if (a > this._numSteps) throw new Error("Number of actual steps exceeded numSteps");
        return new r(e, t, function (t) {
          i({
            step: a,
            numSteps: n._numSteps,
            title: e,
            progress: t.progress,
            max: t.max
          }), a === n._numSteps && t.progress === t.max && n._onComplete();
        });
      }, e;
    }();

    t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      for (var t = [], n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }

      for (var r = e[0], i = 0; i < t.length; i++) {
        r += encodeURIComponent(t[i].toString()) + e[i + 1];
      }

      return r;
    };
  }, function (e, t) {
    e.exports = "uniform float aspectRatio;\nuniform vec4 rotation;\nuniform vec4 offset;\n\nvarying vec3 v_normal;\n\nvec3 rotateVectorByQuaternion(vec3 pos, vec4 quat)\n{\n  // obatined from https://gamedev.stackexchange.com/a/50545\n\n  // Extract the vector part of the quaternion\n  vec3 u = vec3(quat.x, quat.y, quat.z);\n\n  // Extract the scalar part of the quaternion\n  float s = quat.w;\n\n  // Do the math\n  return (2.0 * dot(u, pos) * u\n        + (s*s - dot(u, u)) * pos\n        + 2.0 * s * cross(u, pos));\n}\n\nvoid main() {\n  v_normal = normal;\n\n  vec4 pos = vec4(rotateVectorByQuaternion(position, rotation), 1.0);\n  pos.y *= aspectRatio;\n\n  gl_Position = pos + offset;\n}\n";
  }, function (e, t) {
    e.exports = "varying vec3 v_normal;\n\nvoid main() {\n    if (abs(v_normal.x) > 0.05) \n    {\n      gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n    }\n    else if (abs(v_normal.y) > 0.05)\n    {\n      gl_FragColor = vec4(0.0, 1.0, 0.0, 1.0);\n    }\n    else if (abs(v_normal.z) > 0.05)\n    {\n      gl_FragColor = vec4(0.0, 0.0, 1.0, 1.0);\n    }\n}\n";
  }, function (e, t) {
    e.exports = require("simple-statistics");
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(56),
        i = n.n(r),
        a = n(1),
        o = n.n(a),
        s = n(2),
        c = n.n(s),
        l = n(3),
        d = n.n(l),
        u = n(4),
        f = n.n(u),
        h = n(0),
        p = n(7),
        v = n.n(p),
        g = g || {},
        m = g;
    g.OutWindow = function () {
      this._windowSize = 0;
    }, g.OutWindow.prototype.create = function (e) {
      this._buffer && this._windowSize === e || (this._buffer = []), this._windowSize = e, this._pos = 0, this._streamPos = 0;
    }, g.OutWindow.prototype.flush = function () {
      var e = this._pos - this._streamPos;

      if (0 !== e) {
        for (; e--;) {
          this._stream.writeByte(this._buffer[this._streamPos++]);
        }

        this._pos >= this._windowSize && (this._pos = 0), this._streamPos = this._pos;
      }
    }, g.OutWindow.prototype.releaseStream = function () {
      this.flush(), this._stream = null;
    }, g.OutWindow.prototype.setStream = function (e) {
      this.releaseStream(), this._stream = e;
    }, g.OutWindow.prototype.init = function (e) {
      e || (this._streamPos = 0, this._pos = 0);
    }, g.OutWindow.prototype.copyBlock = function (e, t) {
      var n = this._pos - e - 1;

      for (n < 0 && (n += this._windowSize); t--;) {
        n >= this._windowSize && (n = 0), this._buffer[this._pos++] = this._buffer[n++], this._pos >= this._windowSize && this.flush();
      }
    }, g.OutWindow.prototype.putByte = function (e) {
      this._buffer[this._pos++] = e, this._pos >= this._windowSize && this.flush();
    }, g.OutWindow.prototype.getByte = function (e) {
      var t = this._pos - e - 1;
      return t < 0 && (t += this._windowSize), this._buffer[t];
    }, g.RangeDecoder = function () {}, g.RangeDecoder.prototype.setStream = function (e) {
      this._stream = e;
    }, g.RangeDecoder.prototype.releaseStream = function () {
      this._stream = null;
    }, g.RangeDecoder.prototype.init = function () {
      var e = 5;

      for (this._code = 0, this._range = -1; e--;) {
        this._code = this._code << 8 | this._stream.readByte();
      }
    }, g.RangeDecoder.prototype.decodeDirectBits = function (e) {
      for (var t, n = 0, r = e; r--;) {
        this._range >>>= 1, t = this._code - this._range >>> 31, this._code -= this._range & t - 1, n = n << 1 | 1 - t, 0 == (4278190080 & this._range) && (this._code = this._code << 8 | this._stream.readByte(), this._range <<= 8);
      }

      return n;
    }, g.RangeDecoder.prototype.decodeBit = function (e, t) {
      var n = e[t],
          r = (this._range >>> 11) * n;
      return (2147483648 ^ this._code) < (2147483648 ^ r) ? (this._range = r, e[t] += 2048 - n >>> 5, 0 == (4278190080 & this._range) && (this._code = this._code << 8 | this._stream.readByte(), this._range <<= 8), 0) : (this._range -= r, this._code -= r, e[t] -= n >>> 5, 0 == (4278190080 & this._range) && (this._code = this._code << 8 | this._stream.readByte(), this._range <<= 8), 1);
    }, g.initBitModels = function (e, t) {
      for (; t--;) {
        e[t] = 1024;
      }
    }, g.BitTreeDecoder = function (e) {
      this._models = [], this._numBitLevels = e;
    }, g.BitTreeDecoder.prototype.init = function () {
      g.initBitModels(this._models, 1 << this._numBitLevels);
    }, g.BitTreeDecoder.prototype.decode = function (e) {
      for (var t = 1, n = this._numBitLevels; n--;) {
        t = t << 1 | e.decodeBit(this._models, t);
      }

      return t - (1 << this._numBitLevels);
    }, g.BitTreeDecoder.prototype.reverseDecode = function (e) {
      for (var t, n = 1, r = 0, i = 0; i < this._numBitLevels; ++i) {
        n = n << 1 | (t = e.decodeBit(this._models, n)), r |= t << i;
      }

      return r;
    }, g.reverseDecode2 = function (e, t, n, r) {
      for (var i, a = 1, o = 0, s = 0; s < r; ++s) {
        a = a << 1 | (i = n.decodeBit(e, t + a)), o |= i << s;
      }

      return o;
    }, g.LenDecoder = function () {
      this._choice = [], this._lowCoder = [], this._midCoder = [], this._highCoder = new g.BitTreeDecoder(8), this._numPosStates = 0;
    }, g.LenDecoder.prototype.create = function (e) {
      for (; this._numPosStates < e; ++this._numPosStates) {
        this._lowCoder[this._numPosStates] = new g.BitTreeDecoder(3), this._midCoder[this._numPosStates] = new g.BitTreeDecoder(3);
      }
    }, g.LenDecoder.prototype.init = function () {
      var e = this._numPosStates;

      for (g.initBitModels(this._choice, 2); e--;) {
        this._lowCoder[e].init(), this._midCoder[e].init();
      }

      this._highCoder.init();
    }, g.LenDecoder.prototype.decode = function (e, t) {
      return 0 === e.decodeBit(this._choice, 0) ? this._lowCoder[t].decode(e) : 0 === e.decodeBit(this._choice, 1) ? 8 + this._midCoder[t].decode(e) : 16 + this._highCoder.decode(e);
    }, g.Decoder2 = function () {
      this._decoders = [];
    }, g.Decoder2.prototype.init = function () {
      g.initBitModels(this._decoders, 768);
    }, g.Decoder2.prototype.decodeNormal = function (e) {
      var t = 1;

      do {
        t = t << 1 | e.decodeBit(this._decoders, t);
      } while (t < 256);

      return 255 & t;
    }, g.Decoder2.prototype.decodeWithMatchByte = function (e, t) {
      var n,
          r,
          i = 1;

      do {
        if (n = t >> 7 & 1, t <<= 1, i = i << 1 | (r = e.decodeBit(this._decoders, (1 + n << 8) + i)), n !== r) {
          for (; i < 256;) {
            i = i << 1 | e.decodeBit(this._decoders, i);
          }

          break;
        }
      } while (i < 256);

      return 255 & i;
    }, g.LiteralDecoder = function () {}, g.LiteralDecoder.prototype.create = function (e, t) {
      var n;
      if (!this._coders || this._numPrevBits !== t || this._numPosBits !== e) for (this._numPosBits = e, this._posMask = (1 << e) - 1, this._numPrevBits = t, this._coders = [], n = 1 << this._numPrevBits + this._numPosBits; n--;) {
        this._coders[n] = new g.Decoder2();
      }
    }, g.LiteralDecoder.prototype.init = function () {
      for (var e = 1 << this._numPrevBits + this._numPosBits; e--;) {
        this._coders[e].init();
      }
    }, g.LiteralDecoder.prototype.getDecoder = function (e, t) {
      return this._coders[((e & this._posMask) << this._numPrevBits) + ((255 & t) >>> 8 - this._numPrevBits)];
    }, g.Decoder = function () {
      this._outWindow = new g.OutWindow(), this._rangeDecoder = new g.RangeDecoder(), this._isMatchDecoders = [], this._isRepDecoders = [], this._isRepG0Decoders = [], this._isRepG1Decoders = [], this._isRepG2Decoders = [], this._isRep0LongDecoders = [], this._posSlotDecoder = [], this._posDecoders = [], this._posAlignDecoder = new g.BitTreeDecoder(4), this._lenDecoder = new g.LenDecoder(), this._repLenDecoder = new g.LenDecoder(), this._literalDecoder = new g.LiteralDecoder(), this._dictionarySize = -1, this._dictionarySizeCheck = -1, this._posSlotDecoder[0] = new g.BitTreeDecoder(6), this._posSlotDecoder[1] = new g.BitTreeDecoder(6), this._posSlotDecoder[2] = new g.BitTreeDecoder(6), this._posSlotDecoder[3] = new g.BitTreeDecoder(6);
    }, g.Decoder.prototype.setDictionarySize = function (e) {
      return !(e < 0) && (this._dictionarySize !== e && (this._dictionarySize = e, this._dictionarySizeCheck = Math.max(this._dictionarySize, 1), this._outWindow.create(Math.max(this._dictionarySizeCheck, 4096))), !0);
    }, g.Decoder.prototype.setLcLpPb = function (e, t, n) {
      var r = 1 << n;
      return !(e > 8 || t > 4 || n > 4) && (this._literalDecoder.create(t, e), this._lenDecoder.create(r), this._repLenDecoder.create(r), this._posStateMask = r - 1, !0);
    }, g.Decoder.prototype.init = function () {
      var e = 4;

      for (this._outWindow.init(!1), g.initBitModels(this._isMatchDecoders, 192), g.initBitModels(this._isRep0LongDecoders, 192), g.initBitModels(this._isRepDecoders, 12), g.initBitModels(this._isRepG0Decoders, 12), g.initBitModels(this._isRepG1Decoders, 12), g.initBitModels(this._isRepG2Decoders, 12), g.initBitModels(this._posDecoders, 114), this._literalDecoder.init(); e--;) {
        this._posSlotDecoder[e].init();
      }

      this._lenDecoder.init(), this._repLenDecoder.init(), this._posAlignDecoder.init(), this._rangeDecoder.init();
    }, g.Decoder.prototype.decode = function (e, t, n) {
      var r,
          i,
          a,
          o,
          s,
          c,
          l = 0,
          d = 0,
          u = 0,
          f = 0,
          h = 0,
          p = 0,
          v = 0;

      for (this._rangeDecoder.setStream(e), this._outWindow.setStream(t), this.init(); n < 0 || p < n;) {
        if (r = p & this._posStateMask, 0 === this._rangeDecoder.decodeBit(this._isMatchDecoders, (l << 4) + r)) i = this._literalDecoder.getDecoder(p++, v), v = l >= 7 ? i.decodeWithMatchByte(this._rangeDecoder, this._outWindow.getByte(d)) : i.decodeNormal(this._rangeDecoder), this._outWindow.putByte(v), l = l < 4 ? 0 : l - (l < 10 ? 3 : 6);else {
          if (1 === this._rangeDecoder.decodeBit(this._isRepDecoders, l)) a = 0, 0 === this._rangeDecoder.decodeBit(this._isRepG0Decoders, l) ? 0 === this._rangeDecoder.decodeBit(this._isRep0LongDecoders, (l << 4) + r) && (l = l < 7 ? 9 : 11, a = 1) : (0 === this._rangeDecoder.decodeBit(this._isRepG1Decoders, l) ? o = u : (0 === this._rangeDecoder.decodeBit(this._isRepG2Decoders, l) ? o = f : (o = h, h = f), f = u), u = d, d = o), 0 === a && (a = 2 + this._repLenDecoder.decode(this._rangeDecoder, r), l = l < 7 ? 8 : 11);else if (h = f, f = u, u = d, a = 2 + this._lenDecoder.decode(this._rangeDecoder, r), l = l < 7 ? 7 : 10, (s = this._posSlotDecoder[a <= 5 ? a - 2 : 3].decode(this._rangeDecoder)) >= 4) {
            if (d = (2 | 1 & s) << (c = (s >> 1) - 1), s < 14) d += g.reverseDecode2(this._posDecoders, d - s - 1, this._rangeDecoder, c);else if (d += this._rangeDecoder.decodeDirectBits(c - 4) << 4, (d += this._posAlignDecoder.reverseDecode(this._rangeDecoder)) < 0) {
              if (-1 === d) break;
              return !1;
            }
          } else d = s;
          if (d >= p || d >= this._dictionarySizeCheck) return !1;
          this._outWindow.copyBlock(d, a), p += a, v = this._outWindow.getByte(0);
        }
      }

      return this._outWindow.flush(), this._outWindow.releaseStream(), this._rangeDecoder.releaseStream(), !0;
    }, g.Decoder.prototype.setDecoderProperties = function (e) {
      var t, n, r, i, a;
      return !(e.size < 5) && (n = (t = e.readByte()) % 9, r = (t = ~~(t / 9)) % 5, i = ~~(t / 5), !!this.setLcLpPb(n, r, i) && (a = e.readByte(), a |= e.readByte() << 8, a |= e.readByte() << 16, a += 16777216 * e.readByte(), this.setDictionarySize(a)));
    }, g.decompress = function (e, t, n, r) {
      var i = new g.Decoder();
      if (!i.setDecoderProperties(e)) throw "Incorrect stream properties";
      if (!i.decode(t, n, r)) throw "Error in data stream";
      return !0;
    };

    var _,
        x,
        y,
        b = b || {},
        w = b;

    function E(e) {
      var t = new h.THREE.BufferGeometry();
      t.materials = [];
      var n = e.body,
          r = n.indices,
          i = n.vertices;
      return t.setIndex(new h.THREE.BufferAttribute(r, 1)), t.addAttribute("position", new h.THREE.BufferAttribute(i, 3)), t;
    }

    function M(e) {
      var t = e.type,
          n = e.data;

      switch (t) {
        case "ctm":
          var r = function (e) {
            var t = new Uint8Array(e),
                n = new w.Stream(t);
            return new w.File(n);
          }(n),
              i = r.body,
              a = i.indices,
              o = i.vertices,
              s = [a.buffer];

          return o.buffer !== a.buffer && s.push(o.buffer), {
            result: r,
            transferables: s
          };

        default:
          throw new Error("Unknown mesh type: ".concat(t));
      }
    }

    b.CompressionMethod = {
      RAW: 5718354,
      MG1: 3229517,
      MG2: 3295053
    }, b.Flags = {
      NORMALS: 1
    }, b.File = function (e) {
      this.load(e);
    }, b.File.prototype.load = function (e) {
      this.header = new b.FileHeader(e), this.body = new b.FileBody(this.header), this.getReader().read(e, this.body);
    }, b.File.prototype.getReader = function () {
      var e;

      switch (this.header.compressionMethod) {
        case b.CompressionMethod.RAW:
          e = new b.ReaderRAW();
          break;

        case b.CompressionMethod.MG1:
          e = new b.ReaderMG1();
          break;

        case b.CompressionMethod.MG2:
          e = new b.ReaderMG2();
      }

      return e;
    }, b.FileHeader = function (e) {
      e.readInt32(), this.fileFormat = e.readInt32(), this.compressionMethod = e.readInt32(), this.vertexCount = e.readInt32(), this.triangleCount = e.readInt32(), this.uvMapCount = e.readInt32(), this.attrMapCount = e.readInt32(), this.flags = e.readInt32(), this.comment = e.readString();
    }, b.FileHeader.prototype.hasNormals = function () {
      return this.flags & b.Flags.NORMALS;
    }, b.FileBody = function (e) {
      var t = 3 * e.triangleCount,
          n = 3 * e.vertexCount,
          r = e.hasNormals() ? 3 * e.vertexCount : 0,
          i = 2 * e.vertexCount,
          a = 4 * e.vertexCount,
          o = 0,
          s = new ArrayBuffer(4 * (t + n + r + i * e.uvMapCount + a * e.attrMapCount));
      if (this.indices = new Uint32Array(s, 0, t), this.vertices = new Float32Array(s, 4 * t, n), e.hasNormals() && (this.normals = new Float32Array(s, 4 * (t + n), r)), e.uvMapCount) for (this.uvMaps = [], o = 0; o < e.uvMapCount; ++o) {
        this.uvMaps[o] = {
          uv: new Float32Array(s, 4 * (t + n + r + o * i), i)
        };
      }
      if (e.attrMapCount) for (this.attrMaps = [], o = 0; o < e.attrMapCount; ++o) {
        this.attrMaps[o] = {
          attr: new Float32Array(s, 4 * (t + n + r + i * e.uvMapCount + o * a), a)
        };
      }
    }, b.FileMG2Header = function (e) {
      e.readInt32(), this.vertexPrecision = e.readFloat32(), this.normalPrecision = e.readFloat32(), this.lowerBoundx = e.readFloat32(), this.lowerBoundy = e.readFloat32(), this.lowerBoundz = e.readFloat32(), this.higherBoundx = e.readFloat32(), this.higherBoundy = e.readFloat32(), this.higherBoundz = e.readFloat32(), this.divx = e.readInt32(), this.divy = e.readInt32(), this.divz = e.readInt32(), this.sizex = (this.higherBoundx - this.lowerBoundx) / this.divx, this.sizey = (this.higherBoundy - this.lowerBoundy) / this.divy, this.sizez = (this.higherBoundz - this.lowerBoundz) / this.divz;
    }, b.ReaderRAW = function () {}, b.ReaderRAW.prototype.read = function (e, t) {
      this.readIndices(e, t.indices), this.readVertices(e, t.vertices), t.normals && this.readNormals(e, t.normals), t.uvMaps && this.readUVMaps(e, t.uvMaps), t.attrMaps && this.readAttrMaps(e, t.attrMaps);
    }, b.ReaderRAW.prototype.readIndices = function (e, t) {
      e.readInt32(), e.readArrayInt32(t);
    }, b.ReaderRAW.prototype.readVertices = function (e, t) {
      e.readInt32(), e.readArrayFloat32(t);
    }, b.ReaderRAW.prototype.readNormals = function (e, t) {
      e.readInt32(), e.readArrayFloat32(t);
    }, b.ReaderRAW.prototype.readUVMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString(), t[n].filename = e.readString(), e.readArrayFloat32(t[n].uv);
      }
    }, b.ReaderRAW.prototype.readAttrMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString(), e.readArrayFloat32(t[n].attr);
      }
    }, b.ReaderMG1 = function () {}, b.ReaderMG1.prototype.read = function (e, t) {
      this.readIndices(e, t.indices), this.readVertices(e, t.vertices), t.normals && this.readNormals(e, t.normals), t.uvMaps && this.readUVMaps(e, t.uvMaps), t.attrMaps && this.readAttrMaps(e, t.attrMaps);
    }, b.ReaderMG1.prototype.readIndices = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t, 3);
      m.decompress(e, e, n, n.data.length), b.restoreIndices(t, t.length);
    }, b.ReaderMG1.prototype.readVertices = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t, 1);
      m.decompress(e, e, n, n.data.length);
    }, b.ReaderMG1.prototype.readNormals = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t, 3);
      m.decompress(e, e, n, n.data.length);
    }, b.ReaderMG1.prototype.readUVMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString(), t[n].filename = e.readString(), e.readInt32();
        var r = new b.InterleavedStream(t[n].uv, 2);
        m.decompress(e, e, r, r.data.length);
      }
    }, b.ReaderMG1.prototype.readAttrMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString(), e.readInt32();
        var r = new b.InterleavedStream(t[n].attr, 4);
        m.decompress(e, e, r, r.data.length);
      }
    }, b.ReaderMG2 = function () {}, b.ReaderMG2.prototype.read = function (e, t) {
      this.MG2Header = new b.FileMG2Header(e), this.readVertices(e, t.vertices), this.readIndices(e, t.indices), t.normals && this.readNormals(e, t), t.uvMaps && this.readUVMaps(e, t.uvMaps), t.attrMaps && this.readAttrMaps(e, t.attrMaps);
    }, b.ReaderMG2.prototype.readVertices = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t, 3);
      m.decompress(e, e, n, n.data.length);
      var r = this.readGridIndices(e, t);
      b.restoreVertices(t, this.MG2Header, r, this.MG2Header.vertexPrecision);
    }, b.ReaderMG2.prototype.readGridIndices = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new Uint32Array(t.length / 3),
          r = new b.InterleavedStream(n, 1);
      return m.decompress(e, e, r, r.data.length), b.restoreGridIndices(n, n.length), n;
    }, b.ReaderMG2.prototype.readIndices = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t, 3);
      m.decompress(e, e, n, n.data.length), b.restoreIndices(t, t.length);
    }, b.ReaderMG2.prototype.readNormals = function (e, t) {
      e.readInt32(), e.readInt32();
      var n = new b.InterleavedStream(t.normals, 3);
      m.decompress(e, e, n, n.data.length);
      var r = b.calcSmoothNormals(t.indices, t.vertices);
      b.restoreNormals(t.normals, r, this.MG2Header.normalPrecision);
    }, b.ReaderMG2.prototype.readUVMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString(), t[n].filename = e.readString();
        var r = e.readFloat32();
        e.readInt32();
        var i = new b.InterleavedStream(t[n].uv, 2);
        m.decompress(e, e, i, i.data.length), b.restoreMap(t[n].uv, 2, r);
      }
    }, b.ReaderMG2.prototype.readAttrMaps = function (e, t) {
      for (var n = 0; n < t.length; ++n) {
        e.readInt32(), t[n].name = e.readString();
        var r = e.readFloat32();
        e.readInt32();
        var i = new b.InterleavedStream(t[n].attr, 4);
        m.decompress(e, e, i, i.data.length), b.restoreMap(t[n].attr, 4, r);
      }
    }, b.restoreIndices = function (e, t) {
      var n = 3;

      for (t > 0 && (e[2] += e[0], e[1] += e[0]); n < t; n += 3) {
        e[n] += e[n - 3], e[n] === e[n - 3] ? e[n + 1] += e[n - 2] : e[n + 1] += e[n], e[n + 2] += e[n];
      }
    }, b.restoreGridIndices = function (e, t) {
      for (var n = 1; n < t; ++n) {
        e[n] += e[n - 1];
      }
    }, b.restoreVertices = function (e, t, n, r) {
      for (var i, a, o, s, c, l = new Uint32Array(e.buffer, e.byteOffset, e.length), d = t.divx, u = d * t.divy, f = 2147483647, h = 0, p = 0, v = 0, g = n.length; p < g; v += 3) {
        o = i = n[p++], o -= ~~((c = ~~(o / u)) * u), o -= ~~((s = ~~(o / d)) * d), a = l[v], i === f && (a += h), e[v] = t.lowerBoundx + o * t.sizex + r * a, e[v + 1] = t.lowerBoundy + s * t.sizey + r * l[v + 1], e[v + 2] = t.lowerBoundz + c * t.sizez + r * l[v + 2], f = i, h = a;
      }
    }, b.restoreNormals = function (e, t, n) {
      for (var r, i, a, o, s, c, l, d, u, f, h = new Uint32Array(e.buffer, e.byteOffset, e.length), p = 0, v = e.length, g = 1.5707963267948966; p < v; p += 3) {
        r = h[p] * n, 0 === (i = h[p + 1]) ? (e[p] = t[p] * r, e[p + 1] = t[p + 1] * r, e[p + 2] = t[p + 2] * r) : (a = i <= 4 ? (h[p + 2] - 2) * g : (4 * h[p + 2] / i - 2) * g, i *= n * g, s = (o = r * Math.sin(i)) * Math.cos(a), c = o * Math.sin(a), l = r * Math.cos(i), u = t[p + 1], d = t[p] - t[p + 2], (f = Math.sqrt(2 * u * u + d * d)) > 1e-20 && (d /= f, u /= f), e[p] = t[p] * l + (t[p + 1] * u - t[p + 2] * d) * c - u * s, e[p + 1] = t[p + 1] * l - (t[p + 2] + t[p]) * u * c + d * s, e[p + 2] = t[p + 2] * l + (t[p] * d + t[p + 1] * u) * c + u * s);
      }
    }, b.restoreMap = function (e, t, n) {
      for (var r, i, a, o = new Uint32Array(e.buffer, e.byteOffset, e.length), s = 0, c = e.length; s < t; ++s) {
        for (r = 0, a = s; a < c; a += t) {
          r += 1 & (i = o[a]) ? -(i + 1 >> 1) : i >> 1, e[a] = r * n;
        }
      }
    }, b.calcSmoothNormals = function (e, t) {
      var n,
          r,
          i,
          a,
          o,
          s,
          c,
          l,
          d,
          u,
          f,
          h,
          p,
          v,
          g,
          m = new Float32Array(t.length);

      for (v = 0, g = e.length; v < g;) {
        n = 3 * e[v++], r = 3 * e[v++], i = 3 * e[v++], c = t[r] - t[n], u = t[i] - t[n], l = t[r + 1] - t[n + 1], f = t[i + 1] - t[n + 1], d = t[r + 2] - t[n + 2], a = l * (h = t[i + 2] - t[n + 2]) - d * f, o = d * u - c * h, s = c * f - l * u, (p = Math.sqrt(a * a + o * o + s * s)) > 1e-10 && (a /= p, o /= p, s /= p), m[n] += a, m[n + 1] += o, m[n + 2] += s, m[r] += a, m[r + 1] += o, m[r + 2] += s, m[i] += a, m[i + 1] += o, m[i + 2] += s;
      }

      for (v = 0, g = m.length; v < g; v += 3) {
        (p = Math.sqrt(m[v] * m[v] + m[v + 1] * m[v + 1] + m[v + 2] * m[v + 2])) > 1e-10 && (m[v] /= p, m[v + 1] /= p, m[v + 2] /= p);
      }

      return m;
    }, b.isLittleEndian = (_ = new ArrayBuffer(2), x = new Uint8Array(_), y = new Uint16Array(_), x[0] = 1, 1 === y[0]), b.InterleavedStream = function (e, t) {
      this.data = new Uint8Array(e.buffer, e.byteOffset, e.byteLength), this.offset = b.isLittleEndian ? 3 : 0, this.count = 4 * t, this.len = this.data.length;
    }, b.InterleavedStream.prototype.writeByte = function (e) {
      this.data[this.offset] = e, this.offset += this.count, this.offset >= this.len && (this.offset -= this.len - 4, this.offset >= this.count && (this.offset -= this.count + (b.isLittleEndian ? 1 : -1)));
    }, b.Stream = function (e) {
      this.data = e, this.offset = 0;
    }, b.Stream.prototype.TWO_POW_MINUS23 = Math.pow(2, -23), b.Stream.prototype.TWO_POW_MINUS126 = Math.pow(2, -126), b.Stream.prototype.readByte = function () {
      return 255 & this.data[this.offset++];
    }, b.Stream.prototype.readInt32 = function () {
      var e = this.readByte();
      return e |= this.readByte() << 8, (e |= this.readByte() << 16) | this.readByte() << 24;
    }, b.Stream.prototype.readFloat32 = function () {
      var e = this.readByte();
      e += this.readByte() << 8;
      var t = this.readByte(),
          n = this.readByte();
      e += (127 & t) << 16;
      var r = (127 & n) << 1 | (128 & t) >>> 7,
          i = 128 & n ? -1 : 1;
      return 255 === r ? 0 !== e ? NaN : i * (1 / 0) : r > 0 ? i * (1 + e * this.TWO_POW_MINUS23) * Math.pow(2, r - 127) : 0 !== e ? i * e * this.TWO_POW_MINUS126 : 0 * i;
    }, b.Stream.prototype.readString = function () {
      var e = this.readInt32();
      return this.offset += e, String.fromCharCode.apply(null, this.data.subarray(this.offset - e, this.offset));
    }, b.Stream.prototype.readArrayInt32 = function (e) {
      for (var t = 0, n = e.length; t < n;) {
        e[t++] = this.readInt32();
      }

      return e;
    }, b.Stream.prototype.readArrayFloat32 = function (e) {
      for (var t = 0, n = e.length; t < n;) {
        e[t++] = this.readFloat32();
      }

      return e;
    }, n.d(t, "default", function () {
      return S;
    });

    var S = function () {
      function e(t, n, r) {
        d()(this, e), this.localPath = n, this.cache = {}, this.currentNumberOfFetchRequests = 0, this.cacheDb = r, this._sdk = t;
      }

      return f()(e, [{
        key: "dispose",
        value: function value() {
          for (var e = Object.values(this.cache), t = 0; t < e.length; t++) {
            e[t].then(function (e) {
              return e.dispose();
            });
          }

          this.cache = {};
        }
      }, {
        key: "getGeometry",
        value: function value(e) {
          return null == this.cache[e] && (this.cache[e] = this.loadGeometry(e)), this.cache[e];
        }
      }, {
        key: "loadGeometry",
        value: function () {
          var e = c()(o.a.mark(function e(t) {
            var n, r, i;
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.cacheDb.get("ctm", t);

                  case 2:
                    if (n = e.sent) {
                      e.next = 19;
                      break;
                    }

                    if (null == this.localPath) {
                      e.next = 10;
                      break;
                    }

                    return e.next = 7, this.loadLocalGeometry(t);

                  case 7:
                    i = e.sent, e.next = 13;
                    break;

                  case 10:
                    return e.next = 12, this._sdk.files3D.retrieve(t);

                  case 12:
                    i = e.sent;

                  case 13:
                    return e.next = 15, this.parseMeshData(i);

                  case 15:
                    r = e.sent, this.cacheDb.put("ctm", {
                      fileId: t,
                      data: r
                    }), e.next = 20;
                    break;

                  case 19:
                    r = n.data;

                  case 20:
                    return e.abrupt("return", E(r));

                  case 21:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "getLocalArrayBuffer",
        value: function () {
          var e = c()(o.a.mark(function e(t) {
            var n;
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!(this.currentNumberOfFetchRequests > 20)) {
                      e.next = 5;
                      break;
                    }

                    return e.next = 3, v()(100 * Math.random());

                  case 3:
                    e.next = 0;
                    break;

                  case 5:
                    return this.currentNumberOfFetchRequests += 1, e.next = 8, fetch("".concat(this.localPath).concat(t), this.init);

                  case 8:
                    if (n = e.sent, this.currentNumberOfFetchRequests -= 1, n.ok) {
                      e.next = 12;
                      break;
                    }

                    throw new Error("Request failed");

                  case 12:
                    return e.abrupt("return", n.arrayBuffer());

                  case 13:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "loadLocalGeometry",
        value: function () {
          var e = c()(o.a.mark(function e(t) {
            var n, r, i;
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.getLocalFileMap();

                  case 2:
                    return n = e.sent, null == (r = null != n ? n[t] : null) && (r = "".concat(t, ".ctm")), e.next = 7, this.getLocalArrayBuffer("/".concat(r));

                  case 7:
                    return i = e.sent, e.abrupt("return", i);

                  case 9:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "loadLocalFileMap",
        value: function () {
          var e = c()(o.a.mark(function e() {
            var t, n, r, a;
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (null != this.localPath) {
                      e.next = 2;
                      break;
                    }

                    return e.abrupt("return", null);

                  case 2:
                    return e.next = 4, fetch("".concat(this.localPath, "/uploaded_files.txt"), this.init);

                  case 4:
                    if ((t = e.sent).ok) {
                      e.next = 7;
                      break;
                    }

                    return e.abrupt("return", null);

                  case 7:
                    return e.next = 9, t.text();

                  case 9:
                    return n = e.sent, r = n.split("\n").filter(function (e) {
                      return e.length > 0;
                    }), a = Object.create(null), r.forEach(function (e) {
                      var t = e.split("\t"),
                          n = i()(t, 2),
                          r = n[0],
                          o = n[1];
                      a[r] = o;
                    }), e.abrupt("return", a);

                  case 14:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "getLocalFileMap",
        value: function () {
          var e = c()(o.a.mark(function e() {
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return null != this.localPath && void 0 === this.localFileMap && (this.localFileMap = this.loadLocalFileMap()), e.abrupt("return", this.localFileMap);

                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "parseMeshData",
        value: function () {
          var e = c()(o.a.mark(function e(t) {
            var n;
            return o.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return "ctm", n = M({
                      type: "ctm",
                      data: t
                    }), e.abrupt("return", n.result);

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }]), e;
    }();
  },,,,, function (e, t, n) {
    e.exports = n(62);
  }]);
});